/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: Show regions on a map, with lines overlayed according to ping times.
// TODO: Add an option to contribute times and JS geolocation info to a public BigQuery dataset.
/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $d29cc2d0f1026d01$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$d29cc2d0f1026d01$export$2e2bcd8739ae039 = $d29cc2d0f1026d01$export$a81b11d69c993162;


var $0a13a1859770d71d$export$c3670872e5a4af8e = /** @class */ function() {
    function MDCComponent(root, foundation) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        this.root = root;
        this.initialize.apply(this, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
        // Note that we initialize foundation here and not within the constructor's
        // default param so that this.root is defined and can be used within the
        // foundation class.
        this.foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
        this.foundation.init();
        this.initialSyncWithDOM();
    }
    MDCComponent.attachTo = function(root) {
        // Subclasses which extend MDCBase should provide an attachTo() method that takes a root element and
        // returns an instantiated component with its root set to that element. Also note that in the cases of
        // subclasses, an explicit foundation class will not have to be passed in; it will simply be initialized
        // from getDefaultFoundation().
        return new MDCComponent(root, new (0, $d29cc2d0f1026d01$export$a81b11d69c993162)({}));
    };
    /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */ MDCComponent.prototype.initialize = function() {
        var _args = [];
        for(var _i = 0; _i < arguments.length; _i++)_args[_i] = arguments[_i];
    // Subclasses can override this to do any additional setup work that would be considered part of a
    // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
    // initialized. Any additional arguments besides root and foundation will be passed in here.
    };
    MDCComponent.prototype.getDefaultFoundation = function() {
        // Subclasses must override this method to return a properly configured foundation class for the
        // component.
        throw new Error("Subclasses must override getDefaultFoundation to return a properly configured foundation class");
    };
    MDCComponent.prototype.initialSyncWithDOM = function() {
    // Subclasses should override this method if they need to perform work to synchronize with a host DOM
    // object. An example of this would be a form control wrapper that needs to synchronize its internal state
    // to some property or attribute of the host DOM. Please note: this is *not* the place to perform DOM
    // reads/writes that would cause layout / paint, as this is called synchronously from within the constructor.
    };
    MDCComponent.prototype.destroy = function() {
        // Subclasses may implement this method to release any resources / deregister any listeners they have
        // attached. An example of this might be deregistering a resize event from the window object.
        this.foundation.destroy();
    };
    MDCComponent.prototype.listen = function(evtType, handler, options) {
        this.root.addEventListener(evtType, handler, options);
    };
    MDCComponent.prototype.unlisten = function(evtType, handler, options) {
        this.root.removeEventListener(evtType, handler, options);
    };
    /**
     * Fires a cross-browser-compatible custom event from the component root of the given type, with the given data.
     */ MDCComponent.prototype.emit = function(evtType, evtData, shouldBubble) {
        if (shouldBubble === void 0) shouldBubble = false;
        var evt;
        if (typeof CustomEvent === 'function') evt = new CustomEvent(evtType, {
            bubbles: shouldBubble,
            detail: evtData
        });
        else {
            evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(evtType, shouldBubble, false, evtData);
        }
        this.root.dispatchEvent(evt);
    };
    return MDCComponent;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$0a13a1859770d71d$export$2e2bcd8739ae039 = $0a13a1859770d71d$export$c3670872e5a4af8e;


/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $eb9bb54a78ee410b$var$FOCUS_SENTINEL_CLASS = 'mdc-dom-focus-sentinel';
/**
 * Utility to trap focus in a given root element, e.g. for modal components such
 * as dialogs. The root should have at least one focusable child element,
 * for setting initial focus when trapping focus.
 * Also tracks the previously focused element, and restores focus to that
 * element when releasing focus.
 */ var $eb9bb54a78ee410b$export$34eba2437817a67b = /** @class */ function() {
    function FocusTrap(root, options) {
        if (options === void 0) options = {};
        this.root = root;
        this.options = options;
        // Previously focused element before trapping focus.
        this.elFocusedBeforeTrapFocus = null;
    }
    /**
     * Traps focus in `root`. Also focuses on either `initialFocusEl` if set;
     * otherwises sets initial focus to the first focusable child element.
     */ FocusTrap.prototype.trapFocus = function() {
        var focusableEls = this.getFocusableElements(this.root);
        if (focusableEls.length === 0) throw new Error('FocusTrap: Element must have at least one focusable child.');
        this.elFocusedBeforeTrapFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        this.wrapTabFocus(this.root);
        if (!this.options.skipInitialFocus) this.focusInitialElement(focusableEls, this.options.initialFocusEl);
    };
    /**
     * Releases focus from `root`. Also restores focus to the previously focused
     * element.
     */ FocusTrap.prototype.releaseFocus = function() {
        [].slice.call(this.root.querySelectorAll("." + $eb9bb54a78ee410b$var$FOCUS_SENTINEL_CLASS)).forEach(function(sentinelEl) {
            sentinelEl.parentElement.removeChild(sentinelEl);
        });
        if (!this.options.skipRestoreFocus && this.elFocusedBeforeTrapFocus) this.elFocusedBeforeTrapFocus.focus();
    };
    /**
     * Wraps tab focus within `el` by adding two hidden sentinel divs which are
     * used to mark the beginning and the end of the tabbable region. When
     * focused, these sentinel elements redirect focus to the first/last
     * children elements of the tabbable region, ensuring that focus is trapped
     * within that region.
     */ FocusTrap.prototype.wrapTabFocus = function(el) {
        var _this = this;
        var sentinelStart = this.createSentinel();
        var sentinelEnd = this.createSentinel();
        sentinelStart.addEventListener('focus', function() {
            var focusableEls = _this.getFocusableElements(el);
            if (focusableEls.length > 0) focusableEls[focusableEls.length - 1].focus();
        });
        sentinelEnd.addEventListener('focus', function() {
            var focusableEls = _this.getFocusableElements(el);
            if (focusableEls.length > 0) focusableEls[0].focus();
        });
        el.insertBefore(sentinelStart, el.children[0]);
        el.appendChild(sentinelEnd);
    };
    /**
     * Focuses on `initialFocusEl` if defined and a child of the root element.
     * Otherwise, focuses on the first focusable child element of the root.
     */ FocusTrap.prototype.focusInitialElement = function(focusableEls, initialFocusEl) {
        var focusIndex = 0;
        if (initialFocusEl) focusIndex = Math.max(focusableEls.indexOf(initialFocusEl), 0);
        focusableEls[focusIndex].focus();
    };
    FocusTrap.prototype.getFocusableElements = function(root) {
        var focusableEls = [].slice.call(root.querySelectorAll('[autofocus], [tabindex], a, input, textarea, select, button'));
        return focusableEls.filter(function(el) {
            var isDisabledOrHidden = el.getAttribute('aria-disabled') === 'true' || el.getAttribute('disabled') != null || el.getAttribute('hidden') != null || el.getAttribute('aria-hidden') === 'true';
            var isTabbableAndVisible = el.tabIndex >= 0 && el.getBoundingClientRect().width > 0 && !el.classList.contains($eb9bb54a78ee410b$var$FOCUS_SENTINEL_CLASS) && !isDisabledOrHidden;
            var isProgrammaticallyHidden = false;
            if (isTabbableAndVisible) {
                var style = getComputedStyle(el);
                isProgrammaticallyHidden = style.display === 'none' || style.visibility === 'hidden';
            }
            return isTabbableAndVisible && !isProgrammaticallyHidden;
        });
    };
    FocusTrap.prototype.createSentinel = function() {
        var sentinel = document.createElement('div');
        sentinel.setAttribute('tabindex', '0');
        // Don't announce in screen readers.
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.classList.add($eb9bb54a78ee410b$var$FOCUS_SENTINEL_CLASS);
        return sentinel;
    };
    return FocusTrap;
}();


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * @fileoverview A "ponyfill" is a polyfill that doesn't modify the global prototype chain.
 * This makes ponyfills safer than traditional polyfills, especially for libraries like MDC.
 */ function $f4789bcfa326043f$export$ff7f7c97cdce86e(element, selector) {
    if (element.closest) return element.closest(selector);
    var el = element;
    while(el){
        if ($f4789bcfa326043f$export$de994efd351b291c(el, selector)) return el;
        el = el.parentElement;
    }
    return null;
}
function $f4789bcfa326043f$export$de994efd351b291c(element, selector) {
    var nativeMatches = element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
    return nativeMatches.call(element, selector);
}
function $f4789bcfa326043f$export$30f5493effae393e(element) {
    // Check the offsetParent. If the element inherits display: none from any
    // parent, the offsetParent property will be null (see
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent).
    // This check ensures we only clone the node when necessary.
    var htmlEl = element;
    if (htmlEl.offsetParent !== null) return htmlEl.scrollWidth;
    var clone = htmlEl.cloneNode(true);
    clone.style.setProperty('position', 'absolute');
    clone.style.setProperty('transform', 'translate(-9999px, -9999px)');
    document.documentElement.appendChild(clone);
    var scrollWidth = clone.scrollWidth;
    document.documentElement.removeChild(clone);
    return scrollWidth;
}


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Determine whether the current browser supports passive event listeners, and
 * if so, use them.
 */ function $9d9aa0d3469cd217$export$82e1592afef3b60f(globalObj) {
    if (globalObj === void 0) globalObj = window;
    return $9d9aa0d3469cd217$var$supportsPassiveOption(globalObj) ? {
        passive: true
    } : false;
}
function $9d9aa0d3469cd217$var$supportsPassiveOption(globalObj) {
    if (globalObj === void 0) globalObj = window;
    // See
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
    var passiveSupported = false;
    try {
        var options = {
            // This function will be called when the browser
            // attempts to access the passive property.
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        var handler = function() {};
        globalObj.document.addEventListener('test', handler, options);
        globalObj.document.removeEventListener('test', handler, options);
    } catch (err) {
        passiveSupported = false;
    }
    return passiveSupported;
}



/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 

/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $fd0eb02544dd3322$export$c1c0562ec8379000 = {
    // Ripple is a special case where the "root" component is really a "mixin" of sorts,
    // given that it's an 'upgrade' to an existing component. That being said it is the root
    // CSS class that all other CSS classes derive from.
    BG_FOCUSED: 'mdc-ripple-upgraded--background-focused',
    FG_ACTIVATION: 'mdc-ripple-upgraded--foreground-activation',
    FG_DEACTIVATION: 'mdc-ripple-upgraded--foreground-deactivation',
    ROOT: 'mdc-ripple-upgraded',
    UNBOUNDED: 'mdc-ripple-upgraded--unbounded'
};
var $fd0eb02544dd3322$export$21c51bc433c16634 = {
    VAR_FG_SCALE: '--mdc-ripple-fg-scale',
    VAR_FG_SIZE: '--mdc-ripple-fg-size',
    VAR_FG_TRANSLATE_END: '--mdc-ripple-fg-translate-end',
    VAR_FG_TRANSLATE_START: '--mdc-ripple-fg-translate-start',
    VAR_LEFT: '--mdc-ripple-left',
    VAR_TOP: '--mdc-ripple-top'
};
var $fd0eb02544dd3322$export$1f6c9cc012ebacae = {
    DEACTIVATION_TIMEOUT_MS: 225,
    FG_DEACTIVATION_MS: 150,
    INITIAL_ORIGIN_SCALE: 0.6,
    PADDING: 10,
    TAP_DELAY_MS: 300
};


/**
 * Stores result from supportsCssVariables to avoid redundant processing to
 * detect CSS custom variable support.
 */ var $df4bc532ae9a9f80$var$supportsCssVariables_;
function $df4bc532ae9a9f80$export$599ecc0c8c1caa3e(windowObj, forceRefresh) {
    if (forceRefresh === void 0) forceRefresh = false;
    var CSS = windowObj.CSS;
    var supportsCssVars = $df4bc532ae9a9f80$var$supportsCssVariables_;
    if (typeof $df4bc532ae9a9f80$var$supportsCssVariables_ === 'boolean' && !forceRefresh) return $df4bc532ae9a9f80$var$supportsCssVariables_;
    var supportsFunctionPresent = CSS && typeof CSS.supports === 'function';
    if (!supportsFunctionPresent) return false;
    var explicitlySupportsCssVars = CSS.supports('--css-vars', 'yes');
    // See: https://bugs.webkit.org/show_bug.cgi?id=154669
    // See: README section on Safari
    var weAreFeatureDetectingSafari10plus = CSS.supports('(--css-vars: yes)') && CSS.supports('color', '#00000000');
    supportsCssVars = explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus;
    if (!forceRefresh) $df4bc532ae9a9f80$var$supportsCssVariables_ = supportsCssVars;
    return supportsCssVars;
}
function $df4bc532ae9a9f80$export$82f3563636a128ae(evt, pageOffset, clientRect) {
    if (!evt) return {
        x: 0,
        y: 0
    };
    var x = pageOffset.x, y = pageOffset.y;
    var documentX = x + clientRect.left;
    var documentY = y + clientRect.top;
    var normalizedX;
    var normalizedY;
    // Determine touch point relative to the ripple container.
    if (evt.type === 'touchstart') {
        var touchEvent = evt;
        normalizedX = touchEvent.changedTouches[0].pageX - documentX;
        normalizedY = touchEvent.changedTouches[0].pageY - documentY;
    } else {
        var mouseEvent = evt;
        normalizedX = mouseEvent.pageX - documentX;
        normalizedY = mouseEvent.pageY - documentY;
    }
    return {
        x: normalizedX,
        y: normalizedY
    };
}


// Activation events registered on the root element of each instance for activation
var $bf1cd0cda6c64034$var$ACTIVATION_EVENT_TYPES = [
    'touchstart',
    'pointerdown',
    'mousedown',
    'keydown'
];
// Deactivation events registered on documentElement when a pointer-related down event occurs
var $bf1cd0cda6c64034$var$POINTER_DEACTIVATION_EVENT_TYPES = [
    'touchend',
    'pointerup',
    'mouseup',
    'contextmenu'
];
// simultaneous nested activations
var $bf1cd0cda6c64034$var$activatedTargets = [];
var $bf1cd0cda6c64034$export$fb5f028029d92ef5 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCRippleFoundation, _super);
    function MDCRippleFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCRippleFoundation.defaultAdapter), adapter)) || this;
        _this.activationAnimationHasEnded = false;
        _this.activationTimer = 0;
        _this.fgDeactivationRemovalTimer = 0;
        _this.fgScale = '0';
        _this.frame = {
            width: 0,
            height: 0
        };
        _this.initialSize = 0;
        _this.layoutFrame = 0;
        _this.maxRadius = 0;
        _this.unboundedCoords = {
            left: 0,
            top: 0
        };
        _this.activationState = _this.defaultActivationState();
        _this.activationTimerCallback = function() {
            _this.activationAnimationHasEnded = true;
            _this.runDeactivationUXLogicIfReady();
        };
        _this.activateHandler = function(e) {
            _this.activateImpl(e);
        };
        _this.deactivateHandler = function() {
            _this.deactivateImpl();
        };
        _this.focusHandler = function() {
            _this.handleFocus();
        };
        _this.blurHandler = function() {
            _this.handleBlur();
        };
        _this.resizeHandler = function() {
            _this.layout();
        };
        return _this;
    }
    Object.defineProperty(MDCRippleFoundation, "cssClasses", {
        get: function() {
            return 0, $fd0eb02544dd3322$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCRippleFoundation, "strings", {
        get: function() {
            return 0, $fd0eb02544dd3322$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCRippleFoundation, "numbers", {
        get: function() {
            return 0, $fd0eb02544dd3322$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCRippleFoundation, "defaultAdapter", {
        get: function() {
            return {
                addClass: function() {
                    return undefined;
                },
                browserSupportsCssVars: function() {
                    return true;
                },
                computeBoundingRect: function() {
                    return {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        width: 0,
                        height: 0
                    };
                },
                containsEventTarget: function() {
                    return true;
                },
                deregisterDocumentInteractionHandler: function() {
                    return undefined;
                },
                deregisterInteractionHandler: function() {
                    return undefined;
                },
                deregisterResizeHandler: function() {
                    return undefined;
                },
                getWindowPageOffset: function() {
                    return {
                        x: 0,
                        y: 0
                    };
                },
                isSurfaceActive: function() {
                    return true;
                },
                isSurfaceDisabled: function() {
                    return true;
                },
                isUnbounded: function() {
                    return true;
                },
                registerDocumentInteractionHandler: function() {
                    return undefined;
                },
                registerInteractionHandler: function() {
                    return undefined;
                },
                registerResizeHandler: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                updateCssVariable: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    MDCRippleFoundation.prototype.init = function() {
        var _this = this;
        var supportsPressRipple = this.supportsPressRipple();
        this.registerRootHandlers(supportsPressRipple);
        if (supportsPressRipple) {
            var _a = MDCRippleFoundation.cssClasses, ROOT_1 = _a.ROOT, UNBOUNDED_1 = _a.UNBOUNDED;
            requestAnimationFrame(function() {
                _this.adapter.addClass(ROOT_1);
                if (_this.adapter.isUnbounded()) {
                    _this.adapter.addClass(UNBOUNDED_1);
                    // Unbounded ripples need layout logic applied immediately to set coordinates for both shade and ripple
                    _this.layoutInternal();
                }
            });
        }
    };
    MDCRippleFoundation.prototype.destroy = function() {
        var _this = this;
        if (this.supportsPressRipple()) {
            if (this.activationTimer) {
                clearTimeout(this.activationTimer);
                this.activationTimer = 0;
                this.adapter.removeClass(MDCRippleFoundation.cssClasses.FG_ACTIVATION);
            }
            if (this.fgDeactivationRemovalTimer) {
                clearTimeout(this.fgDeactivationRemovalTimer);
                this.fgDeactivationRemovalTimer = 0;
                this.adapter.removeClass(MDCRippleFoundation.cssClasses.FG_DEACTIVATION);
            }
            var _a = MDCRippleFoundation.cssClasses, ROOT_2 = _a.ROOT, UNBOUNDED_2 = _a.UNBOUNDED;
            requestAnimationFrame(function() {
                _this.adapter.removeClass(ROOT_2);
                _this.adapter.removeClass(UNBOUNDED_2);
                _this.removeCssVars();
            });
        }
        this.deregisterRootHandlers();
        this.deregisterDeactivationHandlers();
    };
    /**
     * @param evt Optional event containing position information.
     */ MDCRippleFoundation.prototype.activate = function(evt) {
        this.activateImpl(evt);
    };
    MDCRippleFoundation.prototype.deactivate = function() {
        this.deactivateImpl();
    };
    MDCRippleFoundation.prototype.layout = function() {
        var _this = this;
        if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(function() {
            _this.layoutInternal();
            _this.layoutFrame = 0;
        });
    };
    MDCRippleFoundation.prototype.setUnbounded = function(unbounded) {
        var UNBOUNDED = MDCRippleFoundation.cssClasses.UNBOUNDED;
        if (unbounded) this.adapter.addClass(UNBOUNDED);
        else this.adapter.removeClass(UNBOUNDED);
    };
    MDCRippleFoundation.prototype.handleFocus = function() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.adapter.addClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
        });
    };
    MDCRippleFoundation.prototype.handleBlur = function() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.adapter.removeClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
        });
    };
    /**
     * We compute this property so that we are not querying information about the client
     * until the point in time where the foundation requests it. This prevents scenarios where
     * client-side feature-detection may happen too early, such as when components are rendered on the server
     * and then initialized at mount time on the client.
     */ MDCRippleFoundation.prototype.supportsPressRipple = function() {
        return this.adapter.browserSupportsCssVars();
    };
    MDCRippleFoundation.prototype.defaultActivationState = function() {
        return {
            activationEvent: undefined,
            hasDeactivationUXRun: false,
            isActivated: false,
            isProgrammatic: false,
            wasActivatedByPointer: false,
            wasElementMadeActive: false
        };
    };
    /**
     * supportsPressRipple Passed from init to save a redundant function call
     */ MDCRippleFoundation.prototype.registerRootHandlers = function(supportsPressRipple) {
        var e_1, _a;
        if (supportsPressRipple) {
            try {
                for(var ACTIVATION_EVENT_TYPES_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($bf1cd0cda6c64034$var$ACTIVATION_EVENT_TYPES), ACTIVATION_EVENT_TYPES_1_1 = ACTIVATION_EVENT_TYPES_1.next(); !ACTIVATION_EVENT_TYPES_1_1.done; ACTIVATION_EVENT_TYPES_1_1 = ACTIVATION_EVENT_TYPES_1.next()){
                    var evtType = ACTIVATION_EVENT_TYPES_1_1.value;
                    this.adapter.registerInteractionHandler(evtType, this.activateHandler);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (ACTIVATION_EVENT_TYPES_1_1 && !ACTIVATION_EVENT_TYPES_1_1.done && (_a = ACTIVATION_EVENT_TYPES_1.return)) _a.call(ACTIVATION_EVENT_TYPES_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (this.adapter.isUnbounded()) this.adapter.registerResizeHandler(this.resizeHandler);
        }
        this.adapter.registerInteractionHandler('focus', this.focusHandler);
        this.adapter.registerInteractionHandler('blur', this.blurHandler);
    };
    MDCRippleFoundation.prototype.registerDeactivationHandlers = function(evt) {
        var e_2, _a;
        if (evt.type === 'keydown') this.adapter.registerInteractionHandler('keyup', this.deactivateHandler);
        else try {
            for(var POINTER_DEACTIVATION_EVENT_TYPES_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($bf1cd0cda6c64034$var$POINTER_DEACTIVATION_EVENT_TYPES), POINTER_DEACTIVATION_EVENT_TYPES_1_1 = POINTER_DEACTIVATION_EVENT_TYPES_1.next(); !POINTER_DEACTIVATION_EVENT_TYPES_1_1.done; POINTER_DEACTIVATION_EVENT_TYPES_1_1 = POINTER_DEACTIVATION_EVENT_TYPES_1.next()){
                var evtType = POINTER_DEACTIVATION_EVENT_TYPES_1_1.value;
                this.adapter.registerDocumentInteractionHandler(evtType, this.deactivateHandler);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (POINTER_DEACTIVATION_EVENT_TYPES_1_1 && !POINTER_DEACTIVATION_EVENT_TYPES_1_1.done && (_a = POINTER_DEACTIVATION_EVENT_TYPES_1.return)) _a.call(POINTER_DEACTIVATION_EVENT_TYPES_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    MDCRippleFoundation.prototype.deregisterRootHandlers = function() {
        var e_3, _a;
        try {
            for(var ACTIVATION_EVENT_TYPES_2 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($bf1cd0cda6c64034$var$ACTIVATION_EVENT_TYPES), ACTIVATION_EVENT_TYPES_2_1 = ACTIVATION_EVENT_TYPES_2.next(); !ACTIVATION_EVENT_TYPES_2_1.done; ACTIVATION_EVENT_TYPES_2_1 = ACTIVATION_EVENT_TYPES_2.next()){
                var evtType = ACTIVATION_EVENT_TYPES_2_1.value;
                this.adapter.deregisterInteractionHandler(evtType, this.activateHandler);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (ACTIVATION_EVENT_TYPES_2_1 && !ACTIVATION_EVENT_TYPES_2_1.done && (_a = ACTIVATION_EVENT_TYPES_2.return)) _a.call(ACTIVATION_EVENT_TYPES_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        this.adapter.deregisterInteractionHandler('focus', this.focusHandler);
        this.adapter.deregisterInteractionHandler('blur', this.blurHandler);
        if (this.adapter.isUnbounded()) this.adapter.deregisterResizeHandler(this.resizeHandler);
    };
    MDCRippleFoundation.prototype.deregisterDeactivationHandlers = function() {
        var e_4, _a;
        this.adapter.deregisterInteractionHandler('keyup', this.deactivateHandler);
        try {
            for(var POINTER_DEACTIVATION_EVENT_TYPES_2 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($bf1cd0cda6c64034$var$POINTER_DEACTIVATION_EVENT_TYPES), POINTER_DEACTIVATION_EVENT_TYPES_2_1 = POINTER_DEACTIVATION_EVENT_TYPES_2.next(); !POINTER_DEACTIVATION_EVENT_TYPES_2_1.done; POINTER_DEACTIVATION_EVENT_TYPES_2_1 = POINTER_DEACTIVATION_EVENT_TYPES_2.next()){
                var evtType = POINTER_DEACTIVATION_EVENT_TYPES_2_1.value;
                this.adapter.deregisterDocumentInteractionHandler(evtType, this.deactivateHandler);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (POINTER_DEACTIVATION_EVENT_TYPES_2_1 && !POINTER_DEACTIVATION_EVENT_TYPES_2_1.done && (_a = POINTER_DEACTIVATION_EVENT_TYPES_2.return)) _a.call(POINTER_DEACTIVATION_EVENT_TYPES_2);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
    };
    MDCRippleFoundation.prototype.removeCssVars = function() {
        var _this = this;
        var rippleStrings = MDCRippleFoundation.strings;
        var keys = Object.keys(rippleStrings);
        keys.forEach(function(key) {
            if (key.indexOf('VAR_') === 0) _this.adapter.updateCssVariable(rippleStrings[key], null);
        });
    };
    MDCRippleFoundation.prototype.activateImpl = function(evt) {
        var _this = this;
        if (this.adapter.isSurfaceDisabled()) return;
        var activationState = this.activationState;
        if (activationState.isActivated) return;
        // Avoid reacting to follow-on events fired by touch device after an already-processed user interaction
        var previousActivationEvent = this.previousActivationEvent;
        var isSameInteraction = previousActivationEvent && evt !== undefined && previousActivationEvent.type !== evt.type;
        if (isSameInteraction) return;
        activationState.isActivated = true;
        activationState.isProgrammatic = evt === undefined;
        activationState.activationEvent = evt;
        activationState.wasActivatedByPointer = activationState.isProgrammatic ? false : evt !== undefined && (evt.type === 'mousedown' || evt.type === 'touchstart' || evt.type === 'pointerdown');
        var hasActivatedChild = evt !== undefined && $bf1cd0cda6c64034$var$activatedTargets.length > 0 && $bf1cd0cda6c64034$var$activatedTargets.some(function(target) {
            return _this.adapter.containsEventTarget(target);
        });
        if (hasActivatedChild) {
            // Immediately reset activation state, while preserving logic that prevents touch follow-on events
            this.resetActivationState();
            return;
        }
        if (evt !== undefined) {
            $bf1cd0cda6c64034$var$activatedTargets.push(evt.target);
            this.registerDeactivationHandlers(evt);
        }
        activationState.wasElementMadeActive = this.checkElementMadeActive(evt);
        if (activationState.wasElementMadeActive) this.animateActivation();
        requestAnimationFrame(function() {
            // Reset array on next frame after the current event has had a chance to bubble to prevent ancestor ripples
            $bf1cd0cda6c64034$var$activatedTargets = [];
            if (!activationState.wasElementMadeActive && evt !== undefined && (evt.key === ' ' || evt.keyCode === 32)) {
                // If space was pressed, try again within an rAF call to detect :active, because different UAs report
                // active states inconsistently when they're called within event handling code:
                // - https://bugs.chromium.org/p/chromium/issues/detail?id=635971
                // - https://bugzilla.mozilla.org/show_bug.cgi?id=1293741
                // We try first outside rAF to support Edge, which does not exhibit this problem, but will crash if a CSS
                // variable is set within a rAF callback for a submit button interaction (#2241).
                activationState.wasElementMadeActive = _this.checkElementMadeActive(evt);
                if (activationState.wasElementMadeActive) _this.animateActivation();
            }
            if (!activationState.wasElementMadeActive) // Reset activation state immediately if element was not made active.
            _this.activationState = _this.defaultActivationState();
        });
    };
    MDCRippleFoundation.prototype.checkElementMadeActive = function(evt) {
        return evt !== undefined && evt.type === 'keydown' ? this.adapter.isSurfaceActive() : true;
    };
    MDCRippleFoundation.prototype.animateActivation = function() {
        var _this = this;
        var _a = MDCRippleFoundation.strings, VAR_FG_TRANSLATE_START = _a.VAR_FG_TRANSLATE_START, VAR_FG_TRANSLATE_END = _a.VAR_FG_TRANSLATE_END;
        var _b = MDCRippleFoundation.cssClasses, FG_DEACTIVATION = _b.FG_DEACTIVATION, FG_ACTIVATION = _b.FG_ACTIVATION;
        var DEACTIVATION_TIMEOUT_MS = MDCRippleFoundation.numbers.DEACTIVATION_TIMEOUT_MS;
        this.layoutInternal();
        var translateStart = '';
        var translateEnd = '';
        if (!this.adapter.isUnbounded()) {
            var _c = this.getFgTranslationCoordinates(), startPoint = _c.startPoint, endPoint = _c.endPoint;
            translateStart = startPoint.x + "px, " + startPoint.y + "px";
            translateEnd = endPoint.x + "px, " + endPoint.y + "px";
        }
        this.adapter.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
        this.adapter.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
        // Cancel any ongoing activation/deactivation animations
        clearTimeout(this.activationTimer);
        clearTimeout(this.fgDeactivationRemovalTimer);
        this.rmBoundedActivationClasses();
        this.adapter.removeClass(FG_DEACTIVATION);
        // Force layout in order to re-trigger the animation.
        this.adapter.computeBoundingRect();
        this.adapter.addClass(FG_ACTIVATION);
        this.activationTimer = setTimeout(function() {
            _this.activationTimerCallback();
        }, DEACTIVATION_TIMEOUT_MS);
    };
    MDCRippleFoundation.prototype.getFgTranslationCoordinates = function() {
        var _a = this.activationState, activationEvent = _a.activationEvent, wasActivatedByPointer = _a.wasActivatedByPointer;
        var startPoint;
        if (wasActivatedByPointer) startPoint = (0, $df4bc532ae9a9f80$export$82f3563636a128ae)(activationEvent, this.adapter.getWindowPageOffset(), this.adapter.computeBoundingRect());
        else startPoint = {
            x: this.frame.width / 2,
            y: this.frame.height / 2
        };
        // Center the element around the start point.
        startPoint = {
            x: startPoint.x - this.initialSize / 2,
            y: startPoint.y - this.initialSize / 2
        };
        var endPoint = {
            x: this.frame.width / 2 - this.initialSize / 2,
            y: this.frame.height / 2 - this.initialSize / 2
        };
        return {
            startPoint: startPoint,
            endPoint: endPoint
        };
    };
    MDCRippleFoundation.prototype.runDeactivationUXLogicIfReady = function() {
        var _this = this;
        // This method is called both when a pointing device is released, and when the activation animation ends.
        // The deactivation animation should only run after both of those occur.
        var FG_DEACTIVATION = MDCRippleFoundation.cssClasses.FG_DEACTIVATION;
        var _a = this.activationState, hasDeactivationUXRun = _a.hasDeactivationUXRun, isActivated = _a.isActivated;
        var activationHasEnded = hasDeactivationUXRun || !isActivated;
        if (activationHasEnded && this.activationAnimationHasEnded) {
            this.rmBoundedActivationClasses();
            this.adapter.addClass(FG_DEACTIVATION);
            this.fgDeactivationRemovalTimer = setTimeout(function() {
                _this.adapter.removeClass(FG_DEACTIVATION);
            }, (0, $fd0eb02544dd3322$export$1f6c9cc012ebacae).FG_DEACTIVATION_MS);
        }
    };
    MDCRippleFoundation.prototype.rmBoundedActivationClasses = function() {
        var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
        this.adapter.removeClass(FG_ACTIVATION);
        this.activationAnimationHasEnded = false;
        this.adapter.computeBoundingRect();
    };
    MDCRippleFoundation.prototype.resetActivationState = function() {
        var _this = this;
        this.previousActivationEvent = this.activationState.activationEvent;
        this.activationState = this.defaultActivationState();
        // Touch devices may fire additional events for the same interaction within a short time.
        // Store the previous event until it's safe to assume that subsequent events are for new interactions.
        setTimeout(function() {
            return _this.previousActivationEvent = undefined;
        }, MDCRippleFoundation.numbers.TAP_DELAY_MS);
    };
    MDCRippleFoundation.prototype.deactivateImpl = function() {
        var _this = this;
        var activationState = this.activationState;
        // This can happen in scenarios such as when you have a keyup event that blurs the element.
        if (!activationState.isActivated) return;
        var state = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, activationState);
        if (activationState.isProgrammatic) {
            requestAnimationFrame(function() {
                _this.animateDeactivation(state);
            });
            this.resetActivationState();
        } else {
            this.deregisterDeactivationHandlers();
            requestAnimationFrame(function() {
                _this.activationState.hasDeactivationUXRun = true;
                _this.animateDeactivation(state);
                _this.resetActivationState();
            });
        }
    };
    MDCRippleFoundation.prototype.animateDeactivation = function(_a) {
        var wasActivatedByPointer = _a.wasActivatedByPointer, wasElementMadeActive = _a.wasElementMadeActive;
        if (wasActivatedByPointer || wasElementMadeActive) this.runDeactivationUXLogicIfReady();
    };
    MDCRippleFoundation.prototype.layoutInternal = function() {
        var _this = this;
        this.frame = this.adapter.computeBoundingRect();
        var maxDim = Math.max(this.frame.height, this.frame.width);
        // Surface diameter is treated differently for unbounded vs. bounded ripples.
        // Unbounded ripple diameter is calculated smaller since the surface is expected to already be padded appropriately
        // to extend the hitbox, and the ripple is expected to meet the edges of the padded hitbox (which is typically
        // square). Bounded ripples, on the other hand, are fully expected to expand beyond the surface's longest diameter
        // (calculated based on the diagonal plus a constant padding), and are clipped at the surface's border via
        // `overflow: hidden`.
        var getBoundedRadius = function() {
            var hypotenuse = Math.sqrt(Math.pow(_this.frame.width, 2) + Math.pow(_this.frame.height, 2));
            return hypotenuse + MDCRippleFoundation.numbers.PADDING;
        };
        this.maxRadius = this.adapter.isUnbounded() ? maxDim : getBoundedRadius();
        // Ripple is sized as a fraction of the largest dimension of the surface, then scales up using a CSS scale transform
        var initialSize = Math.floor(maxDim * MDCRippleFoundation.numbers.INITIAL_ORIGIN_SCALE);
        // Unbounded ripple size should always be even number to equally center align.
        if (this.adapter.isUnbounded() && initialSize % 2 !== 0) this.initialSize = initialSize - 1;
        else this.initialSize = initialSize;
        this.fgScale = "" + this.maxRadius / this.initialSize;
        this.updateLayoutCssVars();
    };
    MDCRippleFoundation.prototype.updateLayoutCssVars = function() {
        var _a = MDCRippleFoundation.strings, VAR_FG_SIZE = _a.VAR_FG_SIZE, VAR_LEFT = _a.VAR_LEFT, VAR_TOP = _a.VAR_TOP, VAR_FG_SCALE = _a.VAR_FG_SCALE;
        this.adapter.updateCssVariable(VAR_FG_SIZE, this.initialSize + "px");
        this.adapter.updateCssVariable(VAR_FG_SCALE, this.fgScale);
        if (this.adapter.isUnbounded()) {
            this.unboundedCoords = {
                left: Math.round(this.frame.width / 2 - this.initialSize / 2),
                top: Math.round(this.frame.height / 2 - this.initialSize / 2)
            };
            this.adapter.updateCssVariable(VAR_LEFT, this.unboundedCoords.left + "px");
            this.adapter.updateCssVariable(VAR_TOP, this.unboundedCoords.top + "px");
        }
    };
    return MDCRippleFoundation;
}((0, $d29cc2d0f1026d01$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$bf1cd0cda6c64034$export$2e2bcd8739ae039 = $bf1cd0cda6c64034$export$fb5f028029d92ef5;



var $20e9578b2a8426ec$export$583ca2e118aa9669 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCRipple, _super);
    function MDCRipple() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabled = false;
        return _this;
    }
    MDCRipple.attachTo = function(root, opts) {
        if (opts === void 0) opts = {
            isUnbounded: undefined
        };
        var ripple = new MDCRipple(root);
        // Only override unbounded behavior if option is explicitly specified
        if (opts.isUnbounded !== undefined) ripple.unbounded = opts.isUnbounded;
        return ripple;
    };
    MDCRipple.createAdapter = function(instance) {
        return {
            addClass: function(className) {
                return instance.root.classList.add(className);
            },
            browserSupportsCssVars: function() {
                return $df4bc532ae9a9f80$export$599ecc0c8c1caa3e(window);
            },
            computeBoundingRect: function() {
                return instance.root.getBoundingClientRect();
            },
            containsEventTarget: function(target) {
                return instance.root.contains(target);
            },
            deregisterDocumentInteractionHandler: function(evtType, handler) {
                return document.documentElement.removeEventListener(evtType, handler, (0, $9d9aa0d3469cd217$export$82e1592afef3b60f)());
            },
            deregisterInteractionHandler: function(evtType, handler) {
                return instance.root.removeEventListener(evtType, handler, (0, $9d9aa0d3469cd217$export$82e1592afef3b60f)());
            },
            deregisterResizeHandler: function(handler) {
                return window.removeEventListener('resize', handler);
            },
            getWindowPageOffset: function() {
                return {
                    x: window.pageXOffset,
                    y: window.pageYOffset
                };
            },
            isSurfaceActive: function() {
                return (0, $f4789bcfa326043f$export$de994efd351b291c)(instance.root, ':active');
            },
            isSurfaceDisabled: function() {
                return Boolean(instance.disabled);
            },
            isUnbounded: function() {
                return Boolean(instance.unbounded);
            },
            registerDocumentInteractionHandler: function(evtType, handler) {
                return document.documentElement.addEventListener(evtType, handler, (0, $9d9aa0d3469cd217$export$82e1592afef3b60f)());
            },
            registerInteractionHandler: function(evtType, handler) {
                return instance.root.addEventListener(evtType, handler, (0, $9d9aa0d3469cd217$export$82e1592afef3b60f)());
            },
            registerResizeHandler: function(handler) {
                return window.addEventListener('resize', handler);
            },
            removeClass: function(className) {
                return instance.root.classList.remove(className);
            },
            updateCssVariable: function(varName, value) {
                return instance.root.style.setProperty(varName, value);
            }
        };
    };
    Object.defineProperty(MDCRipple.prototype, "unbounded", {
        get: function() {
            return Boolean(this.isUnbounded);
        },
        set: function(unbounded) {
            this.isUnbounded = Boolean(unbounded);
            this.setUnbounded();
        },
        enumerable: false,
        configurable: true
    });
    MDCRipple.prototype.activate = function() {
        this.foundation.activate();
    };
    MDCRipple.prototype.deactivate = function() {
        this.foundation.deactivate();
    };
    MDCRipple.prototype.layout = function() {
        this.foundation.layout();
    };
    MDCRipple.prototype.getDefaultFoundation = function() {
        return new (0, $bf1cd0cda6c64034$export$fb5f028029d92ef5)(MDCRipple.createAdapter(this));
    };
    MDCRipple.prototype.initialSyncWithDOM = function() {
        var root = this.root;
        this.isUnbounded = 'mdcRippleIsUnbounded' in root.dataset;
    };
    /**
     * Closure Compiler throws an access control error when directly accessing a
     * protected or private property inside a getter/setter, like unbounded above.
     * By accessing the protected property inside a method, we solve that problem.
     * That's why this function exists.
     */ MDCRipple.prototype.setUnbounded = function() {
        this.foundation.setUnbounded(Boolean(this.isUnbounded));
    };
    return MDCRipple;
}((0, $0a13a1859770d71d$export$c3670872e5a4af8e));


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * AnimationFrame provides a user-friendly abstraction around requesting
 * and canceling animation frames.
 */ var $22ecda001003cf6d$export$1f3d5b43727c648a = /** @class */ function() {
    function AnimationFrame() {
        this.rafIDs = new Map();
    }
    /**
     * Requests an animation frame. Cancels any existing frame with the same key.
     * @param {string} key The key for this callback.
     * @param {FrameRequestCallback} callback The callback to be executed.
     */ AnimationFrame.prototype.request = function(key, callback) {
        var _this = this;
        this.cancel(key);
        var frameID = requestAnimationFrame(function(frame) {
            _this.rafIDs.delete(key);
            // Callback must come *after* the key is deleted so that nested calls to
            // request with the same key are not deleted.
            callback(frame);
        });
        this.rafIDs.set(key, frameID);
    };
    /**
     * Cancels a queued callback with the given key.
     * @param {string} key The key for this callback.
     */ AnimationFrame.prototype.cancel = function(key) {
        var rafID = this.rafIDs.get(key);
        if (rafID) {
            cancelAnimationFrame(rafID);
            this.rafIDs.delete(key);
        }
    };
    /**
     * Cancels all queued callback.
     */ AnimationFrame.prototype.cancelAll = function() {
        var _this = this;
        // Need to use forEach because it's the only iteration method supported
        // by IE11. Suppress the underscore because we don't need it.
        // tslint:disable-next-line:enforce-name-casing
        this.rafIDs.forEach(function(_, key) {
            _this.cancel(key);
        });
    };
    /**
     * Returns the queue of unexecuted callback keys.
     */ AnimationFrame.prototype.getQueue = function() {
        var queue = [];
        // Need to use forEach because it's the only iteration method supported
        // by IE11. Suppress the underscore because we don't need it.
        // tslint:disable-next-line:enforce-name-casing
        this.rafIDs.forEach(function(_, key) {
            queue.push(key);
        });
        return queue;
    };
    return AnimationFrame;
}();



/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $e00bef1e7bfd6d3e$export$c1c0562ec8379000 = {
    CLOSING: 'mdc-dialog--closing',
    OPEN: 'mdc-dialog--open',
    OPENING: 'mdc-dialog--opening',
    SCROLLABLE: 'mdc-dialog--scrollable',
    SCROLL_LOCK: 'mdc-dialog-scroll-lock',
    STACKED: 'mdc-dialog--stacked',
    FULLSCREEN: 'mdc-dialog--fullscreen',
    // Class for showing a scroll divider on full-screen dialog header element.
    // Should only be displayed on scrollable content, when the dialog content is
    // scrolled "underneath" the header.
    SCROLL_DIVIDER_HEADER: 'mdc-dialog-scroll-divider-header',
    // Class for showing a scroll divider on a full-screen dialog footer element.
    // Should only be displayed on scrolalble content, when the dialog content is
    // obscured "underneath" the footer.
    SCROLL_DIVIDER_FOOTER: 'mdc-dialog-scroll-divider-footer',
    // The "surface scrim" is a scrim covering only the surface of a dialog. This
    // is used in situations where a confirmation dialog is shown over an already
    // opened full-screen dialog. On larger screen-sizes, the full-screen dialog
    // is sized as a modal and so in these situations we display a "surface scrim"
    // to prevent a "double scrim" (where the scrim from the secondary
    // confirmation dialog would overlap with the scrim from the full-screen
    // dialog).
    SURFACE_SCRIM_SHOWN: 'mdc-dialog__surface-scrim--shown',
    // "Showing" animating class for the surface-scrim.
    SURFACE_SCRIM_SHOWING: 'mdc-dialog__surface-scrim--showing',
    // "Hiding" animating class for the surface-scrim.
    SURFACE_SCRIM_HIDING: 'mdc-dialog__surface-scrim--hiding',
    // Class to hide a dialog's scrim (used in conjunction with a surface-scrim).
    // Note that we only hide the original scrim rather than removing it entirely
    // to prevent interactions with the content behind this scrim, and to capture
    // scrim clicks.
    SCRIM_HIDDEN: 'mdc-dialog__scrim--hidden'
};
var $e00bef1e7bfd6d3e$export$21c51bc433c16634 = {
    ACTION_ATTRIBUTE: 'data-mdc-dialog-action',
    BUTTON_DEFAULT_ATTRIBUTE: 'data-mdc-dialog-button-default',
    BUTTON_SELECTOR: '.mdc-dialog__button',
    CLOSED_EVENT: 'MDCDialog:closed',
    CLOSE_ACTION: 'close',
    CLOSING_EVENT: 'MDCDialog:closing',
    CONTAINER_SELECTOR: '.mdc-dialog__container',
    CONTENT_SELECTOR: '.mdc-dialog__content',
    DESTROY_ACTION: 'destroy',
    INITIAL_FOCUS_ATTRIBUTE: 'data-mdc-dialog-initial-focus',
    OPENED_EVENT: 'MDCDialog:opened',
    OPENING_EVENT: 'MDCDialog:opening',
    SCRIM_SELECTOR: '.mdc-dialog__scrim',
    SUPPRESS_DEFAULT_PRESS_SELECTOR: [
        'textarea',
        '.mdc-menu .mdc-list-item',
        '.mdc-menu .mdc-deprecated-list-item'
    ].join(', '),
    SURFACE_SELECTOR: '.mdc-dialog__surface'
};
var $e00bef1e7bfd6d3e$export$1f6c9cc012ebacae = {
    DIALOG_ANIMATION_CLOSE_TIME_MS: 75,
    DIALOG_ANIMATION_OPEN_TIME_MS: 150
};


var $4b6d9c4c22d1910a$var$AnimationKeys;
(function(AnimationKeys) {
    AnimationKeys["POLL_SCROLL_POS"] = "poll_scroll_position";
    AnimationKeys["POLL_LAYOUT_CHANGE"] = "poll_layout_change";
})($4b6d9c4c22d1910a$var$AnimationKeys || ($4b6d9c4c22d1910a$var$AnimationKeys = {}));
var $4b6d9c4c22d1910a$export$dac9922df5f517f1 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCDialogFoundation, _super);
    function MDCDialogFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCDialogFoundation.defaultAdapter), adapter)) || this;
        _this.dialogOpen = false;
        _this.isFullscreen = false;
        _this.animationFrame = 0;
        _this.animationTimer = 0;
        _this.escapeKeyAction = (0, $e00bef1e7bfd6d3e$export$21c51bc433c16634).CLOSE_ACTION;
        _this.scrimClickAction = (0, $e00bef1e7bfd6d3e$export$21c51bc433c16634).CLOSE_ACTION;
        _this.autoStackButtons = true;
        _this.areButtonsStacked = false;
        _this.suppressDefaultPressSelector = (0, $e00bef1e7bfd6d3e$export$21c51bc433c16634).SUPPRESS_DEFAULT_PRESS_SELECTOR;
        _this.animFrame = new (0, $22ecda001003cf6d$export$1f3d5b43727c648a)();
        _this.contentScrollHandler = function() {
            _this.handleScrollEvent();
        };
        _this.windowResizeHandler = function() {
            _this.layout();
        };
        _this.windowOrientationChangeHandler = function() {
            _this.layout();
        };
        return _this;
    }
    Object.defineProperty(MDCDialogFoundation, "cssClasses", {
        get: function() {
            return 0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialogFoundation, "strings", {
        get: function() {
            return 0, $e00bef1e7bfd6d3e$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialogFoundation, "numbers", {
        get: function() {
            return 0, $e00bef1e7bfd6d3e$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialogFoundation, "defaultAdapter", {
        get: function() {
            return {
                addBodyClass: function() {
                    return undefined;
                },
                addClass: function() {
                    return undefined;
                },
                areButtonsStacked: function() {
                    return false;
                },
                clickDefaultButton: function() {
                    return undefined;
                },
                eventTargetMatches: function() {
                    return false;
                },
                getActionFromEvent: function() {
                    return '';
                },
                getInitialFocusEl: function() {
                    return null;
                },
                hasClass: function() {
                    return false;
                },
                isContentScrollable: function() {
                    return false;
                },
                notifyClosed: function() {
                    return undefined;
                },
                notifyClosing: function() {
                    return undefined;
                },
                notifyOpened: function() {
                    return undefined;
                },
                notifyOpening: function() {
                    return undefined;
                },
                releaseFocus: function() {
                    return undefined;
                },
                removeBodyClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                reverseButtons: function() {
                    return undefined;
                },
                trapFocus: function() {
                    return undefined;
                },
                registerContentEventHandler: function() {
                    return undefined;
                },
                deregisterContentEventHandler: function() {
                    return undefined;
                },
                isScrollableContentAtTop: function() {
                    return false;
                },
                isScrollableContentAtBottom: function() {
                    return false;
                },
                registerWindowEventHandler: function() {
                    return undefined;
                },
                deregisterWindowEventHandler: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    MDCDialogFoundation.prototype.init = function() {
        if (this.adapter.hasClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).STACKED)) this.setAutoStackButtons(false);
        this.isFullscreen = this.adapter.hasClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).FULLSCREEN);
    };
    MDCDialogFoundation.prototype.destroy = function() {
        if (this.animationTimer) {
            clearTimeout(this.animationTimer);
            this.handleAnimationTimerEnd();
        }
        if (this.isFullscreen) this.adapter.deregisterContentEventHandler('scroll', this.contentScrollHandler);
        this.animFrame.cancelAll();
        this.adapter.deregisterWindowEventHandler('resize', this.windowResizeHandler);
        this.adapter.deregisterWindowEventHandler('orientationchange', this.windowOrientationChangeHandler);
    };
    MDCDialogFoundation.prototype.open = function(dialogOptions) {
        var _this = this;
        this.dialogOpen = true;
        this.adapter.notifyOpening();
        this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).OPENING);
        if (this.isFullscreen) // A scroll event listener is registered even if the dialog is not
        // scrollable on open, since the window resize event, or orientation
        // change may make the dialog scrollable after it is opened.
        this.adapter.registerContentEventHandler('scroll', this.contentScrollHandler);
        if (dialogOptions && dialogOptions.isAboveFullscreenDialog) this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCRIM_HIDDEN);
        this.adapter.registerWindowEventHandler('resize', this.windowResizeHandler);
        this.adapter.registerWindowEventHandler('orientationchange', this.windowOrientationChangeHandler);
        // Wait a frame once display is no longer "none", to establish basis for
        // animation
        this.runNextAnimationFrame(function() {
            _this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).OPEN);
            _this.adapter.addBodyClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_LOCK);
            _this.layout();
            _this.animationTimer = setTimeout(function() {
                _this.handleAnimationTimerEnd();
                _this.adapter.trapFocus(_this.adapter.getInitialFocusEl());
                _this.adapter.notifyOpened();
            }, (0, $e00bef1e7bfd6d3e$export$1f6c9cc012ebacae).DIALOG_ANIMATION_OPEN_TIME_MS);
        });
    };
    MDCDialogFoundation.prototype.close = function(action) {
        var _this = this;
        if (action === void 0) action = '';
        if (!this.dialogOpen) // Avoid redundant close calls (and events), e.g. from keydown on elements
        // that inherently emit click
        return;
        this.dialogOpen = false;
        this.adapter.notifyClosing(action);
        this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).CLOSING);
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).OPEN);
        this.adapter.removeBodyClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_LOCK);
        if (this.isFullscreen) this.adapter.deregisterContentEventHandler('scroll', this.contentScrollHandler);
        this.adapter.deregisterWindowEventHandler('resize', this.windowResizeHandler);
        this.adapter.deregisterWindowEventHandler('orientationchange', this.windowOrientationChangeHandler);
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = 0;
        clearTimeout(this.animationTimer);
        this.animationTimer = setTimeout(function() {
            _this.adapter.releaseFocus();
            _this.handleAnimationTimerEnd();
            _this.adapter.notifyClosed(action);
        }, (0, $e00bef1e7bfd6d3e$export$1f6c9cc012ebacae).DIALOG_ANIMATION_CLOSE_TIME_MS);
    };
    /**
     * Used only in instances of showing a secondary dialog over a full-screen
     * dialog. Shows the "surface scrim" displayed over the full-screen dialog.
     */ MDCDialogFoundation.prototype.showSurfaceScrim = function() {
        var _this = this;
        this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWING);
        this.runNextAnimationFrame(function() {
            _this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWN);
        });
    };
    /**
     * Used only in instances of showing a secondary dialog over a full-screen
     * dialog. Hides the "surface scrim" displayed over the full-screen dialog.
     */ MDCDialogFoundation.prototype.hideSurfaceScrim = function() {
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWN);
        this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_HIDING);
    };
    /**
     * Handles `transitionend` event triggered when surface scrim animation is
     * finished.
     */ MDCDialogFoundation.prototype.handleSurfaceScrimTransitionEnd = function() {
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_HIDING);
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWING);
    };
    MDCDialogFoundation.prototype.isOpen = function() {
        return this.dialogOpen;
    };
    MDCDialogFoundation.prototype.getEscapeKeyAction = function() {
        return this.escapeKeyAction;
    };
    MDCDialogFoundation.prototype.setEscapeKeyAction = function(action) {
        this.escapeKeyAction = action;
    };
    MDCDialogFoundation.prototype.getScrimClickAction = function() {
        return this.scrimClickAction;
    };
    MDCDialogFoundation.prototype.setScrimClickAction = function(action) {
        this.scrimClickAction = action;
    };
    MDCDialogFoundation.prototype.getAutoStackButtons = function() {
        return this.autoStackButtons;
    };
    MDCDialogFoundation.prototype.setAutoStackButtons = function(autoStack) {
        this.autoStackButtons = autoStack;
    };
    MDCDialogFoundation.prototype.getSuppressDefaultPressSelector = function() {
        return this.suppressDefaultPressSelector;
    };
    MDCDialogFoundation.prototype.setSuppressDefaultPressSelector = function(selector) {
        this.suppressDefaultPressSelector = selector;
    };
    MDCDialogFoundation.prototype.layout = function() {
        var _this = this;
        this.animFrame.request($4b6d9c4c22d1910a$var$AnimationKeys.POLL_LAYOUT_CHANGE, function() {
            _this.layoutInternal();
        });
    };
    /** Handles click on the dialog root element. */ MDCDialogFoundation.prototype.handleClick = function(evt) {
        var isScrim = this.adapter.eventTargetMatches(evt.target, (0, $e00bef1e7bfd6d3e$export$21c51bc433c16634).SCRIM_SELECTOR);
        // Check for scrim click first since it doesn't require querying ancestors.
        if (isScrim && this.scrimClickAction !== '') this.close(this.scrimClickAction);
        else {
            var action = this.adapter.getActionFromEvent(evt);
            if (action) this.close(action);
        }
    };
    /** Handles keydown on the dialog root element. */ MDCDialogFoundation.prototype.handleKeydown = function(evt) {
        var isEnter = evt.key === 'Enter' || evt.keyCode === 13;
        if (!isEnter) return;
        var action = this.adapter.getActionFromEvent(evt);
        if (action) // Action button callback is handled in `handleClick`,
        // since space/enter keydowns on buttons trigger click events.
        return;
        // `composedPath` is used here, when available, to account for use cases
        // where a target meant to suppress the default press behaviour
        // may exist in a shadow root.
        // For example, a textarea inside a web component:
        // <mwc-dialog>
        //   <horizontal-layout>
        //     #shadow-root (open)
        //       <mwc-textarea>
        //         #shadow-root (open)
        //           <textarea></textarea>
        //       </mwc-textarea>
        //   </horizontal-layout>
        // </mwc-dialog>
        var target = evt.composedPath ? evt.composedPath()[0] : evt.target;
        var isDefault = this.suppressDefaultPressSelector ? !this.adapter.eventTargetMatches(target, this.suppressDefaultPressSelector) : true;
        if (isEnter && isDefault) this.adapter.clickDefaultButton();
    };
    /** Handles keydown on the document. */ MDCDialogFoundation.prototype.handleDocumentKeydown = function(evt) {
        var isEscape = evt.key === 'Escape' || evt.keyCode === 27;
        if (isEscape && this.escapeKeyAction !== '') this.close(this.escapeKeyAction);
    };
    /**
     * Handles scroll event on the dialog's content element -- showing a scroll
     * divider on the header or footer based on the scroll position. This handler
     * should only be registered on full-screen dialogs with scrollable content.
     */ MDCDialogFoundation.prototype.handleScrollEvent = function() {
        var _this = this;
        // Since scroll events can fire at a high rate, we throttle these events by
        // using requestAnimationFrame.
        this.animFrame.request($4b6d9c4c22d1910a$var$AnimationKeys.POLL_SCROLL_POS, function() {
            _this.toggleScrollDividerHeader();
            _this.toggleScrollDividerFooter();
        });
    };
    MDCDialogFoundation.prototype.layoutInternal = function() {
        if (this.autoStackButtons) this.detectStackedButtons();
        this.toggleScrollableClasses();
    };
    MDCDialogFoundation.prototype.handleAnimationTimerEnd = function() {
        this.animationTimer = 0;
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).OPENING);
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).CLOSING);
    };
    /**
     * Runs the given logic on the next animation frame, using setTimeout to
     * factor in Firefox reflow behavior.
     */ MDCDialogFoundation.prototype.runNextAnimationFrame = function(callback) {
        var _this = this;
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = requestAnimationFrame(function() {
            _this.animationFrame = 0;
            clearTimeout(_this.animationTimer);
            _this.animationTimer = setTimeout(callback, 0);
        });
    };
    MDCDialogFoundation.prototype.detectStackedButtons = function() {
        // Remove the class first to let us measure the buttons' natural positions.
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).STACKED);
        var areButtonsStacked = this.adapter.areButtonsStacked();
        if (areButtonsStacked) this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).STACKED);
        if (areButtonsStacked !== this.areButtonsStacked) {
            this.adapter.reverseButtons();
            this.areButtonsStacked = areButtonsStacked;
        }
    };
    MDCDialogFoundation.prototype.toggleScrollableClasses = function() {
        // Remove the class first to let us measure the natural height of the
        // content.
        this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLLABLE);
        if (this.adapter.isContentScrollable()) {
            this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLLABLE);
            if (this.isFullscreen) {
                // If dialog is full-screen and scrollable, check if a scroll divider
                // should be shown.
                this.toggleScrollDividerHeader();
                this.toggleScrollDividerFooter();
            }
        }
    };
    MDCDialogFoundation.prototype.toggleScrollDividerHeader = function() {
        if (!this.adapter.isScrollableContentAtTop()) this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_HEADER);
        else if (this.adapter.hasClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_HEADER)) this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_HEADER);
    };
    MDCDialogFoundation.prototype.toggleScrollDividerFooter = function() {
        if (!this.adapter.isScrollableContentAtBottom()) this.adapter.addClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_FOOTER);
        else if (this.adapter.hasClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_FOOTER)) this.adapter.removeClass((0, $e00bef1e7bfd6d3e$export$c1c0562ec8379000).SCROLL_DIVIDER_FOOTER);
    };
    return MDCDialogFoundation;
}((0, $d29cc2d0f1026d01$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$4b6d9c4c22d1910a$export$2e2bcd8739ae039 = $4b6d9c4c22d1910a$export$dac9922df5f517f1;


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ function $660d158ad6463612$export$48de15952f6ad658(surfaceEl, focusTrapFactory, initialFocusEl) {
    return focusTrapFactory(surfaceEl, {
        initialFocusEl: initialFocusEl
    });
}
function $660d158ad6463612$export$2bb74740c4e19def(el) {
    return el ? el.scrollHeight > el.offsetHeight : false;
}
function $660d158ad6463612$export$d4b9b9a59340cfb1(el) {
    return el ? el.scrollTop === 0 : false;
}
function $660d158ad6463612$export$d6bf3795025aa911(el) {
    return el ? Math.ceil(el.scrollHeight - el.scrollTop) === el.clientHeight : false;
}
function $660d158ad6463612$export$f6479bf5b3eac5ae(els) {
    var tops = new Set();
    [].forEach.call(els, function(el) {
        return tops.add(el.offsetTop);
    });
    return tops.size > 1;
}


var $38d6c657ee62cba7$var$strings = (0, $4b6d9c4c22d1910a$export$dac9922df5f517f1).strings;
var $38d6c657ee62cba7$export$6808244b173e4b98 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCDialog, _super);
    function MDCDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MDCDialog.prototype, "isOpen", {
        get: function() {
            return this.foundation.isOpen();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialog.prototype, "escapeKeyAction", {
        get: function() {
            return this.foundation.getEscapeKeyAction();
        },
        set: function(action) {
            this.foundation.setEscapeKeyAction(action);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialog.prototype, "scrimClickAction", {
        get: function() {
            return this.foundation.getScrimClickAction();
        },
        set: function(action) {
            this.foundation.setScrimClickAction(action);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialog.prototype, "autoStackButtons", {
        get: function() {
            return this.foundation.getAutoStackButtons();
        },
        set: function(autoStack) {
            this.foundation.setAutoStackButtons(autoStack);
        },
        enumerable: false,
        configurable: true
    });
    MDCDialog.attachTo = function(root) {
        return new MDCDialog(root);
    };
    MDCDialog.prototype.initialize = function(focusTrapFactory) {
        var e_1, _a;
        if (focusTrapFactory === void 0) focusTrapFactory = function(el, focusOptions) {
            return new (0, $eb9bb54a78ee410b$export$34eba2437817a67b)(el, focusOptions);
        };
        var container = this.root.querySelector($38d6c657ee62cba7$var$strings.CONTAINER_SELECTOR);
        if (!container) throw new Error("Dialog component requires a " + $38d6c657ee62cba7$var$strings.CONTAINER_SELECTOR + " container element");
        this.container = container;
        this.content = this.root.querySelector($38d6c657ee62cba7$var$strings.CONTENT_SELECTOR);
        this.buttons = [].slice.call(this.root.querySelectorAll($38d6c657ee62cba7$var$strings.BUTTON_SELECTOR));
        this.defaultButton = this.root.querySelector("[" + $38d6c657ee62cba7$var$strings.BUTTON_DEFAULT_ATTRIBUTE + "]");
        this.focusTrapFactory = focusTrapFactory;
        this.buttonRipples = [];
        try {
            for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(this.buttons), _c = _b.next(); !_c.done; _c = _b.next()){
                var buttonEl = _c.value;
                this.buttonRipples.push(new (0, $20e9578b2a8426ec$export$583ca2e118aa9669)(buttonEl));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    MDCDialog.prototype.initialSyncWithDOM = function() {
        var _this = this;
        this.focusTrap = $660d158ad6463612$export$48de15952f6ad658(this.container, this.focusTrapFactory, this.getInitialFocusEl() || undefined);
        this.handleClick = this.foundation.handleClick.bind(this.foundation);
        this.handleKeydown = this.foundation.handleKeydown.bind(this.foundation);
        this.handleDocumentKeydown = this.foundation.handleDocumentKeydown.bind(this.foundation);
        // this.handleLayout = this.layout.bind(this);
        this.handleOpening = function() {
            document.addEventListener('keydown', _this.handleDocumentKeydown);
        };
        this.handleClosing = function() {
            document.removeEventListener('keydown', _this.handleDocumentKeydown);
        };
        this.listen('click', this.handleClick);
        this.listen('keydown', this.handleKeydown);
        this.listen($38d6c657ee62cba7$var$strings.OPENING_EVENT, this.handleOpening);
        this.listen($38d6c657ee62cba7$var$strings.CLOSING_EVENT, this.handleClosing);
    };
    MDCDialog.prototype.destroy = function() {
        this.unlisten('click', this.handleClick);
        this.unlisten('keydown', this.handleKeydown);
        this.unlisten($38d6c657ee62cba7$var$strings.OPENING_EVENT, this.handleOpening);
        this.unlisten($38d6c657ee62cba7$var$strings.CLOSING_EVENT, this.handleClosing);
        this.handleClosing();
        this.buttonRipples.forEach(function(ripple) {
            ripple.destroy();
        });
        _super.prototype.destroy.call(this);
    };
    MDCDialog.prototype.layout = function() {
        this.foundation.layout();
    };
    MDCDialog.prototype.open = function() {
        this.foundation.open();
    };
    MDCDialog.prototype.close = function(action) {
        if (action === void 0) action = '';
        this.foundation.close(action);
    };
    MDCDialog.prototype.getDefaultFoundation = function() {
        var _this = this;
        // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
        // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
        var adapter = {
            addBodyClass: function(className) {
                return document.body.classList.add(className);
            },
            addClass: function(className) {
                return _this.root.classList.add(className);
            },
            areButtonsStacked: function() {
                return $660d158ad6463612$export$f6479bf5b3eac5ae(_this.buttons);
            },
            clickDefaultButton: function() {
                if (_this.defaultButton && !_this.defaultButton.disabled) _this.defaultButton.click();
            },
            eventTargetMatches: function(target, selector) {
                return target ? (0, $f4789bcfa326043f$export$de994efd351b291c)(target, selector) : false;
            },
            getActionFromEvent: function(evt) {
                if (!evt.target) return '';
                var element = (0, $f4789bcfa326043f$export$ff7f7c97cdce86e)(evt.target, "[" + $38d6c657ee62cba7$var$strings.ACTION_ATTRIBUTE + "]");
                return element && element.getAttribute($38d6c657ee62cba7$var$strings.ACTION_ATTRIBUTE);
            },
            getInitialFocusEl: function() {
                return _this.getInitialFocusEl();
            },
            hasClass: function(className) {
                return _this.root.classList.contains(className);
            },
            isContentScrollable: function() {
                return $660d158ad6463612$export$2bb74740c4e19def(_this.content);
            },
            notifyClosed: function(action) {
                return _this.emit($38d6c657ee62cba7$var$strings.CLOSED_EVENT, action ? {
                    action: action
                } : {});
            },
            notifyClosing: function(action) {
                return _this.emit($38d6c657ee62cba7$var$strings.CLOSING_EVENT, action ? {
                    action: action
                } : {});
            },
            notifyOpened: function() {
                return _this.emit($38d6c657ee62cba7$var$strings.OPENED_EVENT, {});
            },
            notifyOpening: function() {
                return _this.emit($38d6c657ee62cba7$var$strings.OPENING_EVENT, {});
            },
            releaseFocus: function() {
                _this.focusTrap.releaseFocus();
            },
            removeBodyClass: function(className) {
                return document.body.classList.remove(className);
            },
            removeClass: function(className) {
                return _this.root.classList.remove(className);
            },
            reverseButtons: function() {
                _this.buttons.reverse();
                _this.buttons.forEach(function(button) {
                    button.parentElement.appendChild(button);
                });
            },
            trapFocus: function() {
                _this.focusTrap.trapFocus();
            },
            registerContentEventHandler: function(evt, handler) {
                if (_this.content instanceof HTMLElement) _this.content.addEventListener(evt, handler);
            },
            deregisterContentEventHandler: function(evt, handler) {
                if (_this.content instanceof HTMLElement) _this.content.removeEventListener(evt, handler);
            },
            isScrollableContentAtTop: function() {
                return $660d158ad6463612$export$d4b9b9a59340cfb1(_this.content);
            },
            isScrollableContentAtBottom: function() {
                return $660d158ad6463612$export$d6bf3795025aa911(_this.content);
            },
            registerWindowEventHandler: function(evt, handler) {
                window.addEventListener(evt, handler);
            },
            deregisterWindowEventHandler: function(evt, handler) {
                window.removeEventListener(evt, handler);
            }
        };
        return new (0, $4b6d9c4c22d1910a$export$dac9922df5f517f1)(adapter);
    };
    MDCDialog.prototype.getInitialFocusEl = function() {
        return this.root.querySelector("[" + $38d6c657ee62cba7$var$strings.INITIAL_FOCUS_ATTRIBUTE + "]");
    };
    return MDCDialog;
}((0, $0a13a1859770d71d$export$c3670872e5a4af8e));


/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 

/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $d3b9476725b396f0$var$cssPropertyNameMap = {
    animation: {
        prefixed: '-webkit-animation',
        standard: 'animation'
    },
    transform: {
        prefixed: '-webkit-transform',
        standard: 'transform'
    },
    transition: {
        prefixed: '-webkit-transition',
        standard: 'transition'
    }
};
var $d3b9476725b396f0$var$jsEventTypeMap = {
    animationend: {
        cssProperty: 'animation',
        prefixed: 'webkitAnimationEnd',
        standard: 'animationend'
    },
    animationiteration: {
        cssProperty: 'animation',
        prefixed: 'webkitAnimationIteration',
        standard: 'animationiteration'
    },
    animationstart: {
        cssProperty: 'animation',
        prefixed: 'webkitAnimationStart',
        standard: 'animationstart'
    },
    transitionend: {
        cssProperty: 'transition',
        prefixed: 'webkitTransitionEnd',
        standard: 'transitionend'
    }
};
function $d3b9476725b396f0$var$isWindow(windowObj) {
    return Boolean(windowObj.document) && typeof windowObj.document.createElement === 'function';
}
function $d3b9476725b396f0$export$3e3382687f32c044(windowObj, cssProperty) {
    if ($d3b9476725b396f0$var$isWindow(windowObj) && cssProperty in $d3b9476725b396f0$var$cssPropertyNameMap) {
        var el = windowObj.document.createElement('div');
        var _a = $d3b9476725b396f0$var$cssPropertyNameMap[cssProperty], standard = _a.standard, prefixed = _a.prefixed;
        var isStandard = standard in el.style;
        return isStandard ? standard : prefixed;
    }
    return cssProperty;
}
function $d3b9476725b396f0$export$48f0db0729a5631b(windowObj, eventType) {
    if ($d3b9476725b396f0$var$isWindow(windowObj) && eventType in $d3b9476725b396f0$var$jsEventTypeMap) {
        var el = windowObj.document.createElement('div');
        var _a = $d3b9476725b396f0$var$jsEventTypeMap[eventType], standard = _a.standard, prefixed = _a.prefixed, cssProperty = _a.cssProperty;
        var isStandard = cssProperty in el.style;
        return isStandard ? standard : prefixed;
    }
    return eventType;
}







/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $ee22ceda0c2e12e9$export$c1c0562ec8379000 = {
    ANIM_CHECKED_INDETERMINATE: 'mdc-checkbox--anim-checked-indeterminate',
    ANIM_CHECKED_UNCHECKED: 'mdc-checkbox--anim-checked-unchecked',
    ANIM_INDETERMINATE_CHECKED: 'mdc-checkbox--anim-indeterminate-checked',
    ANIM_INDETERMINATE_UNCHECKED: 'mdc-checkbox--anim-indeterminate-unchecked',
    ANIM_UNCHECKED_CHECKED: 'mdc-checkbox--anim-unchecked-checked',
    ANIM_UNCHECKED_INDETERMINATE: 'mdc-checkbox--anim-unchecked-indeterminate',
    BACKGROUND: 'mdc-checkbox__background',
    CHECKED: 'mdc-checkbox--checked',
    CHECKMARK: 'mdc-checkbox__checkmark',
    CHECKMARK_PATH: 'mdc-checkbox__checkmark-path',
    DISABLED: 'mdc-checkbox--disabled',
    INDETERMINATE: 'mdc-checkbox--indeterminate',
    MIXEDMARK: 'mdc-checkbox__mixedmark',
    NATIVE_CONTROL: 'mdc-checkbox__native-control',
    ROOT: 'mdc-checkbox',
    SELECTED: 'mdc-checkbox--selected',
    UPGRADED: 'mdc-checkbox--upgraded'
};
var $ee22ceda0c2e12e9$export$21c51bc433c16634 = {
    ARIA_CHECKED_ATTR: 'aria-checked',
    ARIA_CHECKED_INDETERMINATE_VALUE: 'mixed',
    DATA_INDETERMINATE_ATTR: 'data-indeterminate',
    NATIVE_CONTROL_SELECTOR: '.mdc-checkbox__native-control',
    TRANSITION_STATE_CHECKED: 'checked',
    TRANSITION_STATE_INDETERMINATE: 'indeterminate',
    TRANSITION_STATE_INIT: 'init',
    TRANSITION_STATE_UNCHECKED: 'unchecked'
};
var $ee22ceda0c2e12e9$export$1f6c9cc012ebacae = {
    ANIM_END_LATCH_MS: 250
};


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 


var $0fb8799c7cf86124$export$7b204549dbb0ec4d = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCCheckboxFoundation, _super);
    function MDCCheckboxFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCCheckboxFoundation.defaultAdapter), adapter)) || this;
        _this.currentCheckState = (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).TRANSITION_STATE_INIT;
        _this.currentAnimationClass = '';
        _this.animEndLatchTimer = 0;
        _this.enableAnimationEndHandler = false;
        return _this;
    }
    Object.defineProperty(MDCCheckboxFoundation, "cssClasses", {
        get: function() {
            return 0, $ee22ceda0c2e12e9$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCCheckboxFoundation, "strings", {
        get: function() {
            return 0, $ee22ceda0c2e12e9$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCCheckboxFoundation, "numbers", {
        get: function() {
            return 0, $ee22ceda0c2e12e9$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCCheckboxFoundation, "defaultAdapter", {
        get: function() {
            return {
                addClass: function() {
                    return undefined;
                },
                forceLayout: function() {
                    return undefined;
                },
                hasNativeControl: function() {
                    return false;
                },
                isAttachedToDOM: function() {
                    return false;
                },
                isChecked: function() {
                    return false;
                },
                isIndeterminate: function() {
                    return false;
                },
                removeClass: function() {
                    return undefined;
                },
                removeNativeControlAttr: function() {
                    return undefined;
                },
                setNativeControlAttr: function() {
                    return undefined;
                },
                setNativeControlDisabled: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    MDCCheckboxFoundation.prototype.init = function() {
        this.currentCheckState = this.determineCheckState();
        this.updateAriaChecked();
        this.adapter.addClass((0, $ee22ceda0c2e12e9$export$c1c0562ec8379000).UPGRADED);
    };
    MDCCheckboxFoundation.prototype.destroy = function() {
        clearTimeout(this.animEndLatchTimer);
    };
    MDCCheckboxFoundation.prototype.setDisabled = function(disabled) {
        this.adapter.setNativeControlDisabled(disabled);
        if (disabled) this.adapter.addClass((0, $ee22ceda0c2e12e9$export$c1c0562ec8379000).DISABLED);
        else this.adapter.removeClass((0, $ee22ceda0c2e12e9$export$c1c0562ec8379000).DISABLED);
    };
    /**
     * Handles the animationend event for the checkbox
     */ MDCCheckboxFoundation.prototype.handleAnimationEnd = function() {
        var _this = this;
        if (!this.enableAnimationEndHandler) return;
        clearTimeout(this.animEndLatchTimer);
        this.animEndLatchTimer = setTimeout(function() {
            _this.adapter.removeClass(_this.currentAnimationClass);
            _this.enableAnimationEndHandler = false;
        }, (0, $ee22ceda0c2e12e9$export$1f6c9cc012ebacae).ANIM_END_LATCH_MS);
    };
    /**
     * Handles the change event for the checkbox
     */ MDCCheckboxFoundation.prototype.handleChange = function() {
        this.transitionCheckState();
    };
    MDCCheckboxFoundation.prototype.transitionCheckState = function() {
        if (!this.adapter.hasNativeControl()) return;
        var oldState = this.currentCheckState;
        var newState = this.determineCheckState();
        if (oldState === newState) return;
        this.updateAriaChecked();
        var TRANSITION_STATE_UNCHECKED = (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).TRANSITION_STATE_UNCHECKED;
        var SELECTED = (0, $ee22ceda0c2e12e9$export$c1c0562ec8379000).SELECTED;
        if (newState === TRANSITION_STATE_UNCHECKED) this.adapter.removeClass(SELECTED);
        else this.adapter.addClass(SELECTED);
        // Check to ensure that there isn't a previously existing animation class, in case for example
        // the user interacted with the checkbox before the animation was finished.
        if (this.currentAnimationClass.length > 0) {
            clearTimeout(this.animEndLatchTimer);
            this.adapter.forceLayout();
            this.adapter.removeClass(this.currentAnimationClass);
        }
        this.currentAnimationClass = this.getTransitionAnimationClass(oldState, newState);
        this.currentCheckState = newState;
        // Check for parentNode so that animations are only run when the element is attached
        // to the DOM.
        if (this.adapter.isAttachedToDOM() && this.currentAnimationClass.length > 0) {
            this.adapter.addClass(this.currentAnimationClass);
            this.enableAnimationEndHandler = true;
        }
    };
    MDCCheckboxFoundation.prototype.determineCheckState = function() {
        var TRANSITION_STATE_INDETERMINATE = (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).TRANSITION_STATE_INDETERMINATE, TRANSITION_STATE_CHECKED = (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).TRANSITION_STATE_CHECKED, TRANSITION_STATE_UNCHECKED = (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).TRANSITION_STATE_UNCHECKED;
        if (this.adapter.isIndeterminate()) return TRANSITION_STATE_INDETERMINATE;
        return this.adapter.isChecked() ? TRANSITION_STATE_CHECKED : TRANSITION_STATE_UNCHECKED;
    };
    MDCCheckboxFoundation.prototype.getTransitionAnimationClass = function(oldState, newState) {
        var TRANSITION_STATE_INIT = (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).TRANSITION_STATE_INIT, TRANSITION_STATE_CHECKED = (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).TRANSITION_STATE_CHECKED, TRANSITION_STATE_UNCHECKED = (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).TRANSITION_STATE_UNCHECKED;
        var _a = MDCCheckboxFoundation.cssClasses, ANIM_UNCHECKED_CHECKED = _a.ANIM_UNCHECKED_CHECKED, ANIM_UNCHECKED_INDETERMINATE = _a.ANIM_UNCHECKED_INDETERMINATE, ANIM_CHECKED_UNCHECKED = _a.ANIM_CHECKED_UNCHECKED, ANIM_CHECKED_INDETERMINATE = _a.ANIM_CHECKED_INDETERMINATE, ANIM_INDETERMINATE_CHECKED = _a.ANIM_INDETERMINATE_CHECKED, ANIM_INDETERMINATE_UNCHECKED = _a.ANIM_INDETERMINATE_UNCHECKED;
        switch(oldState){
            case TRANSITION_STATE_INIT:
                if (newState === TRANSITION_STATE_UNCHECKED) return '';
                return newState === TRANSITION_STATE_CHECKED ? ANIM_INDETERMINATE_CHECKED : ANIM_INDETERMINATE_UNCHECKED;
            case TRANSITION_STATE_UNCHECKED:
                return newState === TRANSITION_STATE_CHECKED ? ANIM_UNCHECKED_CHECKED : ANIM_UNCHECKED_INDETERMINATE;
            case TRANSITION_STATE_CHECKED:
                return newState === TRANSITION_STATE_UNCHECKED ? ANIM_CHECKED_UNCHECKED : ANIM_CHECKED_INDETERMINATE;
            default:
                return newState === TRANSITION_STATE_CHECKED ? ANIM_INDETERMINATE_CHECKED : ANIM_INDETERMINATE_UNCHECKED;
        }
    };
    MDCCheckboxFoundation.prototype.updateAriaChecked = function() {
        // Ensure aria-checked is set to mixed if checkbox is in indeterminate state.
        if (this.adapter.isIndeterminate()) this.adapter.setNativeControlAttr((0, $ee22ceda0c2e12e9$export$21c51bc433c16634).ARIA_CHECKED_ATTR, (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).ARIA_CHECKED_INDETERMINATE_VALUE);
        else // The on/off state does not need to keep track of aria-checked, since
        // the screenreader uses the checked property on the checkbox element.
        this.adapter.removeNativeControlAttr((0, $ee22ceda0c2e12e9$export$21c51bc433c16634).ARIA_CHECKED_ATTR);
    };
    return MDCCheckboxFoundation;
}((0, $d29cc2d0f1026d01$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$0fb8799c7cf86124$export$2e2bcd8739ae039 = $0fb8799c7cf86124$export$7b204549dbb0ec4d;


var $7c08072f0d8b00a7$var$CB_PROTO_PROPS = [
    'checked',
    'indeterminate'
];
var $7c08072f0d8b00a7$export$7154650bc9a9224f = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCCheckbox, _super);
    function MDCCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rippleSurface = _this.createRipple();
        return _this;
    }
    MDCCheckbox.attachTo = function(root) {
        return new MDCCheckbox(root);
    };
    Object.defineProperty(MDCCheckbox.prototype, "ripple", {
        get: function() {
            return this.rippleSurface;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCCheckbox.prototype, "checked", {
        get: function() {
            return this.getNativeControl().checked;
        },
        set: function(checked) {
            this.getNativeControl().checked = checked;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCCheckbox.prototype, "indeterminate", {
        get: function() {
            return this.getNativeControl().indeterminate;
        },
        set: function(indeterminate) {
            this.getNativeControl().indeterminate = indeterminate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCCheckbox.prototype, "disabled", {
        get: function() {
            return this.getNativeControl().disabled;
        },
        set: function(disabled) {
            this.foundation.setDisabled(disabled);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCCheckbox.prototype, "value", {
        get: function() {
            return this.getNativeControl().value;
        },
        set: function(value) {
            this.getNativeControl().value = value;
        },
        enumerable: false,
        configurable: true
    });
    MDCCheckbox.prototype.initialize = function() {
        var DATA_INDETERMINATE_ATTR = (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).DATA_INDETERMINATE_ATTR;
        this.getNativeControl().indeterminate = this.getNativeControl().getAttribute(DATA_INDETERMINATE_ATTR) === 'true';
        this.getNativeControl().removeAttribute(DATA_INDETERMINATE_ATTR);
    };
    MDCCheckbox.prototype.initialSyncWithDOM = function() {
        var _this = this;
        this.handleChange = function() {
            _this.foundation.handleChange();
        };
        this.handleAnimationEnd = function() {
            _this.foundation.handleAnimationEnd();
        };
        this.getNativeControl().addEventListener('change', this.handleChange);
        this.listen((0, $d3b9476725b396f0$export$48f0db0729a5631b)(window, 'animationend'), this.handleAnimationEnd);
        this.installPropertyChangeHooks();
    };
    MDCCheckbox.prototype.destroy = function() {
        this.rippleSurface.destroy();
        this.getNativeControl().removeEventListener('change', this.handleChange);
        this.unlisten((0, $d3b9476725b396f0$export$48f0db0729a5631b)(window, 'animationend'), this.handleAnimationEnd);
        this.uninstallPropertyChangeHooks();
        _super.prototype.destroy.call(this);
    };
    MDCCheckbox.prototype.getDefaultFoundation = function() {
        var _this = this;
        // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
        // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
        var adapter = {
            addClass: function(className) {
                return _this.root.classList.add(className);
            },
            forceLayout: function() {
                return _this.root.offsetWidth;
            },
            hasNativeControl: function() {
                return !!_this.getNativeControl();
            },
            isAttachedToDOM: function() {
                return Boolean(_this.root.parentNode);
            },
            isChecked: function() {
                return _this.checked;
            },
            isIndeterminate: function() {
                return _this.indeterminate;
            },
            removeClass: function(className) {
                _this.root.classList.remove(className);
            },
            removeNativeControlAttr: function(attr) {
                _this.getNativeControl().removeAttribute(attr);
            },
            setNativeControlAttr: function(attr, value) {
                _this.getNativeControl().setAttribute(attr, value);
            },
            setNativeControlDisabled: function(disabled) {
                _this.getNativeControl().disabled = disabled;
            }
        };
        return new (0, $0fb8799c7cf86124$export$7b204549dbb0ec4d)(adapter);
    };
    MDCCheckbox.prototype.createRipple = function() {
        var _this = this;
        // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
        // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
        var adapter = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $20e9578b2a8426ec$export$583ca2e118aa9669).createAdapter(this)), {
            deregisterInteractionHandler: function(evtType, handler) {
                _this.getNativeControl().removeEventListener(evtType, handler, (0, $9d9aa0d3469cd217$export$82e1592afef3b60f)());
            },
            isSurfaceActive: function() {
                return (0, $f4789bcfa326043f$export$de994efd351b291c)(_this.getNativeControl(), ':active');
            },
            isUnbounded: function() {
                return true;
            },
            registerInteractionHandler: function(evtType, handler) {
                _this.getNativeControl().addEventListener(evtType, handler, (0, $9d9aa0d3469cd217$export$82e1592afef3b60f)());
            }
        });
        return new (0, $20e9578b2a8426ec$export$583ca2e118aa9669)(this.root, new (0, $bf1cd0cda6c64034$export$fb5f028029d92ef5)(adapter));
    };
    MDCCheckbox.prototype.installPropertyChangeHooks = function() {
        var e_1, _a;
        var _this = this;
        var nativeCb = this.getNativeControl();
        var cbProto = Object.getPrototypeOf(nativeCb);
        var _loop_1 = function(controlState) {
            var desc = Object.getOwnPropertyDescriptor(cbProto, controlState);
            // We have to check for this descriptor, since some browsers (Safari) don't support its return.
            // See: https://bugs.webkit.org/show_bug.cgi?id=49739
            if (!$7c08072f0d8b00a7$var$validDescriptor(desc)) return {
                value: void 0
            };
            // Type cast is needed for compatibility with Closure Compiler.
            var nativeGetter = desc.get;
            var nativeCbDesc = {
                configurable: desc.configurable,
                enumerable: desc.enumerable,
                get: nativeGetter,
                set: function(state) {
                    desc.set.call(nativeCb, state);
                    _this.foundation.handleChange();
                }
            };
            Object.defineProperty(nativeCb, controlState, nativeCbDesc);
        };
        try {
            for(var CB_PROTO_PROPS_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($7c08072f0d8b00a7$var$CB_PROTO_PROPS), CB_PROTO_PROPS_1_1 = CB_PROTO_PROPS_1.next(); !CB_PROTO_PROPS_1_1.done; CB_PROTO_PROPS_1_1 = CB_PROTO_PROPS_1.next()){
                var controlState = CB_PROTO_PROPS_1_1.value;
                var state_1 = _loop_1(controlState);
                if (typeof state_1 === "object") return state_1.value;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (CB_PROTO_PROPS_1_1 && !CB_PROTO_PROPS_1_1.done && (_a = CB_PROTO_PROPS_1.return)) _a.call(CB_PROTO_PROPS_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    MDCCheckbox.prototype.uninstallPropertyChangeHooks = function() {
        var e_2, _a;
        var nativeCb = this.getNativeControl();
        var cbProto = Object.getPrototypeOf(nativeCb);
        try {
            for(var CB_PROTO_PROPS_2 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)($7c08072f0d8b00a7$var$CB_PROTO_PROPS), CB_PROTO_PROPS_2_1 = CB_PROTO_PROPS_2.next(); !CB_PROTO_PROPS_2_1.done; CB_PROTO_PROPS_2_1 = CB_PROTO_PROPS_2.next()){
                var controlState = CB_PROTO_PROPS_2_1.value;
                var desc = Object.getOwnPropertyDescriptor(cbProto, controlState);
                if (!$7c08072f0d8b00a7$var$validDescriptor(desc)) return;
                Object.defineProperty(nativeCb, controlState, desc);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (CB_PROTO_PROPS_2_1 && !CB_PROTO_PROPS_2_1.done && (_a = CB_PROTO_PROPS_2.return)) _a.call(CB_PROTO_PROPS_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    MDCCheckbox.prototype.getNativeControl = function() {
        var NATIVE_CONTROL_SELECTOR = (0, $ee22ceda0c2e12e9$export$21c51bc433c16634).NATIVE_CONTROL_SELECTOR;
        var el = this.root.querySelector(NATIVE_CONTROL_SELECTOR);
        if (!el) throw new Error("Checkbox component requires a " + NATIVE_CONTROL_SELECTOR + " element");
        return el;
    };
    return MDCCheckbox;
}((0, $0a13a1859770d71d$export$c3670872e5a4af8e));
function $7c08072f0d8b00a7$var$validDescriptor(inputPropDesc) {
    return !!inputPropDesc && typeof inputPropDesc.set === 'function';
}



/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $2316b8123b84dab0$export$c1c0562ec8379000 = {
    CLOSED_CLASS: 'mdc-linear-progress--closed',
    CLOSED_ANIMATION_OFF_CLASS: 'mdc-linear-progress--closed-animation-off',
    INDETERMINATE_CLASS: 'mdc-linear-progress--indeterminate',
    REVERSED_CLASS: 'mdc-linear-progress--reversed',
    ANIMATION_READY_CLASS: 'mdc-linear-progress--animation-ready'
};
var $2316b8123b84dab0$export$21c51bc433c16634 = {
    ARIA_HIDDEN: 'aria-hidden',
    ARIA_VALUEMAX: 'aria-valuemax',
    ARIA_VALUEMIN: 'aria-valuemin',
    ARIA_VALUENOW: 'aria-valuenow',
    BUFFER_BAR_SELECTOR: '.mdc-linear-progress__buffer-bar',
    FLEX_BASIS: 'flex-basis',
    PRIMARY_BAR_SELECTOR: '.mdc-linear-progress__primary-bar'
};
var $2316b8123b84dab0$export$a144c1aac8c5b708 = {
    PRIMARY_HALF: .8367142,
    PRIMARY_FULL: 2.00611057,
    SECONDARY_QUARTER: .37651913,
    SECONDARY_HALF: .84386165,
    SECONDARY_FULL: 1.60277782
};


var $c07111c6c9f68222$export$83c781df9f8b3d70 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCLinearProgressFoundation, _super);
    function MDCLinearProgressFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCLinearProgressFoundation.defaultAdapter), adapter)) || this;
        _this.observer = null;
        return _this;
    }
    Object.defineProperty(MDCLinearProgressFoundation, "cssClasses", {
        get: function() {
            return 0, $2316b8123b84dab0$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCLinearProgressFoundation, "strings", {
        get: function() {
            return 0, $2316b8123b84dab0$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCLinearProgressFoundation, "defaultAdapter", {
        get: function() {
            return {
                addClass: function() {
                    return undefined;
                },
                attachResizeObserver: function() {
                    return null;
                },
                forceLayout: function() {
                    return undefined;
                },
                getWidth: function() {
                    return 0;
                },
                hasClass: function() {
                    return false;
                },
                setBufferBarStyle: function() {
                    return null;
                },
                setPrimaryBarStyle: function() {
                    return null;
                },
                setStyle: function() {
                    return undefined;
                },
                removeAttribute: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                setAttribute: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    MDCLinearProgressFoundation.prototype.init = function() {
        var _this = this;
        this.determinate = !this.adapter.hasClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).INDETERMINATE_CLASS);
        this.adapter.addClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).ANIMATION_READY_CLASS);
        this.progress = 0;
        this.buffer = 1;
        this.observer = this.adapter.attachResizeObserver(function(entries) {
            var e_1, _a;
            if (_this.determinate) return;
            try {
                for(var entries_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()){
                    var entry = entries_1_1.value;
                    if (entry.contentRect) _this.calculateAndSetDimensions(entry.contentRect.width);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        });
        if (!this.determinate && this.observer) this.calculateAndSetDimensions(this.adapter.getWidth());
    };
    MDCLinearProgressFoundation.prototype.setDeterminate = function(isDeterminate) {
        this.determinate = isDeterminate;
        if (this.determinate) {
            this.adapter.removeClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).INDETERMINATE_CLASS);
            this.adapter.setAttribute((0, $2316b8123b84dab0$export$21c51bc433c16634).ARIA_VALUENOW, this.progress.toString());
            this.adapter.setAttribute((0, $2316b8123b84dab0$export$21c51bc433c16634).ARIA_VALUEMAX, '1');
            this.adapter.setAttribute((0, $2316b8123b84dab0$export$21c51bc433c16634).ARIA_VALUEMIN, '0');
            this.setPrimaryBarProgress(this.progress);
            this.setBufferBarProgress(this.buffer);
            return;
        }
        if (this.observer) this.calculateAndSetDimensions(this.adapter.getWidth());
        this.adapter.addClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).INDETERMINATE_CLASS);
        this.adapter.removeAttribute((0, $2316b8123b84dab0$export$21c51bc433c16634).ARIA_VALUENOW);
        this.adapter.removeAttribute((0, $2316b8123b84dab0$export$21c51bc433c16634).ARIA_VALUEMAX);
        this.adapter.removeAttribute((0, $2316b8123b84dab0$export$21c51bc433c16634).ARIA_VALUEMIN);
        this.setPrimaryBarProgress(1);
        this.setBufferBarProgress(1);
    };
    MDCLinearProgressFoundation.prototype.isDeterminate = function() {
        return this.determinate;
    };
    MDCLinearProgressFoundation.prototype.setProgress = function(value) {
        this.progress = value;
        if (this.determinate) {
            this.setPrimaryBarProgress(value);
            this.adapter.setAttribute((0, $2316b8123b84dab0$export$21c51bc433c16634).ARIA_VALUENOW, value.toString());
        }
    };
    MDCLinearProgressFoundation.prototype.getProgress = function() {
        return this.progress;
    };
    MDCLinearProgressFoundation.prototype.setBuffer = function(value) {
        this.buffer = value;
        if (this.determinate) this.setBufferBarProgress(value);
    };
    MDCLinearProgressFoundation.prototype.getBuffer = function() {
        return this.buffer;
    };
    MDCLinearProgressFoundation.prototype.open = function() {
        this.adapter.removeClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).CLOSED_CLASS);
        this.adapter.removeClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).CLOSED_ANIMATION_OFF_CLASS);
        this.adapter.removeAttribute((0, $2316b8123b84dab0$export$21c51bc433c16634).ARIA_HIDDEN);
    };
    MDCLinearProgressFoundation.prototype.close = function() {
        this.adapter.addClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).CLOSED_CLASS);
        this.adapter.setAttribute((0, $2316b8123b84dab0$export$21c51bc433c16634).ARIA_HIDDEN, 'true');
    };
    MDCLinearProgressFoundation.prototype.isClosed = function() {
        return this.adapter.hasClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).CLOSED_CLASS);
    };
    /**
     * Handles the transitionend event emitted after `close()` is called and the
     * opacity fades out. This is so that animations are removed only after the
     * progress indicator is completely hidden.
     */ MDCLinearProgressFoundation.prototype.handleTransitionEnd = function() {
        if (this.adapter.hasClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).CLOSED_CLASS)) this.adapter.addClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).CLOSED_ANIMATION_OFF_CLASS);
    };
    MDCLinearProgressFoundation.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        if (this.observer) this.observer.disconnect();
    };
    MDCLinearProgressFoundation.prototype.restartAnimation = function() {
        this.adapter.removeClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).ANIMATION_READY_CLASS);
        this.adapter.forceLayout();
        this.adapter.addClass((0, $2316b8123b84dab0$export$c1c0562ec8379000).ANIMATION_READY_CLASS);
    };
    MDCLinearProgressFoundation.prototype.setPrimaryBarProgress = function(progressValue) {
        var value = "scaleX(" + progressValue + ")";
        // Accessing `window` without a `typeof` check will throw on Node
        // environments.
        var transformProp = typeof window !== 'undefined' ? (0, $d3b9476725b396f0$export$3e3382687f32c044)(window, 'transform') : 'transform';
        this.adapter.setPrimaryBarStyle(transformProp, value);
    };
    MDCLinearProgressFoundation.prototype.setBufferBarProgress = function(progressValue) {
        var value = progressValue * 100 + "%";
        this.adapter.setBufferBarStyle((0, $2316b8123b84dab0$export$21c51bc433c16634).FLEX_BASIS, value);
    };
    MDCLinearProgressFoundation.prototype.calculateAndSetDimensions = function(width) {
        var primaryHalf = width * (0, $2316b8123b84dab0$export$a144c1aac8c5b708).PRIMARY_HALF;
        var primaryFull = width * (0, $2316b8123b84dab0$export$a144c1aac8c5b708).PRIMARY_FULL;
        var secondaryQuarter = width * (0, $2316b8123b84dab0$export$a144c1aac8c5b708).SECONDARY_QUARTER;
        var secondaryHalf = width * (0, $2316b8123b84dab0$export$a144c1aac8c5b708).SECONDARY_HALF;
        var secondaryFull = width * (0, $2316b8123b84dab0$export$a144c1aac8c5b708).SECONDARY_FULL;
        this.adapter.setStyle('--mdc-linear-progress-primary-half', primaryHalf + "px");
        this.adapter.setStyle('--mdc-linear-progress-primary-half-neg', -primaryHalf + "px");
        this.adapter.setStyle('--mdc-linear-progress-primary-full', primaryFull + "px");
        this.adapter.setStyle('--mdc-linear-progress-primary-full-neg', -primaryFull + "px");
        this.adapter.setStyle('--mdc-linear-progress-secondary-quarter', secondaryQuarter + "px");
        this.adapter.setStyle('--mdc-linear-progress-secondary-quarter-neg', -secondaryQuarter + "px");
        this.adapter.setStyle('--mdc-linear-progress-secondary-half', secondaryHalf + "px");
        this.adapter.setStyle('--mdc-linear-progress-secondary-half-neg', -secondaryHalf + "px");
        this.adapter.setStyle('--mdc-linear-progress-secondary-full', secondaryFull + "px");
        this.adapter.setStyle('--mdc-linear-progress-secondary-full-neg', -secondaryFull + "px");
        // need to restart animation for custom props to apply to keyframes
        this.restartAnimation();
    };
    return MDCLinearProgressFoundation;
}((0, $d29cc2d0f1026d01$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$c07111c6c9f68222$export$2e2bcd8739ae039 = $c07111c6c9f68222$export$83c781df9f8b3d70;


var $882247d19ca1c993$export$8ef9bec6c14049d = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCLinearProgress, _super);
    function MDCLinearProgress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MDCLinearProgress.attachTo = function(root) {
        return new MDCLinearProgress(root);
    };
    Object.defineProperty(MDCLinearProgress.prototype, "determinate", {
        set: function(value) {
            this.foundation.setDeterminate(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCLinearProgress.prototype, "progress", {
        set: function(value) {
            this.foundation.setProgress(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCLinearProgress.prototype, "buffer", {
        set: function(value) {
            this.foundation.setBuffer(value);
        },
        enumerable: false,
        configurable: true
    });
    MDCLinearProgress.prototype.open = function() {
        this.foundation.open();
    };
    MDCLinearProgress.prototype.close = function() {
        this.foundation.close();
    };
    MDCLinearProgress.prototype.initialSyncWithDOM = function() {
        var _this = this;
        this.root.addEventListener('transitionend', function() {
            _this.foundation.handleTransitionEnd();
        });
    };
    MDCLinearProgress.prototype.getDefaultFoundation = function() {
        var _this = this;
        // DO NOT INLINE this variable. For backward compatibility, foundations take
        // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
        // methods, we need a separate, strongly typed adapter variable.
        var adapter = {
            addClass: function(className) {
                _this.root.classList.add(className);
            },
            forceLayout: function() {
                _this.root.getBoundingClientRect();
            },
            setBufferBarStyle: function(styleProperty, value) {
                var bufferBar = _this.root.querySelector((0, $c07111c6c9f68222$export$83c781df9f8b3d70).strings.BUFFER_BAR_SELECTOR);
                if (bufferBar) bufferBar.style.setProperty(styleProperty, value);
            },
            setPrimaryBarStyle: function(styleProperty, value) {
                var primaryBar = _this.root.querySelector((0, $c07111c6c9f68222$export$83c781df9f8b3d70).strings.PRIMARY_BAR_SELECTOR);
                if (primaryBar) primaryBar.style.setProperty(styleProperty, value);
            },
            hasClass: function(className) {
                return _this.root.classList.contains(className);
            },
            removeAttribute: function(attributeName) {
                _this.root.removeAttribute(attributeName);
            },
            removeClass: function(className) {
                _this.root.classList.remove(className);
            },
            setAttribute: function(attributeName, value) {
                _this.root.setAttribute(attributeName, value);
            },
            setStyle: function(name, value) {
                _this.root.style.setProperty(name, value);
            },
            attachResizeObserver: function(callback) {
                var RO = window.ResizeObserver;
                if (RO) {
                    var ro = new RO(callback);
                    ro.observe(_this.root);
                    return ro;
                }
                return null;
            },
            getWidth: function() {
                return _this.root.offsetWidth;
            }
        };
        return new (0, $c07111c6c9f68222$export$83c781df9f8b3d70)(adapter);
    };
    return MDCLinearProgress;
}((0, $0a13a1859770d71d$export$c3670872e5a4af8e));


/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * CSS class names used in component.
 */ var $f6cfddedd77988a6$export$c1c0562ec8379000 = {
    CELL: 'mdc-data-table__cell',
    CELL_NUMERIC: 'mdc-data-table__cell--numeric',
    CONTENT: 'mdc-data-table__content',
    HEADER_CELL: 'mdc-data-table__header-cell',
    HEADER_CELL_LABEL: 'mdc-data-table__header-cell-label',
    HEADER_CELL_SORTED: 'mdc-data-table__header-cell--sorted',
    HEADER_CELL_SORTED_DESCENDING: 'mdc-data-table__header-cell--sorted-descending',
    HEADER_CELL_WITH_SORT: 'mdc-data-table__header-cell--with-sort',
    HEADER_CELL_WRAPPER: 'mdc-data-table__header-cell-wrapper',
    HEADER_ROW: 'mdc-data-table__header-row',
    HEADER_ROW_CHECKBOX: 'mdc-data-table__header-row-checkbox',
    IN_PROGRESS: 'mdc-data-table--in-progress',
    LINEAR_PROGRESS: 'mdc-data-table__linear-progress',
    PAGINATION_ROWS_PER_PAGE_LABEL: 'mdc-data-table__pagination-rows-per-page-label',
    PAGINATION_ROWS_PER_PAGE_SELECT: 'mdc-data-table__pagination-rows-per-page-select',
    PROGRESS_INDICATOR: 'mdc-data-table__progress-indicator',
    ROOT: 'mdc-data-table',
    ROW: 'mdc-data-table__row',
    ROW_CHECKBOX: 'mdc-data-table__row-checkbox',
    ROW_SELECTED: 'mdc-data-table__row--selected',
    SORT_ICON_BUTTON: 'mdc-data-table__sort-icon-button',
    SORT_STATUS_LABEL: 'mdc-data-table__sort-status-label',
    TABLE_CONTAINER: 'mdc-data-table__table-container'
};
var $f6cfddedd77988a6$export$16bd37df0047a29c = {
    ARIA_SELECTED: 'aria-selected',
    ARIA_SORT: 'aria-sort'
};
var $f6cfddedd77988a6$export$15d6ddc168d35719 = {
    COLUMN_ID: 'data-column-id',
    ROW_ID: 'data-row-id'
};
var $f6cfddedd77988a6$export$e1252723db1c541 = {
    CONTENT: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.CONTENT,
    HEADER_CELL: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.HEADER_CELL,
    HEADER_CELL_WITH_SORT: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.HEADER_CELL_WITH_SORT,
    HEADER_ROW: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.HEADER_ROW,
    HEADER_ROW_CHECKBOX: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.HEADER_ROW_CHECKBOX,
    PROGRESS_INDICATOR: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.PROGRESS_INDICATOR,
    ROW: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.ROW,
    ROW_CHECKBOX: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.ROW_CHECKBOX,
    ROW_SELECTED: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.ROW_SELECTED,
    SORT_ICON_BUTTON: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.SORT_ICON_BUTTON,
    SORT_STATUS_LABEL: "." + $f6cfddedd77988a6$export$c1c0562ec8379000.SORT_STATUS_LABEL
};
var $f6cfddedd77988a6$export$defe85febe8b728c = {
    SORTED_IN_DESCENDING: 'Sorted in descending order',
    SORTED_IN_ASCENDING: 'Sorted in ascending order'
};
var $f6cfddedd77988a6$export$21c51bc433c16634 = {
    ARIA_SELECTED: $f6cfddedd77988a6$export$16bd37df0047a29c.ARIA_SELECTED,
    ARIA_SORT: $f6cfddedd77988a6$export$16bd37df0047a29c.ARIA_SORT,
    DATA_ROW_ID_ATTR: $f6cfddedd77988a6$export$15d6ddc168d35719.ROW_ID,
    HEADER_ROW_CHECKBOX_SELECTOR: $f6cfddedd77988a6$export$e1252723db1c541.HEADER_ROW_CHECKBOX,
    ROW_CHECKBOX_SELECTOR: $f6cfddedd77988a6$export$e1252723db1c541.ROW_CHECKBOX,
    ROW_SELECTED_SELECTOR: $f6cfddedd77988a6$export$e1252723db1c541.ROW_SELECTED,
    ROW_SELECTOR: $f6cfddedd77988a6$export$e1252723db1c541.ROW
};
var $f6cfddedd77988a6$export$aff26e357adc6917;
(function(SortValue) {
    // Items are sorted in ascending order by this column.
    SortValue["ASCENDING"] = "ascending";
    // Items are sorted in descending order by this column.
    SortValue["DESCENDING"] = "descending";
    // There is no defined sort applied to the column.
    SortValue["NONE"] = "none";
    // A sort algorithm other than ascending or descending has been applied.
    SortValue["OTHER"] = "other";
})($f6cfddedd77988a6$export$aff26e357adc6917 || ($f6cfddedd77988a6$export$aff26e357adc6917 = {}));
var $f6cfddedd77988a6$export$4bf9923669ad6c63 = {
    ROW_CLICK: 'MDCDataTable:rowClick',
    ROW_SELECTION_CHANGED: 'MDCDataTable:rowSelectionChanged',
    SELECTED_ALL: 'MDCDataTable:selectedAll',
    SORTED: 'MDCDataTable:sorted',
    UNSELECTED_ALL: 'MDCDataTable:unselectedAll'
};


/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 


/**
 * The Foundation of data table component containing pure business logic, any
 * logic requiring DOM manipulation are delegated to adapter methods.
 */ var $14b9dedc87673f83$export$9d41abb262ebacf8 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCDataTableFoundation, _super);
    function MDCDataTableFoundation(adapter) {
        return _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCDataTableFoundation.defaultAdapter), adapter)) || this;
    }
    Object.defineProperty(MDCDataTableFoundation, "defaultAdapter", {
        get: function() {
            return {
                addClass: function() {
                    return undefined;
                },
                addClassAtRowIndex: function() {
                    return undefined;
                },
                getAttributeByHeaderCellIndex: function() {
                    return '';
                },
                getHeaderCellCount: function() {
                    return 0;
                },
                getHeaderCellElements: function() {
                    return [];
                },
                getRowCount: function() {
                    return 0;
                },
                getRowElements: function() {
                    return [];
                },
                getRowIdAtIndex: function() {
                    return '';
                },
                getRowIndexByChildElement: function() {
                    return 0;
                },
                getSelectedRowCount: function() {
                    return 0;
                },
                getTableContainerHeight: function() {
                    return 0;
                },
                getTableHeaderHeight: function() {
                    return 0;
                },
                isCheckboxAtRowIndexChecked: function() {
                    return false;
                },
                isHeaderRowCheckboxChecked: function() {
                    return false;
                },
                isRowsSelectable: function() {
                    return false;
                },
                notifyRowSelectionChanged: function() {
                    return undefined;
                },
                notifySelectedAll: function() {
                    return undefined;
                },
                notifySortAction: function() {
                    return undefined;
                },
                notifyUnselectedAll: function() {
                    return undefined;
                },
                notifyRowClick: function() {
                    return undefined;
                },
                registerHeaderRowCheckbox: function() {
                    return undefined;
                },
                registerRowCheckboxes: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                removeClassAtRowIndex: function() {
                    return undefined;
                },
                removeClassNameByHeaderCellIndex: function() {
                    return undefined;
                },
                setAttributeAtRowIndex: function() {
                    return undefined;
                },
                setAttributeByHeaderCellIndex: function() {
                    return undefined;
                },
                setClassNameByHeaderCellIndex: function() {
                    return undefined;
                },
                setHeaderRowCheckboxChecked: function() {
                    return undefined;
                },
                setHeaderRowCheckboxIndeterminate: function() {
                    return undefined;
                },
                setProgressIndicatorStyles: function() {
                    return undefined;
                },
                setRowCheckboxCheckedAtIndex: function() {
                    return undefined;
                },
                setSortStatusLabelByHeaderCellIndex: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Re-initializes header row checkbox and row checkboxes when selectable rows
     * are added or removed from table. Use this if registering checkbox is
     * synchronous.
     */ MDCDataTableFoundation.prototype.layout = function() {
        if (this.adapter.isRowsSelectable()) {
            this.adapter.registerHeaderRowCheckbox();
            this.adapter.registerRowCheckboxes();
            this.setHeaderRowCheckboxState();
        }
    };
    /**
     * Re-initializes header row checkbox and row checkboxes when selectable rows
     * are added or removed from table. Use this if registering checkbox is
     * asynchronous.
     */ MDCDataTableFoundation.prototype.layoutAsync = function() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.adapter.isRowsSelectable()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.adapter.registerHeaderRowCheckbox()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.adapter.registerRowCheckboxes()
                        ];
                    case 2:
                        _a.sent();
                        this.setHeaderRowCheckboxState();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @return Returns array of row elements.
     */ MDCDataTableFoundation.prototype.getRows = function() {
        return this.adapter.getRowElements();
    };
    /**
     * @return Array of header cell elements.
     */ MDCDataTableFoundation.prototype.getHeaderCells = function() {
        return this.adapter.getHeaderCellElements();
    };
    /**
     * Sets selected row ids. Overwrites previously selected rows.
     * @param rowIds Array of row ids that needs to be selected.
     */ MDCDataTableFoundation.prototype.setSelectedRowIds = function(rowIds) {
        for(var rowIndex = 0; rowIndex < this.adapter.getRowCount(); rowIndex++){
            var rowId = this.adapter.getRowIdAtIndex(rowIndex);
            var isSelected = false;
            if (rowId && rowIds.indexOf(rowId) >= 0) isSelected = true;
            this.adapter.setRowCheckboxCheckedAtIndex(rowIndex, isSelected);
            this.selectRowAtIndex(rowIndex, isSelected);
        }
        this.setHeaderRowCheckboxState();
    };
    /**
     * @return Returns array of all row ids.
     */ MDCDataTableFoundation.prototype.getRowIds = function() {
        var rowIds = [];
        for(var rowIndex = 0; rowIndex < this.adapter.getRowCount(); rowIndex++)rowIds.push(this.adapter.getRowIdAtIndex(rowIndex));
        return rowIds;
    };
    /**
     * @return Returns array of selected row ids.
     */ MDCDataTableFoundation.prototype.getSelectedRowIds = function() {
        var selectedRowIds = [];
        for(var rowIndex = 0; rowIndex < this.adapter.getRowCount(); rowIndex++)if (this.adapter.isCheckboxAtRowIndexChecked(rowIndex)) selectedRowIds.push(this.adapter.getRowIdAtIndex(rowIndex));
        return selectedRowIds;
    };
    /**
     * Handles header row checkbox change event.
     */ MDCDataTableFoundation.prototype.handleHeaderRowCheckboxChange = function() {
        var isHeaderChecked = this.adapter.isHeaderRowCheckboxChecked();
        for(var rowIndex = 0; rowIndex < this.adapter.getRowCount(); rowIndex++){
            this.adapter.setRowCheckboxCheckedAtIndex(rowIndex, isHeaderChecked);
            this.selectRowAtIndex(rowIndex, isHeaderChecked);
        }
        if (isHeaderChecked) this.adapter.notifySelectedAll();
        else this.adapter.notifyUnselectedAll();
    };
    /**
     * Handles change event originated from row checkboxes.
     */ MDCDataTableFoundation.prototype.handleRowCheckboxChange = function(event) {
        var rowIndex = this.adapter.getRowIndexByChildElement(event.target);
        if (rowIndex === -1) return;
        var selected = this.adapter.isCheckboxAtRowIndexChecked(rowIndex);
        this.selectRowAtIndex(rowIndex, selected);
        this.setHeaderRowCheckboxState();
        var rowId = this.adapter.getRowIdAtIndex(rowIndex);
        this.adapter.notifyRowSelectionChanged({
            rowId: rowId,
            rowIndex: rowIndex,
            selected: selected
        });
    };
    /**
     * Handles sort action on sortable header cell.
     */ MDCDataTableFoundation.prototype.handleSortAction = function(eventData) {
        var columnId = eventData.columnId, columnIndex = eventData.columnIndex, headerCell = eventData.headerCell;
        // Reset sort attributes / classes on other header cells.
        for(var index = 0; index < this.adapter.getHeaderCellCount(); index++){
            if (index === columnIndex) continue;
            this.adapter.removeClassNameByHeaderCellIndex(index, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED);
            this.adapter.removeClassNameByHeaderCellIndex(index, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED_DESCENDING);
            this.adapter.setAttributeByHeaderCellIndex(index, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SORT, (0, $f6cfddedd77988a6$export$aff26e357adc6917).NONE);
            this.adapter.setSortStatusLabelByHeaderCellIndex(index, (0, $f6cfddedd77988a6$export$aff26e357adc6917).NONE);
        }
        // Set appropriate sort attributes / classes on target header cell.
        this.adapter.setClassNameByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED);
        var currentSortValue = this.adapter.getAttributeByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SORT);
        var sortValue = (0, $f6cfddedd77988a6$export$aff26e357adc6917).NONE;
        // Set to descending if sorted on ascending order.
        if (currentSortValue === (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING) {
            this.adapter.setClassNameByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED_DESCENDING);
            this.adapter.setAttributeByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SORT, (0, $f6cfddedd77988a6$export$aff26e357adc6917).DESCENDING);
            sortValue = (0, $f6cfddedd77988a6$export$aff26e357adc6917).DESCENDING;
        // Set to ascending if sorted on descending order.
        } else if (currentSortValue === (0, $f6cfddedd77988a6$export$aff26e357adc6917).DESCENDING) {
            this.adapter.removeClassNameByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_CELL_SORTED_DESCENDING);
            this.adapter.setAttributeByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SORT, (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING);
            sortValue = (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING;
        } else {
            // Set to ascending by default when not sorted.
            this.adapter.setAttributeByHeaderCellIndex(columnIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SORT, (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING);
            sortValue = (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING;
        }
        this.adapter.setSortStatusLabelByHeaderCellIndex(columnIndex, sortValue);
        this.adapter.notifySortAction({
            columnId: columnId,
            columnIndex: columnIndex,
            headerCell: headerCell,
            sortValue: sortValue
        });
    };
    /**
     * Handles data table row click event.
     */ MDCDataTableFoundation.prototype.handleRowClick = function(_a) {
        var rowId = _a.rowId, row = _a.row;
        this.adapter.notifyRowClick({
            rowId: rowId,
            row: row
        });
    };
    /**
     * Shows progress indicator blocking only the table body content when in
     * loading state.
     */ MDCDataTableFoundation.prototype.showProgress = function() {
        var tableHeaderHeight = this.adapter.getTableHeaderHeight();
        // Calculate the height of table content (Not scroll content) excluding
        // header row height.
        var height = this.adapter.getTableContainerHeight() - tableHeaderHeight;
        var top = tableHeaderHeight;
        this.adapter.setProgressIndicatorStyles({
            height: height + "px",
            top: top + "px"
        });
        this.adapter.addClass((0, $f6cfddedd77988a6$export$c1c0562ec8379000).IN_PROGRESS);
    };
    /**
     * Hides progress indicator when data table is finished loading.
     */ MDCDataTableFoundation.prototype.hideProgress = function() {
        this.adapter.removeClass((0, $f6cfddedd77988a6$export$c1c0562ec8379000).IN_PROGRESS);
    };
    /**
     * Updates header row checkbox state based on number of rows selected.
     */ MDCDataTableFoundation.prototype.setHeaderRowCheckboxState = function() {
        if (this.adapter.getSelectedRowCount() === 0) {
            this.adapter.setHeaderRowCheckboxChecked(false);
            this.adapter.setHeaderRowCheckboxIndeterminate(false);
        } else if (this.adapter.getSelectedRowCount() === this.adapter.getRowCount()) {
            this.adapter.setHeaderRowCheckboxChecked(true);
            this.adapter.setHeaderRowCheckboxIndeterminate(false);
        } else {
            this.adapter.setHeaderRowCheckboxIndeterminate(true);
            this.adapter.setHeaderRowCheckboxChecked(false);
        }
    };
    /**
     * Sets the attributes of row element based on selection state.
     */ MDCDataTableFoundation.prototype.selectRowAtIndex = function(rowIndex, selected) {
        if (selected) {
            this.adapter.addClassAtRowIndex(rowIndex, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).ROW_SELECTED);
            this.adapter.setAttributeAtRowIndex(rowIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SELECTED, 'true');
        } else {
            this.adapter.removeClassAtRowIndex(rowIndex, (0, $f6cfddedd77988a6$export$c1c0562ec8379000).ROW_SELECTED);
            this.adapter.setAttributeAtRowIndex(rowIndex, (0, $f6cfddedd77988a6$export$21c51bc433c16634).ARIA_SELECTED, 'false');
        }
    };
    return MDCDataTableFoundation;
}((0, $d29cc2d0f1026d01$export$a81b11d69c993162));


/**
 * Implementation of `MDCDataTableFoundation`
 */ var $369a0c7b5a754e20$export$240748bfd28d4d90 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCDataTable, _super);
    function MDCDataTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MDCDataTable.attachTo = function(root) {
        return new MDCDataTable(root);
    };
    MDCDataTable.prototype.initialize = function(checkboxFactory) {
        if (checkboxFactory === void 0) checkboxFactory = function(el) {
            return new (0, $7c08072f0d8b00a7$export$7154650bc9a9224f)(el);
        };
        this.checkboxFactory = checkboxFactory;
    };
    MDCDataTable.prototype.initialSyncWithDOM = function() {
        var _this = this;
        this.headerRow = this.root.querySelector("." + (0, $f6cfddedd77988a6$export$c1c0562ec8379000).HEADER_ROW);
        this.handleHeaderRowCheckboxChange = function() {
            _this.foundation.handleHeaderRowCheckboxChange();
        };
        this.headerRow.addEventListener('change', this.handleHeaderRowCheckboxChange);
        this.headerRowClickListener = function(event) {
            _this.handleHeaderRowClick(event);
        };
        this.headerRow.addEventListener('click', this.headerRowClickListener);
        this.content = this.root.querySelector("." + (0, $f6cfddedd77988a6$export$c1c0562ec8379000).CONTENT);
        this.handleContentClick = function(event) {
            var dataRowEl = (0, $f4789bcfa326043f$export$ff7f7c97cdce86e)(event.target, (0, $f6cfddedd77988a6$export$e1252723db1c541).ROW);
            if (!dataRowEl) return;
            _this.foundation.handleRowClick({
                rowId: _this.getRowIdByRowElement(dataRowEl),
                row: dataRowEl
            });
        };
        this.content.addEventListener('click', this.handleContentClick);
        this.handleRowCheckboxChange = function(event) {
            _this.foundation.handleRowCheckboxChange(event);
        };
        this.content.addEventListener('change', this.handleRowCheckboxChange);
        this.layout();
    };
    /**
     * Re-initializes header row checkbox and row checkboxes when selectable rows
     * are added or removed from table.
     */ MDCDataTable.prototype.layout = function() {
        this.foundation.layout();
    };
    /**
     * @return Returns array of header row cell elements.
     */ MDCDataTable.prototype.getHeaderCells = function() {
        return [].slice.call(this.root.querySelectorAll((0, $f6cfddedd77988a6$export$e1252723db1c541).HEADER_CELL));
    };
    /**
     * @return Returns array of row elements.
     */ MDCDataTable.prototype.getRows = function() {
        return this.foundation.getRows();
    };
    /**
     * @return Returns array of selected row ids.
     */ MDCDataTable.prototype.getSelectedRowIds = function() {
        return this.foundation.getSelectedRowIds();
    };
    /**
     * Sets selected row ids. Overwrites previously selected rows.
     * @param rowIds Array of row ids that needs to be selected.
     */ MDCDataTable.prototype.setSelectedRowIds = function(rowIds) {
        this.foundation.setSelectedRowIds(rowIds);
    };
    /**
     * Shows progress indicator when data table is in loading state.
     */ MDCDataTable.prototype.showProgress = function() {
        this.getLinearProgress().open();
        this.foundation.showProgress();
    };
    /**
     * Hides progress indicator after data table is finished loading.
     */ MDCDataTable.prototype.hideProgress = function() {
        this.foundation.hideProgress();
        this.getLinearProgress().close();
    };
    MDCDataTable.prototype.destroy = function() {
        var e_1, _a;
        if (this.handleHeaderRowCheckboxChange) this.headerRow.removeEventListener('change', this.handleHeaderRowCheckboxChange);
        if (this.headerRowClickListener) this.headerRow.removeEventListener('click', this.headerRowClickListener);
        if (this.handleRowCheckboxChange) this.content.removeEventListener('change', this.handleRowCheckboxChange);
        if (this.headerRowCheckbox) this.headerRowCheckbox.destroy();
        if (this.rowCheckboxList) try {
            for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(this.rowCheckboxList), _c = _b.next(); !_c.done; _c = _b.next()){
                var checkbox = _c.value;
                checkbox.destroy();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (this.handleContentClick) this.content.removeEventListener('click', this.handleContentClick);
    };
    MDCDataTable.prototype.getDefaultFoundation = function() {
        var _this = this;
        // DO NOT INLINE this variable. For backward compatibility, foundations take
        // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
        // methods, we need a separate, strongly typed adapter variable.
        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
        var adapter = {
            addClass: function(className) {
                _this.root.classList.add(className);
            },
            removeClass: function(className) {
                _this.root.classList.remove(className);
            },
            getHeaderCellElements: function() {
                return _this.getHeaderCells();
            },
            getHeaderCellCount: function() {
                return _this.getHeaderCells().length;
            },
            getAttributeByHeaderCellIndex: function(index, attribute) {
                return _this.getHeaderCells()[index].getAttribute(attribute);
            },
            setAttributeByHeaderCellIndex: function(index, attribute, value) {
                _this.getHeaderCells()[index].setAttribute(attribute, value);
            },
            setClassNameByHeaderCellIndex: function(index, className) {
                _this.getHeaderCells()[index].classList.add(className);
            },
            removeClassNameByHeaderCellIndex: function(index, className) {
                _this.getHeaderCells()[index].classList.remove(className);
            },
            notifySortAction: function(data) {
                _this.emit((0, $f6cfddedd77988a6$export$4bf9923669ad6c63).SORTED, data, /** shouldBubble */ true);
            },
            getTableContainerHeight: function() {
                var tableContainer = _this.root.querySelector("." + (0, $f6cfddedd77988a6$export$c1c0562ec8379000).TABLE_CONTAINER);
                if (!tableContainer) throw new Error('MDCDataTable: Table container element not found.');
                return tableContainer.getBoundingClientRect().height;
            },
            getTableHeaderHeight: function() {
                var tableHeader = _this.root.querySelector((0, $f6cfddedd77988a6$export$e1252723db1c541).HEADER_ROW);
                if (!tableHeader) throw new Error('MDCDataTable: Table header element not found.');
                return tableHeader.getBoundingClientRect().height;
            },
            setProgressIndicatorStyles: function(styles) {
                var progressIndicator = _this.root.querySelector((0, $f6cfddedd77988a6$export$e1252723db1c541).PROGRESS_INDICATOR);
                if (!progressIndicator) throw new Error('MDCDataTable: Progress indicator element not found.');
                progressIndicator.style.setProperty('height', styles.height);
                progressIndicator.style.setProperty('top', styles.top);
            },
            addClassAtRowIndex: function(rowIndex, className) {
                _this.getRows()[rowIndex].classList.add(className);
            },
            getRowCount: function() {
                return _this.getRows().length;
            },
            getRowElements: function() {
                return [].slice.call(_this.root.querySelectorAll((0, $f6cfddedd77988a6$export$e1252723db1c541).ROW));
            },
            getRowIdAtIndex: function(rowIndex) {
                return _this.getRows()[rowIndex].getAttribute((0, $f6cfddedd77988a6$export$15d6ddc168d35719).ROW_ID);
            },
            getRowIndexByChildElement: function(el) {
                return _this.getRows().indexOf((0, $f4789bcfa326043f$export$ff7f7c97cdce86e)(el, (0, $f6cfddedd77988a6$export$e1252723db1c541).ROW));
            },
            getSelectedRowCount: function() {
                return _this.root.querySelectorAll((0, $f6cfddedd77988a6$export$e1252723db1c541).ROW_SELECTED).length;
            },
            isCheckboxAtRowIndexChecked: function(rowIndex) {
                return _this.rowCheckboxList[rowIndex].checked;
            },
            isHeaderRowCheckboxChecked: function() {
                return _this.headerRowCheckbox.checked;
            },
            isRowsSelectable: function() {
                return !!_this.root.querySelector((0, $f6cfddedd77988a6$export$e1252723db1c541).ROW_CHECKBOX) || !!_this.root.querySelector((0, $f6cfddedd77988a6$export$e1252723db1c541).HEADER_ROW_CHECKBOX);
            },
            notifyRowSelectionChanged: function(data) {
                _this.emit((0, $f6cfddedd77988a6$export$4bf9923669ad6c63).ROW_SELECTION_CHANGED, {
                    row: _this.getRowByIndex(data.rowIndex),
                    rowId: _this.getRowIdByIndex(data.rowIndex),
                    rowIndex: data.rowIndex,
                    selected: data.selected
                }, /** shouldBubble */ true);
            },
            notifySelectedAll: function() {
                _this.emit((0, $f6cfddedd77988a6$export$4bf9923669ad6c63).SELECTED_ALL, {}, /** shouldBubble */ true);
            },
            notifyUnselectedAll: function() {
                _this.emit((0, $f6cfddedd77988a6$export$4bf9923669ad6c63).UNSELECTED_ALL, {}, /** shouldBubble */ true);
            },
            notifyRowClick: function(data) {
                _this.emit((0, $f6cfddedd77988a6$export$4bf9923669ad6c63).ROW_CLICK, data, /** shouldBubble */ true);
            },
            registerHeaderRowCheckbox: function() {
                if (_this.headerRowCheckbox) _this.headerRowCheckbox.destroy();
                var checkboxEl = _this.root.querySelector((0, $f6cfddedd77988a6$export$e1252723db1c541).HEADER_ROW_CHECKBOX);
                _this.headerRowCheckbox = _this.checkboxFactory(checkboxEl);
            },
            registerRowCheckboxes: function() {
                if (_this.rowCheckboxList) _this.rowCheckboxList.forEach(function(checkbox) {
                    checkbox.destroy();
                });
                _this.rowCheckboxList = [];
                _this.getRows().forEach(function(rowEl) {
                    var checkbox = _this.checkboxFactory(rowEl.querySelector((0, $f6cfddedd77988a6$export$e1252723db1c541).ROW_CHECKBOX));
                    _this.rowCheckboxList.push(checkbox);
                });
            },
            removeClassAtRowIndex: function(rowIndex, className) {
                _this.getRows()[rowIndex].classList.remove(className);
            },
            setAttributeAtRowIndex: function(rowIndex, attr, value) {
                _this.getRows()[rowIndex].setAttribute(attr, value);
            },
            setHeaderRowCheckboxChecked: function(checked) {
                _this.headerRowCheckbox.checked = checked;
            },
            setHeaderRowCheckboxIndeterminate: function(indeterminate) {
                _this.headerRowCheckbox.indeterminate = indeterminate;
            },
            setRowCheckboxCheckedAtIndex: function(rowIndex, checked) {
                _this.rowCheckboxList[rowIndex].checked = checked;
            },
            setSortStatusLabelByHeaderCellIndex: function(columnIndex, sortValue) {
                var headerCell = _this.getHeaderCells()[columnIndex];
                var sortStatusLabel = headerCell.querySelector((0, $f6cfddedd77988a6$export$e1252723db1c541).SORT_STATUS_LABEL);
                if (!sortStatusLabel) return;
                sortStatusLabel.textContent = _this.getSortStatusMessageBySortValue(sortValue);
            }
        };
        return new (0, $14b9dedc87673f83$export$9d41abb262ebacf8)(adapter);
    };
    MDCDataTable.prototype.getRowByIndex = function(index) {
        return this.getRows()[index];
    };
    MDCDataTable.prototype.getRowIdByIndex = function(index) {
        return this.getRowByIndex(index).getAttribute((0, $f6cfddedd77988a6$export$15d6ddc168d35719).ROW_ID);
    };
    MDCDataTable.prototype.handleHeaderRowClick = function(event) {
        var headerCell = (0, $f4789bcfa326043f$export$ff7f7c97cdce86e)(event.target, (0, $f6cfddedd77988a6$export$e1252723db1c541).HEADER_CELL_WITH_SORT);
        if (!headerCell) return;
        var columnId = headerCell.getAttribute((0, $f6cfddedd77988a6$export$15d6ddc168d35719).COLUMN_ID);
        var columnIndex = this.getHeaderCells().indexOf(headerCell);
        if (columnIndex === -1) return;
        this.foundation.handleSortAction({
            columnId: columnId,
            columnIndex: columnIndex,
            headerCell: headerCell
        });
    };
    MDCDataTable.prototype.getSortStatusMessageBySortValue = function(sortValue) {
        switch(sortValue){
            case (0, $f6cfddedd77988a6$export$aff26e357adc6917).ASCENDING:
                return (0, $f6cfddedd77988a6$export$defe85febe8b728c).SORTED_IN_ASCENDING;
            case (0, $f6cfddedd77988a6$export$aff26e357adc6917).DESCENDING:
                return (0, $f6cfddedd77988a6$export$defe85febe8b728c).SORTED_IN_DESCENDING;
            default:
                return '';
        }
    };
    MDCDataTable.prototype.getLinearProgressElement = function() {
        var el = this.root.querySelector("." + (0, $f6cfddedd77988a6$export$c1c0562ec8379000).LINEAR_PROGRESS);
        if (!el) throw new Error('MDCDataTable: linear progress element is not found.');
        return el;
    };
    MDCDataTable.prototype.getLinearProgress = function() {
        if (!this.linearProgress) {
            var el = this.getLinearProgressElement();
            this.linearProgress = new (0, $882247d19ca1c993$export$8ef9bec6c14049d)(el);
        }
        return this.linearProgress;
    };
    MDCDataTable.prototype.getRowIdByRowElement = function(rowElement) {
        return rowElement.getAttribute((0, $f6cfddedd77988a6$export$15d6ddc168d35719).ROW_ID);
    };
    return MDCDataTable;
}((0, $0a13a1859770d71d$export$c3670872e5a4af8e));


/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 

/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $5e84edd0d370f6cc$export$19467ce65cc4f055;
(function(CssClasses) {
    CssClasses["RICH"] = "mdc-tooltip--rich";
    CssClasses["SHOWN"] = "mdc-tooltip--shown";
    CssClasses["SHOWING"] = "mdc-tooltip--showing";
    CssClasses["SHOWING_TRANSITION"] = "mdc-tooltip--showing-transition";
    CssClasses["HIDE"] = "mdc-tooltip--hide";
    CssClasses["HIDE_TRANSITION"] = "mdc-tooltip--hide-transition";
    CssClasses["MULTILINE_TOOLTIP"] = "mdc-tooltip--multiline";
    CssClasses["SURFACE"] = "mdc-tooltip__surface";
    CssClasses["SURFACE_ANIMATION"] = "mdc-tooltip__surface-animation";
    CssClasses["TOOLTIP_CARET_TOP"] = "mdc-tooltip__caret-surface-top";
    CssClasses["TOOLTIP_CARET_BOTTOM"] = "mdc-tooltip__caret-surface-bottom";
})($5e84edd0d370f6cc$export$19467ce65cc4f055 || ($5e84edd0d370f6cc$export$19467ce65cc4f055 = {}));
var $5e84edd0d370f6cc$export$1f6c9cc012ebacae = {
    BOUNDED_ANCHOR_GAP: 4,
    UNBOUNDED_ANCHOR_GAP: 8,
    MIN_VIEWPORT_TOOLTIP_THRESHOLD: 8,
    HIDE_DELAY_MS: 600,
    SHOW_DELAY_MS: 500,
    // LINT.IfChange(tooltip-dimensions)
    MIN_HEIGHT: 24,
    MAX_WIDTH: 200,
    // LINT.ThenChange(_tooltip.scss:tooltip-dimensions)
    CARET_INDENTATION: 24,
    // LINT.IfChange(tooltip-anim-scale)
    ANIMATION_SCALE: 0.8
};
var $5e84edd0d370f6cc$export$16bd37df0047a29c = {
    ARIA_EXPANDED: 'aria-expanded',
    ARIA_HASPOPUP: 'aria-haspopup',
    PERSISTENT: 'data-mdc-tooltip-persistent',
    SCROLLABLE_ANCESTOR: 'tooltip-scrollable-ancestor',
    HAS_CARET: 'data-mdc-tooltip-has-caret'
};
var $5e84edd0d370f6cc$export$4bf9923669ad6c63 = {
    HIDDEN: 'MDCTooltip:hidden'
};
/** Enum for possible tooltip positioning relative to its anchor element. */ var $5e84edd0d370f6cc$export$641c5df4f167fdf5;
(function(XPosition) {
    XPosition[XPosition["DETECTED"] = 0] = "DETECTED";
    XPosition[XPosition["START"] = 1] = "START";
    // Note: CENTER is not valid for rich tooltips.
    XPosition[XPosition["CENTER"] = 2] = "CENTER";
    XPosition[XPosition["END"] = 3] = "END";
})($5e84edd0d370f6cc$export$641c5df4f167fdf5 || ($5e84edd0d370f6cc$export$641c5df4f167fdf5 = {}));
var $5e84edd0d370f6cc$export$191747e67c9789ed;
(function(YPosition) {
    YPosition[YPosition["DETECTED"] = 0] = "DETECTED";
    YPosition[YPosition["ABOVE"] = 1] = "ABOVE";
    YPosition[YPosition["BELOW"] = 2] = "BELOW";
})($5e84edd0d370f6cc$export$191747e67c9789ed || ($5e84edd0d370f6cc$export$191747e67c9789ed = {}));
/**
 * Enum for possible anchor boundary types. This determines the gap between the
 * bottom of the anchor and the tooltip element.
 * Bounded anchors have an identifiable boundary (e.g. buttons).
 * Unbounded anchors don't have a visually declared boundary (e.g. plain text).
 */ var $5e84edd0d370f6cc$export$e4ad4a7a8f9088fc;
(function(AnchorBoundaryType) {
    AnchorBoundaryType[AnchorBoundaryType["BOUNDED"] = 0] = "BOUNDED";
    AnchorBoundaryType[AnchorBoundaryType["UNBOUNDED"] = 1] = "UNBOUNDED";
})($5e84edd0d370f6cc$export$e4ad4a7a8f9088fc || ($5e84edd0d370f6cc$export$e4ad4a7a8f9088fc = {}));
var $5e84edd0d370f6cc$export$21c51bc433c16634 = {
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center',
    TOP: 'top',
    BOTTOM: 'bottom'
};
/**
 * Enum for possible positions of a tooltip with caret (this specifies the
 * positioning of the tooltip relative to the anchor -- the position of the
 * caret will follow that of the tooltip). This can NOT be combined with the
 * above X/YPosition options. Naming for the enums follows: (vertical
 * placement)_(horizontal placement).
 */ var $5e84edd0d370f6cc$export$c932156b3d020a8f;
(function(PositionWithCaret) {
    PositionWithCaret[PositionWithCaret["DETECTED"] = 0] = "DETECTED";
    PositionWithCaret[PositionWithCaret["ABOVE_START"] = 1] = "ABOVE_START";
    PositionWithCaret[PositionWithCaret["ABOVE_CENTER"] = 2] = "ABOVE_CENTER";
    PositionWithCaret[PositionWithCaret["ABOVE_END"] = 3] = "ABOVE_END";
    PositionWithCaret[PositionWithCaret["TOP_SIDE_START"] = 4] = "TOP_SIDE_START";
    PositionWithCaret[PositionWithCaret["CENTER_SIDE_START"] = 5] = "CENTER_SIDE_START";
    PositionWithCaret[PositionWithCaret["BOTTOM_SIDE_START"] = 6] = "BOTTOM_SIDE_START";
    PositionWithCaret[PositionWithCaret["TOP_SIDE_END"] = 7] = "TOP_SIDE_END";
    PositionWithCaret[PositionWithCaret["CENTER_SIDE_END"] = 8] = "CENTER_SIDE_END";
    PositionWithCaret[PositionWithCaret["BOTTOM_SIDE_END"] = 9] = "BOTTOM_SIDE_END";
    PositionWithCaret[PositionWithCaret["BELOW_START"] = 10] = "BELOW_START";
    PositionWithCaret[PositionWithCaret["BELOW_CENTER"] = 11] = "BELOW_CENTER";
    PositionWithCaret[PositionWithCaret["BELOW_END"] = 12] = "BELOW_END";
})($5e84edd0d370f6cc$export$c932156b3d020a8f || ($5e84edd0d370f6cc$export$c932156b3d020a8f = {}));
var $5e84edd0d370f6cc$export$f574c92ec84323d9;
(function(YPositionWithCaret) {
    YPositionWithCaret[YPositionWithCaret["ABOVE"] = 1] = "ABOVE";
    YPositionWithCaret[YPositionWithCaret["BELOW"] = 2] = "BELOW";
    YPositionWithCaret[YPositionWithCaret["SIDE_TOP"] = 3] = "SIDE_TOP";
    YPositionWithCaret[YPositionWithCaret["SIDE_CENTER"] = 4] = "SIDE_CENTER";
    YPositionWithCaret[YPositionWithCaret["SIDE_BOTTOM"] = 5] = "SIDE_BOTTOM";
})($5e84edd0d370f6cc$export$f574c92ec84323d9 || ($5e84edd0d370f6cc$export$f574c92ec84323d9 = {}));
var $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0;
(function(XPositionWithCaret) {
    XPositionWithCaret[XPositionWithCaret["START"] = 1] = "START";
    XPositionWithCaret[XPositionWithCaret["CENTER"] = 2] = "CENTER";
    XPositionWithCaret[XPositionWithCaret["END"] = 3] = "END";
    XPositionWithCaret[XPositionWithCaret["SIDE_START"] = 4] = "SIDE_START";
    XPositionWithCaret[XPositionWithCaret["SIDE_END"] = 5] = "SIDE_END";
})($5e84edd0d370f6cc$export$2ccb7d1982d6ddb0 || ($5e84edd0d370f6cc$export$2ccb7d1982d6ddb0 = {}));


/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 



/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * KEY provides normalized string values for keys.
 */ var $52e7243426ddff9a$export$7167c830cefcb6b5 = {
    UNKNOWN: 'Unknown',
    BACKSPACE: 'Backspace',
    ENTER: 'Enter',
    SPACEBAR: 'Spacebar',
    PAGE_UP: 'PageUp',
    PAGE_DOWN: 'PageDown',
    END: 'End',
    HOME: 'Home',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_UP: 'ArrowUp',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_DOWN: 'ArrowDown',
    DELETE: 'Delete',
    ESCAPE: 'Escape',
    TAB: 'Tab'
};
var $52e7243426ddff9a$var$normalizedKeys = new Set();
// IE11 has no support for new Map with iterable so we need to initialize this
// by hand.
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.BACKSPACE);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.ENTER);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.SPACEBAR);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.PAGE_UP);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.PAGE_DOWN);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.END);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.HOME);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_LEFT);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_UP);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_RIGHT);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_DOWN);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.DELETE);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.ESCAPE);
$52e7243426ddff9a$var$normalizedKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.TAB);
var $52e7243426ddff9a$var$KEY_CODE = {
    BACKSPACE: 8,
    ENTER: 13,
    SPACEBAR: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    DELETE: 46,
    ESCAPE: 27,
    TAB: 9
};
var $52e7243426ddff9a$var$mappedKeyCodes = new Map();
// IE11 has no support for new Map with iterable so we need to initialize this
// by hand.
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.BACKSPACE, $52e7243426ddff9a$export$7167c830cefcb6b5.BACKSPACE);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.ENTER, $52e7243426ddff9a$export$7167c830cefcb6b5.ENTER);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.SPACEBAR, $52e7243426ddff9a$export$7167c830cefcb6b5.SPACEBAR);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.PAGE_UP, $52e7243426ddff9a$export$7167c830cefcb6b5.PAGE_UP);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.PAGE_DOWN, $52e7243426ddff9a$export$7167c830cefcb6b5.PAGE_DOWN);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.END, $52e7243426ddff9a$export$7167c830cefcb6b5.END);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.HOME, $52e7243426ddff9a$export$7167c830cefcb6b5.HOME);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.ARROW_LEFT, $52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_LEFT);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.ARROW_UP, $52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_UP);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.ARROW_RIGHT, $52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_RIGHT);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.ARROW_DOWN, $52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_DOWN);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.DELETE, $52e7243426ddff9a$export$7167c830cefcb6b5.DELETE);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.ESCAPE, $52e7243426ddff9a$export$7167c830cefcb6b5.ESCAPE);
$52e7243426ddff9a$var$mappedKeyCodes.set($52e7243426ddff9a$var$KEY_CODE.TAB, $52e7243426ddff9a$export$7167c830cefcb6b5.TAB);
var $52e7243426ddff9a$var$navigationKeys = new Set();
// IE11 has no support for new Set with iterable so we need to initialize this
// by hand.
$52e7243426ddff9a$var$navigationKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.PAGE_UP);
$52e7243426ddff9a$var$navigationKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.PAGE_DOWN);
$52e7243426ddff9a$var$navigationKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.END);
$52e7243426ddff9a$var$navigationKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.HOME);
$52e7243426ddff9a$var$navigationKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_LEFT);
$52e7243426ddff9a$var$navigationKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_UP);
$52e7243426ddff9a$var$navigationKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_RIGHT);
$52e7243426ddff9a$var$navigationKeys.add($52e7243426ddff9a$export$7167c830cefcb6b5.ARROW_DOWN);
function $52e7243426ddff9a$export$e0c709538cb8ae18(evt) {
    var key = evt.key;
    // If the event already has a normalized key, return it
    if ($52e7243426ddff9a$var$normalizedKeys.has(key)) return key;
    // tslint:disable-next-line:deprecation
    var mappedKey = $52e7243426ddff9a$var$mappedKeyCodes.get(evt.keyCode);
    if (mappedKey) return mappedKey;
    return $52e7243426ddff9a$export$7167c830cefcb6b5.UNKNOWN;
}
function $52e7243426ddff9a$export$15e092e359be91e2(evt) {
    return $52e7243426ddff9a$var$navigationKeys.has($52e7243426ddff9a$export$e0c709538cb8ae18(evt));
}



var $778570533f5b6055$var$RICH = (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).RICH, $778570533f5b6055$var$SHOWN = (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).SHOWN, $778570533f5b6055$var$SHOWING = (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).SHOWING, $778570533f5b6055$var$SHOWING_TRANSITION = (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).SHOWING_TRANSITION, $778570533f5b6055$var$HIDE = (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).HIDE, $778570533f5b6055$var$HIDE_TRANSITION = (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).HIDE_TRANSITION, $778570533f5b6055$var$MULTILINE_TOOLTIP = (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).MULTILINE_TOOLTIP;
var $778570533f5b6055$var$AnimationKeys;
(function(AnimationKeys) {
    AnimationKeys["POLL_ANCHOR"] = "poll_anchor";
})($778570533f5b6055$var$AnimationKeys || ($778570533f5b6055$var$AnimationKeys = {}));
// Accessing `window` without a `typeof` check will throw on Node environments.
var $778570533f5b6055$var$HAS_WINDOW = typeof window !== 'undefined';
var $778570533f5b6055$export$ad52ca8d63569c37 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCTooltipFoundation, _super);
    function MDCTooltipFoundation(adapter) {
        var _this = _super.call(this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, MDCTooltipFoundation.defaultAdapter), adapter)) || this;
        _this.tooltipShown = false;
        _this.anchorGap = (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).BOUNDED_ANCHOR_GAP;
        _this.xTooltipPos = (0, $5e84edd0d370f6cc$export$641c5df4f167fdf5).DETECTED;
        _this.yTooltipPos = (0, $5e84edd0d370f6cc$export$191747e67c9789ed).DETECTED;
        _this.tooltipPositionWithCaret = (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).DETECTED;
        // Minimum threshold distance needed between the tooltip and the viewport.
        _this.minViewportTooltipThreshold = (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).MIN_VIEWPORT_TOOLTIP_THRESHOLD;
        _this.hideDelayMs = (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).HIDE_DELAY_MS;
        _this.showDelayMs = (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).SHOW_DELAY_MS;
        _this.anchorRect = null;
        _this.parentRect = null;
        _this.frameId = null;
        _this.hideTimeout = null;
        _this.showTimeout = null;
        _this.addAncestorScrollEventListeners = new Array();
        _this.removeAncestorScrollEventListeners = new Array();
        _this.animFrame = new (0, $22ecda001003cf6d$export$1f3d5b43727c648a)();
        _this.anchorBlurHandler = function(evt) {
            _this.handleAnchorBlur(evt);
        };
        _this.documentClickHandler = function(evt) {
            _this.handleDocumentClick(evt);
        };
        _this.documentKeydownHandler = function(evt) {
            _this.handleKeydown(evt);
        };
        _this.tooltipMouseEnterHandler = function() {
            _this.handleTooltipMouseEnter();
        };
        _this.tooltipMouseLeaveHandler = function() {
            _this.handleTooltipMouseLeave();
        };
        _this.richTooltipFocusOutHandler = function(evt) {
            _this.handleRichTooltipFocusOut(evt);
        };
        _this.windowScrollHandler = function() {
            _this.handleWindowScrollEvent();
        };
        _this.windowResizeHandler = function() {
            _this.handleWindowChangeEvent();
        };
        return _this;
    }
    Object.defineProperty(MDCTooltipFoundation, "defaultAdapter", {
        get: function() {
            return {
                getAttribute: function() {
                    return null;
                },
                setAttribute: function() {
                    return undefined;
                },
                removeAttribute: function() {
                    return undefined;
                },
                addClass: function() {
                    return undefined;
                },
                hasClass: function() {
                    return false;
                },
                removeClass: function() {
                    return undefined;
                },
                getComputedStyleProperty: function() {
                    return '';
                },
                setStyleProperty: function() {
                    return undefined;
                },
                setSurfaceAnimationStyleProperty: function() {
                    return undefined;
                },
                getViewportWidth: function() {
                    return 0;
                },
                getViewportHeight: function() {
                    return 0;
                },
                getTooltipSize: function() {
                    return {
                        width: 0,
                        height: 0
                    };
                },
                getAnchorBoundingRect: function() {
                    return {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        width: 0,
                        height: 0
                    };
                },
                getParentBoundingRect: function() {
                    return {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        width: 0,
                        height: 0
                    };
                },
                getAnchorAttribute: function() {
                    return null;
                },
                setAnchorAttribute: function() {
                    return null;
                },
                isRTL: function() {
                    return false;
                },
                anchorContainsElement: function() {
                    return false;
                },
                tooltipContainsElement: function() {
                    return false;
                },
                focusAnchorElement: function() {
                    return undefined;
                },
                registerEventHandler: function() {
                    return undefined;
                },
                deregisterEventHandler: function() {
                    return undefined;
                },
                registerAnchorEventHandler: function() {
                    return undefined;
                },
                deregisterAnchorEventHandler: function() {
                    return undefined;
                },
                registerDocumentEventHandler: function() {
                    return undefined;
                },
                deregisterDocumentEventHandler: function() {
                    return undefined;
                },
                registerWindowEventHandler: function() {
                    return undefined;
                },
                deregisterWindowEventHandler: function() {
                    return undefined;
                },
                notifyHidden: function() {
                    return undefined;
                },
                getTooltipCaretBoundingRect: function() {
                    return {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        width: 0,
                        height: 0
                    };
                },
                setTooltipCaretStyle: function() {
                    return undefined;
                },
                clearTooltipCaretStyles: function() {
                    return undefined;
                },
                getActiveElement: function() {
                    return null;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    MDCTooltipFoundation.prototype.init = function() {
        this.richTooltip = this.adapter.hasClass($778570533f5b6055$var$RICH);
        this.persistentTooltip = this.adapter.getAttribute((0, $5e84edd0d370f6cc$export$16bd37df0047a29c).PERSISTENT) === 'true';
        this.interactiveTooltip = !!this.adapter.getAnchorAttribute((0, $5e84edd0d370f6cc$export$16bd37df0047a29c).ARIA_EXPANDED) && this.adapter.getAnchorAttribute((0, $5e84edd0d370f6cc$export$16bd37df0047a29c).ARIA_HASPOPUP) === 'dialog';
        this.hasCaret = this.richTooltip && this.adapter.getAttribute((0, $5e84edd0d370f6cc$export$16bd37df0047a29c).HAS_CARET) === 'true';
    };
    MDCTooltipFoundation.prototype.isShown = function() {
        return this.tooltipShown;
    };
    MDCTooltipFoundation.prototype.isRich = function() {
        return this.richTooltip;
    };
    MDCTooltipFoundation.prototype.isPersistent = function() {
        return this.persistentTooltip;
    };
    MDCTooltipFoundation.prototype.handleAnchorMouseEnter = function() {
        var _this = this;
        if (this.tooltipShown) // Covers the instance where a user hovers over the anchor to reveal the
        // tooltip, and then quickly navigates away and then back to the anchor.
        // The tooltip should stay visible without animating out and then back in
        // again.
        this.show();
        else {
            // clearHideTimeout here since handleAnchorMouseLeave sets a hideTimeout
            // and that can execute before the showTimeout executes, resulting in hide
            // being called and the showTimeout set below to be cleared.
            this.clearHideTimeout();
            this.showTimeout = setTimeout(function() {
                _this.show();
            }, this.showDelayMs);
        }
    };
    MDCTooltipFoundation.prototype.handleAnchorTouchstart = function() {
        var _this = this;
        this.showTimeout = setTimeout(function() {
            _this.show();
        }, this.showDelayMs);
        // Prevent a context menu from appearing if user is long-pressing on a
        // tooltip anchor.
        this.adapter.registerWindowEventHandler('contextmenu', this.preventContextMenuOnLongTouch);
    };
    MDCTooltipFoundation.prototype.preventContextMenuOnLongTouch = function(evt) {
        evt.preventDefault();
    };
    MDCTooltipFoundation.prototype.handleAnchorTouchend = function() {
        this.clearShowTimeout();
        // Only remove the 'contextmenu' listener if the tooltip is not shown. When
        // the tooltip *is* shown, listener is removed in the close method.
        if (!this.isShown()) this.adapter.deregisterWindowEventHandler('contextmenu', this.preventContextMenuOnLongTouch);
    };
    MDCTooltipFoundation.prototype.handleAnchorFocus = function(evt) {
        var _this = this;
        // TODO(b/157075286): Need to add some way to distinguish keyboard
        // navigation focus events from other focus events, and only show the
        // tooltip on the former of these events.
        var relatedTarget = evt.relatedTarget;
        var tooltipContainsRelatedTarget = relatedTarget instanceof HTMLElement && this.adapter.tooltipContainsElement(relatedTarget);
        // Do not show tooltip if the previous focus was on a tooltip element. This
        // occurs when a rich tooltip is closed and focus is restored to the anchor
        // or when user tab-navigates back into the anchor from the rich tooltip.
        if (tooltipContainsRelatedTarget) return;
        this.showTimeout = setTimeout(function() {
            _this.show();
        }, this.showDelayMs);
    };
    MDCTooltipFoundation.prototype.handleAnchorMouseLeave = function() {
        var _this = this;
        this.clearShowTimeout();
        this.hideTimeout = setTimeout(function() {
            _this.hide();
        }, this.hideDelayMs);
    };
    MDCTooltipFoundation.prototype.handleAnchorClick = function() {
        if (this.tooltipShown) this.hide();
        else this.show();
    };
    MDCTooltipFoundation.prototype.handleDocumentClick = function(evt) {
        var anchorOrTooltipContainsTargetElement = evt.target instanceof HTMLElement && (this.adapter.anchorContainsElement(evt.target) || this.adapter.tooltipContainsElement(evt.target));
        // For persistent rich tooltips, we will not hide if:
        // - The click target is within the anchor element. Otherwise, both
        //   the anchor element's click handler and this handler will handle the
        //   click (due to event propagation), resulting in a shown tooltip
        //   being immediately hidden if the tooltip was initially hidden.
        // - The click target is within the tooltip element, since clicks
        //   on the tooltip do not close the tooltip.
        if (this.richTooltip && this.persistentTooltip && anchorOrTooltipContainsTargetElement) return;
        // Hide the tooltip immediately on click.
        this.hide();
    };
    MDCTooltipFoundation.prototype.handleKeydown = function(evt) {
        // Hide the tooltip immediately on ESC key.
        var key = (0, $52e7243426ddff9a$export$e0c709538cb8ae18)(evt);
        if (key === (0, $52e7243426ddff9a$export$7167c830cefcb6b5).ESCAPE) {
            var activeElement = this.adapter.getActiveElement();
            var tooltipContainsActiveElement = activeElement instanceof HTMLElement && this.adapter.tooltipContainsElement(activeElement);
            if (tooltipContainsActiveElement) this.adapter.focusAnchorElement();
            this.hide();
        }
    };
    MDCTooltipFoundation.prototype.handleAnchorBlur = function(evt) {
        if (this.richTooltip) {
            var tooltipContainsRelatedTargetElement = evt.relatedTarget instanceof HTMLElement && this.adapter.tooltipContainsElement(evt.relatedTarget);
            // If focus changed to the tooltip element, don't hide the tooltip.
            if (tooltipContainsRelatedTargetElement) return;
            if (evt.relatedTarget === null && this.interactiveTooltip) // If evt.relatedTarget is null, it is because focus is moving to an
            // element that is not focusable. This should only occur in instances
            // of a screen reader in browse mode/linear navigation mode. If the
            // tooltip is interactive (and so the entire content is not read by
            // the screen reader upon the tooltip being opened), we want to allow
            // users to read the content of the tooltip (and not just the focusable
            // elements).
            return;
        }
        // Hide tooltip immediately on focus change.
        this.hide();
    };
    MDCTooltipFoundation.prototype.handleTooltipMouseEnter = function() {
        this.show();
    };
    MDCTooltipFoundation.prototype.handleTooltipMouseLeave = function() {
        var _this = this;
        this.clearShowTimeout();
        this.hideTimeout = setTimeout(function() {
            _this.hide();
        }, this.hideDelayMs);
    };
    MDCTooltipFoundation.prototype.handleRichTooltipFocusOut = function(evt) {
        var anchorOrTooltipContainsRelatedTargetElement = evt.relatedTarget instanceof HTMLElement && (this.adapter.anchorContainsElement(evt.relatedTarget) || this.adapter.tooltipContainsElement(evt.relatedTarget));
        // If the focus is still within the anchor or the tooltip, do not hide the
        // tooltip.
        if (anchorOrTooltipContainsRelatedTargetElement) return;
        if (evt.relatedTarget === null && this.interactiveTooltip) // If evt.relatedTarget is null, it is because focus is moving to an
        // element that is not focusable. This should only occur in instances
        // of a screen reader in browse mode/linear navigation mode. If the
        // tooltip is interactive (and so the entire content is not read by
        // the screen reader upon the tooltip being opened), we want to allow
        // users to read the content of the tooltip (and not just the focusable
        // elements).
        return;
        this.hide();
    };
    MDCTooltipFoundation.prototype.handleWindowScrollEvent = function() {
        if (this.persistentTooltip) {
            // Persistent tooltips remain visible on user scroll, call appropriate
            // handler to ensure the tooltip remains pinned to the anchor on page
            // scroll.
            this.handleWindowChangeEvent();
            return;
        }
        this.hide();
    };
    /**
     * On window resize or scroll, check the anchor position and size and
     * repostion tooltip if necessary.
     */ MDCTooltipFoundation.prototype.handleWindowChangeEvent = function() {
        var _this = this;
        // Since scroll and resize events can fire at a high rate, we throttle
        // the potential re-positioning of tooltip component using
        // requestAnimationFrame.
        this.animFrame.request($778570533f5b6055$var$AnimationKeys.POLL_ANCHOR, function() {
            _this.repositionTooltipOnAnchorMove();
        });
    };
    MDCTooltipFoundation.prototype.show = function() {
        var e_1, _a;
        var _this = this;
        this.clearHideTimeout();
        this.clearShowTimeout();
        if (this.tooltipShown) return;
        this.tooltipShown = true;
        this.adapter.removeAttribute('aria-hidden');
        if (this.richTooltip) {
            if (this.interactiveTooltip) this.adapter.setAnchorAttribute('aria-expanded', 'true');
            this.adapter.registerEventHandler('focusout', this.richTooltipFocusOutHandler);
        }
        if (!this.persistentTooltip) {
            this.adapter.registerEventHandler('mouseenter', this.tooltipMouseEnterHandler);
            this.adapter.registerEventHandler('mouseleave', this.tooltipMouseLeaveHandler);
        }
        this.adapter.removeClass($778570533f5b6055$var$HIDE);
        this.adapter.addClass($778570533f5b6055$var$SHOWING);
        if (this.isTooltipMultiline() && !this.richTooltip) this.adapter.addClass($778570533f5b6055$var$MULTILINE_TOOLTIP);
        this.anchorRect = this.adapter.getAnchorBoundingRect();
        this.parentRect = this.adapter.getParentBoundingRect();
        this.richTooltip ? this.positionRichTooltip() : this.positionPlainTooltip();
        this.adapter.registerAnchorEventHandler('blur', this.anchorBlurHandler);
        this.adapter.registerDocumentEventHandler('click', this.documentClickHandler);
        this.adapter.registerDocumentEventHandler('keydown', this.documentKeydownHandler);
        this.adapter.registerWindowEventHandler('scroll', this.windowScrollHandler);
        this.adapter.registerWindowEventHandler('resize', this.windowResizeHandler);
        try {
            // Register any additional scroll handlers
            for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(this.addAncestorScrollEventListeners), _c = _b.next(); !_c.done; _c = _b.next()){
                var fn = _c.value;
                fn();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.frameId = requestAnimationFrame(function() {
            _this.clearAllAnimationClasses();
            _this.adapter.addClass($778570533f5b6055$var$SHOWN);
            _this.adapter.addClass($778570533f5b6055$var$SHOWING_TRANSITION);
        });
    };
    MDCTooltipFoundation.prototype.hide = function() {
        var e_2, _a;
        this.clearHideTimeout();
        this.clearShowTimeout();
        if (!this.tooltipShown) return;
        if (this.frameId) cancelAnimationFrame(this.frameId);
        this.tooltipShown = false;
        this.adapter.setAttribute('aria-hidden', 'true');
        this.adapter.deregisterEventHandler('focusout', this.richTooltipFocusOutHandler);
        if (this.richTooltip) {
            if (this.interactiveTooltip) this.adapter.setAnchorAttribute('aria-expanded', 'false');
        }
        if (!this.persistentTooltip) {
            this.adapter.deregisterEventHandler('mouseenter', this.tooltipMouseEnterHandler);
            this.adapter.deregisterEventHandler('mouseleave', this.tooltipMouseLeaveHandler);
        }
        this.clearAllAnimationClasses();
        this.adapter.addClass($778570533f5b6055$var$HIDE);
        this.adapter.addClass($778570533f5b6055$var$HIDE_TRANSITION);
        this.adapter.removeClass($778570533f5b6055$var$SHOWN);
        this.adapter.deregisterAnchorEventHandler('blur', this.anchorBlurHandler);
        this.adapter.deregisterDocumentEventHandler('click', this.documentClickHandler);
        this.adapter.deregisterDocumentEventHandler('keydown', this.documentKeydownHandler);
        this.adapter.deregisterWindowEventHandler('scroll', this.windowScrollHandler);
        this.adapter.deregisterWindowEventHandler('resize', this.windowResizeHandler);
        this.adapter.deregisterWindowEventHandler('contextmenu', this.preventContextMenuOnLongTouch);
        try {
            // Deregister any additional scroll handlers
            for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(this.removeAncestorScrollEventListeners), _c = _b.next(); !_c.done; _c = _b.next()){
                var fn = _c.value;
                fn();
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    MDCTooltipFoundation.prototype.handleTransitionEnd = function() {
        var isHidingTooltip = this.adapter.hasClass($778570533f5b6055$var$HIDE);
        this.adapter.removeClass($778570533f5b6055$var$SHOWING);
        this.adapter.removeClass($778570533f5b6055$var$SHOWING_TRANSITION);
        this.adapter.removeClass($778570533f5b6055$var$HIDE);
        this.adapter.removeClass($778570533f5b6055$var$HIDE_TRANSITION);
        // If handleTransitionEnd is called after hiding the tooltip, the tooltip
        // will have the HIDE class (before calling the adapter removeClass method).
        // If tooltip is now hidden, send a notification that the animation has
        // completed and the tooltip is no longer visible.
        // We don't send a notification of the animation completing if a showTimeout
        // value is set -- this happens when a user triggers a tooltip to be shown
        // while that tooltip is fading. Once this hide transition is completed,
        // that same tooltip will be re-shown.
        if (isHidingTooltip && this.showTimeout === null) this.adapter.notifyHidden();
    };
    MDCTooltipFoundation.prototype.clearAllAnimationClasses = function() {
        this.adapter.removeClass($778570533f5b6055$var$SHOWING_TRANSITION);
        this.adapter.removeClass($778570533f5b6055$var$HIDE_TRANSITION);
    };
    MDCTooltipFoundation.prototype.setTooltipPosition = function(position) {
        var xPos = position.xPos, yPos = position.yPos, withCaretPos = position.withCaretPos;
        if (this.hasCaret && withCaretPos) {
            this.tooltipPositionWithCaret = withCaretPos;
            return;
        }
        if (xPos) this.xTooltipPos = xPos;
        if (yPos) this.yTooltipPos = yPos;
    };
    MDCTooltipFoundation.prototype.setAnchorBoundaryType = function(type) {
        if (type === (0, $5e84edd0d370f6cc$export$e4ad4a7a8f9088fc).UNBOUNDED) this.anchorGap = (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).UNBOUNDED_ANCHOR_GAP;
        else this.anchorGap = (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).BOUNDED_ANCHOR_GAP;
    };
    MDCTooltipFoundation.prototype.setShowDelay = function(delayMs) {
        this.showDelayMs = delayMs;
    };
    MDCTooltipFoundation.prototype.setHideDelay = function(delayMs) {
        this.hideDelayMs = delayMs;
    };
    MDCTooltipFoundation.prototype.isTooltipMultiline = function() {
        var tooltipSize = this.adapter.getTooltipSize();
        return tooltipSize.height > (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).MIN_HEIGHT && tooltipSize.width >= (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).MAX_WIDTH;
    };
    MDCTooltipFoundation.prototype.positionPlainTooltip = function() {
        // A plain tooltip has `fixed` positioning and is placed as an immediate
        // child of the document body. Its positioning is calculated with respect to
        // the viewport.
        var _a = this.calculateTooltipStyles(this.anchorRect), top = _a.top, yTransformOrigin = _a.yTransformOrigin, left = _a.left, xTransformOrigin = _a.xTransformOrigin;
        var transformProperty = $778570533f5b6055$var$HAS_WINDOW ? (0, $d3b9476725b396f0$export$3e3382687f32c044)(window, 'transform') : 'transform';
        this.adapter.setSurfaceAnimationStyleProperty(transformProperty + "-origin", xTransformOrigin + " " + yTransformOrigin);
        this.adapter.setStyleProperty('top', top + "px");
        this.adapter.setStyleProperty('left', left + "px");
    };
    MDCTooltipFoundation.prototype.positionRichTooltip = function() {
        // TODO(b/177686782): Remove width setting when max-content is used to style
        // the rich tooltip.
        var _a, _b, _c, _d;
        // getComputedStyleProperty is used instead of getTooltipSize since
        // getTooltipSize returns the offSetWidth, which includes the border and
        // padding. What we need is the width of the tooltip without border and
        // padding.
        var width = this.adapter.getComputedStyleProperty('width');
        // When rich tooltips are positioned within their parent containers, the
        // tooltip width might be shrunk if it collides with the edge of the parent
        // container. We set the width of the tooltip to prevent this.
        this.adapter.setStyleProperty('width', width);
        var _e = this.hasCaret ? this.calculateTooltipWithCaretStyles(this.anchorRect) : this.calculateTooltipStyles(this.anchorRect), top = _e.top, yTransformOrigin = _e.yTransformOrigin, left = _e.left, xTransformOrigin = _e.xTransformOrigin;
        var transformProperty = $778570533f5b6055$var$HAS_WINDOW ? (0, $d3b9476725b396f0$export$3e3382687f32c044)(window, 'transform') : 'transform';
        this.adapter.setSurfaceAnimationStyleProperty(transformProperty + "-origin", xTransformOrigin + " " + yTransformOrigin);
        // A rich tooltip has `absolute` positioning and is placed as a sibling to
        // the anchor element. Its positioning is calculated with respect to the
        // parent element, and so the values need to be adjusted against the parent
        // element.
        var leftAdjustment = left - ((_b = (_a = this.parentRect) === null || _a === void 0 ? void 0 : _a.left) !== null && _b !== void 0 ? _b : 0);
        var topAdjustment = top - ((_d = (_c = this.parentRect) === null || _c === void 0 ? void 0 : _c.top) !== null && _d !== void 0 ? _d : 0);
        this.adapter.setStyleProperty('top', topAdjustment + "px");
        this.adapter.setStyleProperty('left', leftAdjustment + "px");
    };
    /**
     * Calculates the position of the tooltip. A tooltip will be placed beneath
     * the anchor element and aligned either with the 'start'/'end' edge of the
     * anchor element or the 'center'.
     *
     * Tooltip alignment is selected such that the tooltip maintains a threshold
     * distance away from the viewport (defaulting to 'center' alignment). If the
     * placement of the anchor prevents this threshold distance from being
     * maintained, the tooltip is positioned so that it does not collide with the
     * viewport.
     *
     * Users can specify an alignment, however, if this alignment results in the
     * tooltip colliding with the viewport, this specification is overwritten.
     */ MDCTooltipFoundation.prototype.calculateTooltipStyles = function(anchorRect) {
        if (!anchorRect) return {
            top: 0,
            left: 0
        };
        var tooltipSize = this.adapter.getTooltipSize();
        var top = this.calculateYTooltipDistance(anchorRect, tooltipSize.height);
        var left = this.calculateXTooltipDistance(anchorRect, tooltipSize.width);
        return {
            top: top.distance,
            yTransformOrigin: top.yTransformOrigin,
            left: left.distance,
            xTransformOrigin: left.xTransformOrigin
        };
    };
    /**
     * Calculates the `left` distance for the tooltip.
     * Returns the distance value and a string indicating the x-axis transform-
     * origin that should be used when animating the tooltip.
     */ MDCTooltipFoundation.prototype.calculateXTooltipDistance = function(anchorRect, tooltipWidth) {
        var isLTR = !this.adapter.isRTL();
        var startPos, endPos, centerPos;
        var startTransformOrigin, endTransformOrigin;
        if (this.richTooltip) {
            startPos = isLTR ? anchorRect.left - tooltipWidth : anchorRect.right;
            endPos = isLTR ? anchorRect.right : anchorRect.left - tooltipWidth;
            startTransformOrigin = isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT;
            endTransformOrigin = isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT;
        } else {
            startPos = isLTR ? anchorRect.left : anchorRect.right - tooltipWidth;
            endPos = isLTR ? anchorRect.right - tooltipWidth : anchorRect.left;
            centerPos = anchorRect.left + (anchorRect.width - tooltipWidth) / 2;
            startTransformOrigin = isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT;
            endTransformOrigin = isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT;
        }
        var positionOptions = this.richTooltip ? this.determineValidPositionOptions(startPos, endPos) : // For plain tooltips, centerPos is defined
        this.determineValidPositionOptions(centerPos, startPos, endPos);
        if (this.xTooltipPos === (0, $5e84edd0d370f6cc$export$641c5df4f167fdf5).START && positionOptions.has(startPos)) return {
            distance: startPos,
            xTransformOrigin: startTransformOrigin
        };
        if (this.xTooltipPos === (0, $5e84edd0d370f6cc$export$641c5df4f167fdf5).END && positionOptions.has(endPos)) return {
            distance: endPos,
            xTransformOrigin: endTransformOrigin
        };
        if (this.xTooltipPos === (0, $5e84edd0d370f6cc$export$641c5df4f167fdf5).CENTER && positionOptions.has(centerPos)) // This code path is only executed if calculating the distance for plain
        // tooltips. In this instance, centerPos will always be defined, so we can
        // safely assert that the returned value is non-null/undefined.
        return {
            distance: centerPos,
            xTransformOrigin: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).CENTER
        };
        // If no user position is supplied, rich tooltips default to end pos, then
        // start position. Plain tooltips default to center, start, then end.
        var possiblePositions = this.richTooltip ? [
            {
                distance: endPos,
                xTransformOrigin: endTransformOrigin
            },
            {
                distance: startPos,
                xTransformOrigin: startTransformOrigin
            }
        ] : [
            {
                distance: centerPos,
                xTransformOrigin: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).CENTER
            },
            {
                distance: startPos,
                xTransformOrigin: startTransformOrigin
            },
            {
                distance: endPos,
                xTransformOrigin: endTransformOrigin
            }
        ];
        var validPosition = possiblePositions.find(function(_a) {
            var distance = _a.distance;
            return positionOptions.has(distance);
        });
        if (validPosition) return validPosition;
        // Indicates that all potential positions would result in the tooltip
        // colliding with the viewport. This would only occur when the anchor
        // element itself collides with the viewport, or the viewport is very
        // narrow. In this case, we allow the tooltip to be mis-aligned from the
        // anchor element.
        if (anchorRect.left < 0) return {
            distance: this.minViewportTooltipThreshold,
            xTransformOrigin: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT
        };
        else {
            var viewportWidth = this.adapter.getViewportWidth();
            var distance = viewportWidth - (tooltipWidth + this.minViewportTooltipThreshold);
            return {
                distance: distance,
                xTransformOrigin: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT
            };
        }
    };
    /**
     * Given the values for the horizontal alignments of the tooltip, calculates
     * which of these options would result in the tooltip maintaining the required
     * threshold distance vs which would result in the tooltip staying within the
     * viewport.
     *
     * A Set of values is returned holding the distances that would honor the
     * above requirements. Following the logic for determining the tooltip
     * position, if all alignments violate the threshold, then the returned Set
     * contains values that keep the tooltip within the viewport.
     */ MDCTooltipFoundation.prototype.determineValidPositionOptions = function() {
        var e_3, _a;
        var positions = [];
        for(var _i = 0; _i < arguments.length; _i++)positions[_i] = arguments[_i];
        var posWithinThreshold = new Set();
        var posWithinViewport = new Set();
        try {
            for(var positions_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(positions), positions_1_1 = positions_1.next(); !positions_1_1.done; positions_1_1 = positions_1.next()){
                var position = positions_1_1.value;
                if (this.positionHonorsViewportThreshold(position)) posWithinThreshold.add(position);
                else if (this.positionDoesntCollideWithViewport(position)) posWithinViewport.add(position);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (positions_1_1 && !positions_1_1.done && (_a = positions_1.return)) _a.call(positions_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return posWithinThreshold.size ? posWithinThreshold : posWithinViewport;
    };
    MDCTooltipFoundation.prototype.positionHonorsViewportThreshold = function(leftPos) {
        var viewportWidth = this.adapter.getViewportWidth();
        var tooltipWidth = this.adapter.getTooltipSize().width;
        return leftPos + tooltipWidth <= viewportWidth - this.minViewportTooltipThreshold && leftPos >= this.minViewportTooltipThreshold;
    };
    MDCTooltipFoundation.prototype.positionDoesntCollideWithViewport = function(leftPos) {
        var viewportWidth = this.adapter.getViewportWidth();
        var tooltipWidth = this.adapter.getTooltipSize().width;
        return leftPos + tooltipWidth <= viewportWidth && leftPos >= 0;
    };
    /**
     * Calculates the `top` distance for the tooltip.
     * Returns the distance value and a string indicating the y-axis transform-
     * origin that should be used when animating the tooltip.
     */ MDCTooltipFoundation.prototype.calculateYTooltipDistance = function(anchorRect, tooltipHeight) {
        var belowYPos = anchorRect.bottom + this.anchorGap;
        var aboveYPos = anchorRect.top - (this.anchorGap + tooltipHeight);
        var yPositionOptions = this.determineValidYPositionOptions(aboveYPos, belowYPos);
        if (this.yTooltipPos === (0, $5e84edd0d370f6cc$export$191747e67c9789ed).ABOVE && yPositionOptions.has(aboveYPos)) return {
            distance: aboveYPos,
            yTransformOrigin: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).BOTTOM
        };
        else if (this.yTooltipPos === (0, $5e84edd0d370f6cc$export$191747e67c9789ed).BELOW && yPositionOptions.has(belowYPos)) return {
            distance: belowYPos,
            yTransformOrigin: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).TOP
        };
        if (yPositionOptions.has(belowYPos)) return {
            distance: belowYPos,
            yTransformOrigin: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).TOP
        };
        if (yPositionOptions.has(aboveYPos)) return {
            distance: aboveYPos,
            yTransformOrigin: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).BOTTOM
        };
        // Indicates that all potential positions would result in the tooltip
        // colliding with the viewport. This would only occur when the viewport is
        // very short.
        return {
            distance: belowYPos,
            yTransformOrigin: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).TOP
        };
    };
    /**
     * Given the values for above/below alignment of the tooltip, calculates
     * which of these options would result in the tooltip maintaining the required
     * threshold distance vs which would result in the tooltip staying within the
     * viewport.
     *
     * A Set of values is returned holding the distances that would honor the
     * above requirements. Following the logic for determining the tooltip
     * position, if all possible alignments violate the threshold, then the
     * returned Set contains values that keep the tooltip within the viewport.
     */ MDCTooltipFoundation.prototype.determineValidYPositionOptions = function(aboveAnchorPos, belowAnchorPos) {
        var posWithinThreshold = new Set();
        var posWithinViewport = new Set();
        if (this.yPositionHonorsViewportThreshold(aboveAnchorPos)) posWithinThreshold.add(aboveAnchorPos);
        else if (this.yPositionDoesntCollideWithViewport(aboveAnchorPos)) posWithinViewport.add(aboveAnchorPos);
        if (this.yPositionHonorsViewportThreshold(belowAnchorPos)) posWithinThreshold.add(belowAnchorPos);
        else if (this.yPositionDoesntCollideWithViewport(belowAnchorPos)) posWithinViewport.add(belowAnchorPos);
        return posWithinThreshold.size ? posWithinThreshold : posWithinViewport;
    };
    MDCTooltipFoundation.prototype.yPositionHonorsViewportThreshold = function(yPos) {
        var viewportHeight = this.adapter.getViewportHeight();
        var tooltipHeight = this.adapter.getTooltipSize().height;
        return yPos + tooltipHeight + this.minViewportTooltipThreshold <= viewportHeight && yPos >= this.minViewportTooltipThreshold;
    };
    MDCTooltipFoundation.prototype.yPositionDoesntCollideWithViewport = function(yPos) {
        var viewportHeight = this.adapter.getViewportHeight();
        var tooltipHeight = this.adapter.getTooltipSize().height;
        return yPos + tooltipHeight <= viewportHeight && yPos >= 0;
    };
    MDCTooltipFoundation.prototype.calculateTooltipWithCaretStyles = function(anchorRect) {
        // Prior to grabbing the caret bounding rect, we clear all styles set on the
        // caret. This will ensure the width/height is consistent (since we rotate
        // the caret 90deg in some positions which would result in the height and
        // width bounding rect measurements flipping).
        this.adapter.clearTooltipCaretStyles();
        var caretSize = this.adapter.getTooltipCaretBoundingRect();
        if (!anchorRect || !caretSize) return {
            position: (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).DETECTED,
            top: 0,
            left: 0
        };
        // The caret for the rich tooltip is created by rotating/skewing/scaling
        // square div into a diamond shape and then hiding half of it so it looks
        // like a triangle. We use the boundingClientRect to calculate the
        // width/height of the element after the transforms (to the caret) have been
        // applied. Since the full tooltip is scaled by 0.8 for the entrance
        // animation, we divide by this value to retrieve the actual caret
        // dimensions.
        var caretWidth = caretSize.width / (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).ANIMATION_SCALE;
        // Since we hide half of caret, we divide the returned DOMRect height
        // by 2.
        var caretHeight = caretSize.height / (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).ANIMATION_SCALE / 2;
        var tooltipSize = this.adapter.getTooltipSize();
        var yOptions = this.calculateYWithCaretDistanceOptions(anchorRect, tooltipSize.height, {
            caretWidth: caretWidth,
            caretHeight: caretHeight
        });
        var xOptions = this.calculateXWithCaretDistanceOptions(anchorRect, tooltipSize.width, {
            caretWidth: caretWidth,
            caretHeight: caretHeight
        });
        var positionOptions = this.validateTooltipWithCaretDistances(yOptions, xOptions);
        if (positionOptions.size < 1) positionOptions = this.generateBackupPositionOption(anchorRect, tooltipSize, {
            caretWidth: caretWidth,
            caretHeight: caretHeight
        });
        var _a = this.determineTooltipWithCaretDistance(positionOptions), position = _a.position, xDistance = _a.xDistance, yDistance = _a.yDistance;
        // After determining the position of the tooltip relative to the anchor,
        // place the caret in the corresponding position and retrieve the necessary
        // x/y transform origins needed to properly animate the tooltip entrance.
        var _b = this.setCaretPositionStyles(position, {
            caretWidth: caretWidth,
            caretHeight: caretHeight
        }), yTransformOrigin = _b.yTransformOrigin, xTransformOrigin = _b.xTransformOrigin;
        return {
            yTransformOrigin: yTransformOrigin,
            xTransformOrigin: xTransformOrigin,
            top: yDistance,
            left: xDistance
        };
    };
    MDCTooltipFoundation.prototype.calculateXWithCaretDistanceOptions = function(anchorRect, tooltipWidth, caretSize) {
        var caretWidth = caretSize.caretWidth, caretHeight = caretSize.caretHeight;
        var isLTR = !this.adapter.isRTL();
        var anchorMidpoint = anchorRect.left + anchorRect.width / 2;
        var sideLeftAligned = anchorRect.left - (tooltipWidth + this.anchorGap + caretHeight);
        var sideRightAligned = anchorRect.right + this.anchorGap + caretHeight;
        var sideStartPos = isLTR ? sideLeftAligned : sideRightAligned;
        var sideEndPos = isLTR ? sideRightAligned : sideLeftAligned;
        var verticalLeftAligned = anchorMidpoint - ((0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).CARET_INDENTATION + caretWidth / 2);
        var verticalRightAligned = anchorMidpoint - (tooltipWidth - (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).CARET_INDENTATION - caretWidth / 2);
        var verticalStartPos = isLTR ? verticalLeftAligned : verticalRightAligned;
        var verticalEndPos = isLTR ? verticalRightAligned : verticalLeftAligned;
        var verticalCenterPos = anchorMidpoint - tooltipWidth / 2;
        var possiblePositionsMap = new Map([
            [
                (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).START,
                verticalStartPos
            ],
            [
                (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).CENTER,
                verticalCenterPos
            ],
            [
                (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).END,
                verticalEndPos
            ],
            [
                (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_END,
                sideEndPos
            ],
            [
                (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_START,
                sideStartPos
            ]
        ]);
        return possiblePositionsMap;
    };
    MDCTooltipFoundation.prototype.calculateYWithCaretDistanceOptions = function(anchorRect, tooltipHeight, caretSize) {
        var caretWidth = caretSize.caretWidth, caretHeight = caretSize.caretHeight;
        var anchorMidpoint = anchorRect.top + anchorRect.height / 2;
        var belowYPos = anchorRect.bottom + this.anchorGap + caretHeight;
        var aboveYPos = anchorRect.top - (this.anchorGap + tooltipHeight + caretHeight);
        var sideTopYPos = anchorMidpoint - ((0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).CARET_INDENTATION + caretWidth / 2);
        var sideCenterYPos = anchorMidpoint - tooltipHeight / 2;
        var sideBottomYPos = anchorMidpoint - (tooltipHeight - (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).CARET_INDENTATION - caretWidth / 2);
        var possiblePositionsMap = new Map([
            [
                (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).ABOVE,
                aboveYPos
            ],
            [
                (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).BELOW,
                belowYPos
            ],
            [
                (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).SIDE_TOP,
                sideTopYPos
            ],
            [
                (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).SIDE_CENTER,
                sideCenterYPos
            ],
            [
                (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).SIDE_BOTTOM,
                sideBottomYPos
            ]
        ]);
        return possiblePositionsMap;
    };
    MDCTooltipFoundation.prototype.repositionTooltipOnAnchorMove = function() {
        var newAnchorRect = this.adapter.getAnchorBoundingRect();
        if (!newAnchorRect || !this.anchorRect) return;
        if (newAnchorRect.top !== this.anchorRect.top || newAnchorRect.left !== this.anchorRect.left || newAnchorRect.height !== this.anchorRect.height || newAnchorRect.width !== this.anchorRect.width) {
            this.anchorRect = newAnchorRect;
            this.parentRect = this.adapter.getParentBoundingRect();
            this.richTooltip ? this.positionRichTooltip() : this.positionPlainTooltip();
        }
    };
    /**
     * Given a list of x/y position options for a rich tooltip with caret, checks
     * if valid x/y combinations of these position options are either within the
     * viewport threshold, or simply within the viewport. Returns a map with the
     * valid x/y position combinations that all either honor the viewport
     * threshold or are simply inside within the viewport.
     */ MDCTooltipFoundation.prototype.validateTooltipWithCaretDistances = function(yOptions, xOptions) {
        var e_4, _a, e_5, _b, e_6, _c;
        var posWithinThreshold = new Map();
        var posWithinViewport = new Map();
        // If a tooltip has a caret, not all combinations of YPositionWithCarets and
        // XPositionWithCarets are possible. Because of this we only check the
        // validity of a given XPositionWithCaret if a potential corresponding
        // YPositionWithCaret is valid.
        var validMappings = new Map([
            [
                (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).ABOVE,
                [
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).START,
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).CENTER,
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).END
                ]
            ],
            [
                (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).BELOW,
                [
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).START,
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).CENTER,
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).END
                ]
            ],
            [
                (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).SIDE_TOP,
                [
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_START,
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_END
                ]
            ],
            [
                (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).SIDE_CENTER,
                [
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_START,
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_END
                ]
            ],
            [
                (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).SIDE_BOTTOM,
                [
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_START,
                    (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_END
                ]
            ]
        ]);
        try {
            // TODO(b/227383292): Handle instances where one direction can fit in
            // in the viewport (whether honoring the threshold or not), and the
            // other direction does not.
            for(var _d = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(validMappings.keys()), _e = _d.next(); !_e.done; _e = _d.next()){
                var y = _e.value;
                var yDistance = yOptions.get(y);
                if (this.yPositionHonorsViewportThreshold(yDistance)) try {
                    for(var _f = (e_5 = void 0, (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(validMappings.get(y))), _g = _f.next(); !_g.done; _g = _f.next()){
                        var x = _g.value;
                        var xDistance = xOptions.get(x);
                        if (this.positionHonorsViewportThreshold(xDistance)) {
                            var caretPositionName = this.caretPositionOptionsMapping(x, y);
                            posWithinThreshold.set(caretPositionName, {
                                xDistance: xDistance,
                                yDistance: yDistance
                            });
                        }
                    }
                } catch (e_5_1) {
                    e_5 = {
                        error: e_5_1
                    };
                } finally{
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    } finally{
                        if (e_5) throw e_5.error;
                    }
                }
                if (this.yPositionDoesntCollideWithViewport(yDistance)) try {
                    for(var _h = (e_6 = void 0, (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(validMappings.get(y))), _j = _h.next(); !_j.done; _j = _h.next()){
                        var x = _j.value;
                        var xDistance = xOptions.get(x);
                        if (this.positionDoesntCollideWithViewport(xDistance)) {
                            var caretPositionName = this.caretPositionOptionsMapping(x, y);
                            posWithinViewport.set(caretPositionName, {
                                xDistance: xDistance,
                                yDistance: yDistance
                            });
                        }
                    }
                } catch (e_6_1) {
                    e_6 = {
                        error: e_6_1
                    };
                } finally{
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    } finally{
                        if (e_6) throw e_6.error;
                    }
                }
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        return posWithinThreshold.size ? posWithinThreshold : posWithinViewport;
    };
    /**
     * Method for generating a horizontal and vertical position for the tooltip if
     * all other calculated values are considered invalid. This would only happen
     * in situations of very small viewports/large tooltips.
     */ MDCTooltipFoundation.prototype.generateBackupPositionOption = function(anchorRect, tooltipSize, caretSize) {
        var isLTR = !this.adapter.isRTL();
        var xDistance;
        var xPos;
        if (anchorRect.left < 0) {
            xDistance = this.minViewportTooltipThreshold + caretSize.caretHeight;
            xPos = isLTR ? (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).END : (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).START;
        } else {
            var viewportWidth = this.adapter.getViewportWidth();
            xDistance = viewportWidth - (tooltipSize.width + this.minViewportTooltipThreshold + caretSize.caretHeight);
            xPos = isLTR ? (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).START : (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).END;
        }
        var yDistance;
        var yPos;
        if (anchorRect.top < 0) {
            yDistance = this.minViewportTooltipThreshold + caretSize.caretHeight;
            yPos = (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).BELOW;
        } else {
            var viewportHeight = this.adapter.getViewportHeight();
            yDistance = viewportHeight - (tooltipSize.height + this.minViewportTooltipThreshold + caretSize.caretHeight);
            yPos = (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).ABOVE;
        }
        var caretPositionName = this.caretPositionOptionsMapping(xPos, yPos);
        return new Map([
            [
                caretPositionName,
                {
                    xDistance: xDistance,
                    yDistance: yDistance
                }
            ]
        ]);
    };
    /**
     * Given a list of valid position options for a rich tooltip with caret,
     * returns the option that should be used.
     */ MDCTooltipFoundation.prototype.determineTooltipWithCaretDistance = function(options) {
        if (options.has(this.tooltipPositionWithCaret)) {
            var tooltipPos = options.get(this.tooltipPositionWithCaret);
            return {
                position: this.tooltipPositionWithCaret,
                xDistance: tooltipPos.xDistance,
                yDistance: tooltipPos.yDistance
            };
        }
        var orderPref = [
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).ABOVE_START,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).ABOVE_CENTER,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).ABOVE_END,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).TOP_SIDE_START,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).CENTER_SIDE_START,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BOTTOM_SIDE_START,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).TOP_SIDE_END,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).CENTER_SIDE_END,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BOTTOM_SIDE_END,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BELOW_START,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BELOW_CENTER,
            (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BELOW_END
        ];
        // Before calling this method we check whether or not the "options" param
        // is empty and invoke a different method. We, therefore, can be certain
        // that "validPosition" will always be defined.
        var validPosition = orderPref.find(function(pos) {
            return options.has(pos);
        });
        var pos = options.get(validPosition);
        return {
            position: validPosition,
            xDistance: pos.xDistance,
            yDistance: pos.yDistance
        };
    };
    /**
     * Returns the corresponding PositionWithCaret enum for the proivded
     * XPositionWithCaret and YPositionWithCaret enums. This mapping exists so our
     * public API accepts only PositionWithCaret enums (as all combinations of
     * XPositionWithCaret and YPositionWithCaret are not valid), but internally we
     * can calculate the X and Y positions of a rich tooltip with caret
     * separately.
     */ MDCTooltipFoundation.prototype.caretPositionOptionsMapping = function(xPos, yPos) {
        switch(yPos){
            case (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).ABOVE:
                if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).START) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).ABOVE_START;
                else if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).CENTER) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).ABOVE_CENTER;
                else if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).END) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).ABOVE_END;
                break;
            case (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).BELOW:
                if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).START) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BELOW_START;
                else if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).CENTER) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BELOW_CENTER;
                else if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).END) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BELOW_END;
                break;
            case (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).SIDE_TOP:
                if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_START) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).TOP_SIDE_START;
                else if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_END) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).TOP_SIDE_END;
                break;
            case (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).SIDE_CENTER:
                if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_START) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).CENTER_SIDE_START;
                else if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_END) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).CENTER_SIDE_END;
                break;
            case (0, $5e84edd0d370f6cc$export$f574c92ec84323d9).SIDE_BOTTOM:
                if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_START) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BOTTOM_SIDE_START;
                else if (xPos === (0, $5e84edd0d370f6cc$export$2ccb7d1982d6ddb0).SIDE_END) return (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BOTTOM_SIDE_END;
                break;
            default:
                break;
        }
        throw new Error("MDCTooltipFoundation: Invalid caret position of " + xPos + ", " + yPos);
    };
    /**
     * Given a PositionWithCaret, applies the correct styles to the caret element
     * so that it is positioned properly on the rich tooltip.
     * Returns the x and y positions of the caret, to be used as the
     * transform-origin on the tooltip itself for entrance animations.
     */ MDCTooltipFoundation.prototype.setCaretPositionStyles = function(position, caretSize) {
        var e_7, _a;
        var values = this.calculateCaretPositionOnTooltip(position, caretSize);
        if (!values) return {
            yTransformOrigin: 0,
            xTransformOrigin: 0
        };
        // Prior to setting the caret position styles, clear any previous styles
        // set. This is necessary as all position options do not use the same
        // properties (e.g. using 'left' or 'right') and so old style properties
        // might not get overridden, causing misplaced carets.
        this.adapter.clearTooltipCaretStyles();
        this.adapter.setTooltipCaretStyle(values.yAlignment, values.yAxisPx);
        this.adapter.setTooltipCaretStyle(values.xAlignment, values.xAxisPx);
        // Value of scaleX is cos(skew), Math.cos() expects radians though, so we
        // must first convert the skew value (which is in degrees) to radians.
        var skewRadians = values.skew * (Math.PI / 180);
        var scaleX = Math.cos(skewRadians);
        this.adapter.setTooltipCaretStyle('transform', "rotate(" + values.rotation + "deg) skewY(" + values.skew + "deg) scaleX(" + scaleX + ")");
        this.adapter.setTooltipCaretStyle('transform-origin', values.xAlignment + " " + values.yAlignment);
        try {
            for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(values.caretCorners), _c = _b.next(); !_c.done; _c = _b.next()){
                var corner = _c.value;
                this.adapter.setTooltipCaretStyle(corner, '0');
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return {
            yTransformOrigin: values.yTransformOrigin,
            xTransformOrigin: values.xTransformOrigin
        };
    };
    /**
     * Given a PositionWithCaret, determines the correct styles to position the
     * caret properly on the rich tooltip.
     */ MDCTooltipFoundation.prototype.calculateCaretPositionOnTooltip = function(tooltipPos, caretSize) {
        var isLTR = !this.adapter.isRTL();
        var tooltipWidth = this.adapter.getComputedStyleProperty('width');
        var tooltipHeight = this.adapter.getComputedStyleProperty('height');
        if (!tooltipWidth || !tooltipHeight || !caretSize) return;
        var midpointWidth = "calc((" + tooltipWidth + " - " + caretSize.caretWidth + "px) / 2)";
        var midpointHeight = "calc((" + tooltipHeight + " - " + caretSize.caretWidth + "px) / 2)";
        var flushWithEdge = '0';
        var indentedFromEdge = (0, $5e84edd0d370f6cc$export$1f6c9cc012ebacae).CARET_INDENTATION + "px";
        var indentedFromWidth = "calc(" + tooltipWidth + " - " + indentedFromEdge + ")";
        var indentedFromHeight = "calc(" + tooltipHeight + " - " + indentedFromEdge + ")";
        var verticalRotation = 35;
        var horizontalRotation = Math.abs(90 - verticalRotation);
        var bottomRightTopLeftBorderRadius = [
            'border-bottom-right-radius',
            'border-top-left-radius'
        ];
        var bottomLeftTopRightBorderRadius = [
            'border-bottom-left-radius',
            'border-top-right-radius'
        ];
        var skewDeg = 20;
        switch(tooltipPos){
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BELOW_CENTER:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).TOP,
                    xAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT,
                    yAxisPx: flushWithEdge,
                    xAxisPx: midpointWidth,
                    rotation: -1 * verticalRotation,
                    skew: -1 * skewDeg,
                    xTransformOrigin: midpointWidth,
                    yTransformOrigin: flushWithEdge,
                    caretCorners: bottomRightTopLeftBorderRadius
                };
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BELOW_END:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).TOP,
                    xAlignment: isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT,
                    yAxisPx: flushWithEdge,
                    xAxisPx: indentedFromEdge,
                    rotation: isLTR ? verticalRotation : -1 * verticalRotation,
                    skew: isLTR ? skewDeg : -1 * skewDeg,
                    xTransformOrigin: isLTR ? indentedFromWidth : indentedFromEdge,
                    yTransformOrigin: flushWithEdge,
                    caretCorners: isLTR ? bottomLeftTopRightBorderRadius : bottomRightTopLeftBorderRadius
                };
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BELOW_START:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).TOP,
                    xAlignment: isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT,
                    yAxisPx: flushWithEdge,
                    xAxisPx: indentedFromEdge,
                    rotation: isLTR ? -1 * verticalRotation : verticalRotation,
                    skew: isLTR ? -1 * skewDeg : skewDeg,
                    xTransformOrigin: isLTR ? indentedFromEdge : indentedFromWidth,
                    yTransformOrigin: flushWithEdge,
                    caretCorners: isLTR ? bottomRightTopLeftBorderRadius : bottomLeftTopRightBorderRadius
                };
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).TOP_SIDE_END:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).TOP,
                    xAlignment: isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT,
                    yAxisPx: indentedFromEdge,
                    xAxisPx: flushWithEdge,
                    rotation: isLTR ? horizontalRotation : -1 * horizontalRotation,
                    skew: isLTR ? -1 * skewDeg : skewDeg,
                    xTransformOrigin: isLTR ? flushWithEdge : tooltipWidth,
                    yTransformOrigin: indentedFromEdge,
                    caretCorners: isLTR ? bottomRightTopLeftBorderRadius : bottomLeftTopRightBorderRadius
                };
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).CENTER_SIDE_END:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).TOP,
                    xAlignment: isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT,
                    yAxisPx: midpointHeight,
                    xAxisPx: flushWithEdge,
                    rotation: isLTR ? horizontalRotation : -1 * horizontalRotation,
                    skew: isLTR ? -1 * skewDeg : skewDeg,
                    xTransformOrigin: isLTR ? flushWithEdge : tooltipWidth,
                    yTransformOrigin: midpointHeight,
                    caretCorners: isLTR ? bottomRightTopLeftBorderRadius : bottomLeftTopRightBorderRadius
                };
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BOTTOM_SIDE_END:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).BOTTOM,
                    xAlignment: isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT,
                    yAxisPx: indentedFromEdge,
                    xAxisPx: flushWithEdge,
                    rotation: isLTR ? -1 * horizontalRotation : horizontalRotation,
                    skew: isLTR ? skewDeg : -1 * skewDeg,
                    xTransformOrigin: isLTR ? flushWithEdge : tooltipWidth,
                    yTransformOrigin: indentedFromHeight,
                    caretCorners: isLTR ? bottomLeftTopRightBorderRadius : bottomRightTopLeftBorderRadius
                };
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).TOP_SIDE_START:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).TOP,
                    xAlignment: isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT,
                    yAxisPx: indentedFromEdge,
                    xAxisPx: flushWithEdge,
                    rotation: isLTR ? -1 * horizontalRotation : horizontalRotation,
                    skew: isLTR ? skewDeg : -1 * skewDeg,
                    xTransformOrigin: isLTR ? tooltipWidth : flushWithEdge,
                    yTransformOrigin: indentedFromEdge,
                    caretCorners: isLTR ? bottomLeftTopRightBorderRadius : bottomRightTopLeftBorderRadius
                };
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).CENTER_SIDE_START:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).TOP,
                    xAlignment: isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT,
                    yAxisPx: midpointHeight,
                    xAxisPx: flushWithEdge,
                    rotation: isLTR ? -1 * horizontalRotation : horizontalRotation,
                    skew: isLTR ? skewDeg : -1 * skewDeg,
                    xTransformOrigin: isLTR ? tooltipWidth : flushWithEdge,
                    yTransformOrigin: midpointHeight,
                    caretCorners: isLTR ? bottomLeftTopRightBorderRadius : bottomRightTopLeftBorderRadius
                };
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).BOTTOM_SIDE_START:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).BOTTOM,
                    xAlignment: isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT,
                    yAxisPx: indentedFromEdge,
                    xAxisPx: flushWithEdge,
                    rotation: isLTR ? horizontalRotation : -1 * horizontalRotation,
                    skew: isLTR ? -1 * skewDeg : skewDeg,
                    xTransformOrigin: isLTR ? tooltipWidth : flushWithEdge,
                    yTransformOrigin: indentedFromHeight,
                    caretCorners: isLTR ? bottomRightTopLeftBorderRadius : bottomLeftTopRightBorderRadius
                };
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).ABOVE_CENTER:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).BOTTOM,
                    xAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT,
                    yAxisPx: flushWithEdge,
                    xAxisPx: midpointWidth,
                    rotation: verticalRotation,
                    skew: skewDeg,
                    xTransformOrigin: midpointWidth,
                    yTransformOrigin: tooltipHeight,
                    caretCorners: bottomLeftTopRightBorderRadius
                };
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).ABOVE_END:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).BOTTOM,
                    xAlignment: isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT,
                    yAxisPx: flushWithEdge,
                    xAxisPx: indentedFromEdge,
                    rotation: isLTR ? -1 * verticalRotation : verticalRotation,
                    skew: isLTR ? -1 * skewDeg : skewDeg,
                    xTransformOrigin: isLTR ? indentedFromWidth : indentedFromEdge,
                    yTransformOrigin: tooltipHeight,
                    caretCorners: isLTR ? bottomRightTopLeftBorderRadius : bottomLeftTopRightBorderRadius
                };
            default:
            case (0, $5e84edd0d370f6cc$export$c932156b3d020a8f).ABOVE_START:
                return {
                    yAlignment: (0, $5e84edd0d370f6cc$export$21c51bc433c16634).BOTTOM,
                    xAlignment: isLTR ? (0, $5e84edd0d370f6cc$export$21c51bc433c16634).LEFT : (0, $5e84edd0d370f6cc$export$21c51bc433c16634).RIGHT,
                    yAxisPx: flushWithEdge,
                    xAxisPx: indentedFromEdge,
                    rotation: isLTR ? verticalRotation : -1 * verticalRotation,
                    skew: isLTR ? skewDeg : -1 * skewDeg,
                    xTransformOrigin: isLTR ? indentedFromEdge : indentedFromWidth,
                    yTransformOrigin: tooltipHeight,
                    caretCorners: isLTR ? bottomLeftTopRightBorderRadius : bottomRightTopLeftBorderRadius
                };
        }
    };
    MDCTooltipFoundation.prototype.clearShowTimeout = function() {
        if (this.showTimeout) {
            clearTimeout(this.showTimeout);
            this.showTimeout = null;
        }
    };
    MDCTooltipFoundation.prototype.clearHideTimeout = function() {
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }
    };
    /**
     * Method that allows user to specify additional elements that should have a
     * scroll event listener attached to it. This should be used in instances
     * where the anchor element is placed inside a scrollable container, and will
     * ensure that the tooltip will stay attached to the anchor on scroll.
     */ MDCTooltipFoundation.prototype.attachScrollHandler = function(addEventListenerFn) {
        var _this = this;
        this.addAncestorScrollEventListeners.push(function() {
            addEventListenerFn('scroll', _this.windowScrollHandler);
        });
    };
    /**
     * Must be used in conjunction with #attachScrollHandler. Removes the scroll
     * event handler from elements on the page.
     */ MDCTooltipFoundation.prototype.removeScrollHandler = function(removeEventHandlerFn) {
        var _this = this;
        this.removeAncestorScrollEventListeners.push(function() {
            removeEventHandlerFn('scroll', _this.windowScrollHandler);
        });
    };
    MDCTooltipFoundation.prototype.destroy = function() {
        var e_8, _a;
        if (this.frameId) {
            cancelAnimationFrame(this.frameId);
            this.frameId = null;
        }
        this.clearHideTimeout();
        this.clearShowTimeout();
        this.adapter.removeClass($778570533f5b6055$var$SHOWN);
        this.adapter.removeClass($778570533f5b6055$var$SHOWING_TRANSITION);
        this.adapter.removeClass($778570533f5b6055$var$SHOWING);
        this.adapter.removeClass($778570533f5b6055$var$HIDE);
        this.adapter.removeClass($778570533f5b6055$var$HIDE_TRANSITION);
        if (this.richTooltip) this.adapter.deregisterEventHandler('focusout', this.richTooltipFocusOutHandler);
        if (!this.persistentTooltip) {
            this.adapter.deregisterEventHandler('mouseenter', this.tooltipMouseEnterHandler);
            this.adapter.deregisterEventHandler('mouseleave', this.tooltipMouseLeaveHandler);
        }
        this.adapter.deregisterAnchorEventHandler('blur', this.anchorBlurHandler);
        this.adapter.deregisterDocumentEventHandler('click', this.documentClickHandler);
        this.adapter.deregisterDocumentEventHandler('keydown', this.documentKeydownHandler);
        this.adapter.deregisterWindowEventHandler('scroll', this.windowScrollHandler);
        this.adapter.deregisterWindowEventHandler('resize', this.windowResizeHandler);
        try {
            for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(this.removeAncestorScrollEventListeners), _c = _b.next(); !_c.done; _c = _b.next()){
                var fn = _c.value;
                fn();
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        this.animFrame.cancelAll();
    };
    return MDCTooltipFoundation;
}((0, $d29cc2d0f1026d01$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$778570533f5b6055$export$2e2bcd8739ae039 = $778570533f5b6055$export$ad52ca8d63569c37;


var $6208747c4409e6c0$export$31963e96a9940462 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MDCTooltip, _super);
    function MDCTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MDCTooltip.attachTo = function(root) {
        return new MDCTooltip(root);
    };
    MDCTooltip.prototype.initialize = function() {
        var tooltipId = this.root.getAttribute('id');
        if (!tooltipId) throw new Error('MDCTooltip: Tooltip component must have an id.');
        var anchorElem = document.querySelector("[data-tooltip-id=\"" + tooltipId + "\"]") || document.querySelector("[aria-describedby=\"" + tooltipId + "\"]");
        if (!anchorElem) throw new Error('MDCTooltip: Tooltip component requires an anchor element annotated with [aria-describedby] or [data-tooltip-id].');
        this.anchorElem = anchorElem;
    };
    MDCTooltip.prototype.initialSyncWithDOM = function() {
        var _this = this;
        this.isTooltipRich = this.foundation.isRich();
        this.isTooltipPersistent = this.foundation.isPersistent();
        this.handleMouseEnter = function() {
            _this.foundation.handleAnchorMouseEnter();
        };
        this.handleFocus = function(evt) {
            _this.foundation.handleAnchorFocus(evt);
        };
        this.handleMouseLeave = function() {
            _this.foundation.handleAnchorMouseLeave();
        };
        this.handleTransitionEnd = function() {
            _this.foundation.handleTransitionEnd();
        };
        this.handleClick = function() {
            _this.foundation.handleAnchorClick();
        };
        this.handleTouchstart = function() {
            _this.foundation.handleAnchorTouchstart();
        };
        this.handleTouchend = function() {
            _this.foundation.handleAnchorTouchend();
        };
        if (this.isTooltipRich && this.isTooltipPersistent) this.anchorElem.addEventListener('click', this.handleClick);
        else {
            this.anchorElem.addEventListener('mouseenter', this.handleMouseEnter);
            // TODO(b/157075286): Listening for a 'focus' event is too broad.
            this.anchorElem.addEventListener('focus', this.handleFocus);
            this.anchorElem.addEventListener('mouseleave', this.handleMouseLeave);
            this.anchorElem.addEventListener('touchstart', this.handleTouchstart);
            this.anchorElem.addEventListener('touchend', this.handleTouchend);
        }
        this.listen('transitionend', this.handleTransitionEnd);
    };
    MDCTooltip.prototype.destroy = function() {
        if (this.anchorElem) {
            if (this.isTooltipRich && this.isTooltipPersistent) this.anchorElem.removeEventListener('click', this.handleClick);
            else {
                this.anchorElem.removeEventListener('mouseenter', this.handleMouseEnter);
                this.anchorElem.removeEventListener('focus', this.handleFocus);
                this.anchorElem.removeEventListener('mouseleave', this.handleMouseLeave);
                this.anchorElem.removeEventListener('touchstart', this.handleTouchstart);
                this.anchorElem.removeEventListener('touchend', this.handleTouchend);
            }
        }
        this.unlisten('transitionend', this.handleTransitionEnd);
        _super.prototype.destroy.call(this);
    };
    MDCTooltip.prototype.setTooltipPosition = function(position) {
        this.foundation.setTooltipPosition(position);
    };
    MDCTooltip.prototype.setAnchorBoundaryType = function(type) {
        this.foundation.setAnchorBoundaryType(type);
    };
    MDCTooltip.prototype.setShowDelay = function(delayMs) {
        this.foundation.setShowDelay(delayMs);
    };
    MDCTooltip.prototype.setHideDelay = function(delayMs) {
        this.foundation.setHideDelay(delayMs);
    };
    MDCTooltip.prototype.hide = function() {
        this.foundation.hide();
    };
    MDCTooltip.prototype.isShown = function() {
        return this.foundation.isShown();
    };
    /**
     * Method that allows user to specify additional elements that should have a
     * scroll event listener attached to it. This should be used in instances
     * where the anchor element is placed inside a scrollable container (that is
     * not the body element), and will ensure that the tooltip will stay attached
     * to the anchor on scroll.
     */ MDCTooltip.prototype.attachScrollHandler = function(addEventListenerFn) {
        this.foundation.attachScrollHandler(addEventListenerFn);
    };
    /**
     * Must be used in conjunction with #attachScrollHandler. Removes the scroll
     * event handler from elements on the page.
     */ MDCTooltip.prototype.removeScrollHandler = function(removeEventHandlerFn) {
        this.foundation.removeScrollHandler(removeEventHandlerFn);
    };
    MDCTooltip.prototype.getDefaultFoundation = function() {
        var _this = this;
        var adapter = {
            getAttribute: function(attr) {
                return _this.root.getAttribute(attr);
            },
            setAttribute: function(attr, value) {
                _this.root.setAttribute(attr, value);
            },
            removeAttribute: function(attr) {
                _this.root.removeAttribute(attr);
            },
            addClass: function(className) {
                _this.root.classList.add(className);
            },
            hasClass: function(className) {
                return _this.root.classList.contains(className);
            },
            removeClass: function(className) {
                _this.root.classList.remove(className);
            },
            getComputedStyleProperty: function(propertyName) {
                return window.getComputedStyle(_this.root).getPropertyValue(propertyName);
            },
            setStyleProperty: function(propertyName, value) {
                _this.root.style.setProperty(propertyName, value);
            },
            setSurfaceAnimationStyleProperty: function(propertyName, value) {
                var surface = _this.root.querySelector("." + (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).SURFACE_ANIMATION);
                surface === null || surface === void 0 || surface.style.setProperty(propertyName, value);
            },
            getViewportWidth: function() {
                return window.innerWidth;
            },
            getViewportHeight: function() {
                return window.innerHeight;
            },
            getTooltipSize: function() {
                return {
                    width: _this.root.offsetWidth,
                    height: _this.root.offsetHeight
                };
            },
            getAnchorBoundingRect: function() {
                return _this.anchorElem ? _this.anchorElem.getBoundingClientRect() : null;
            },
            getParentBoundingRect: function() {
                var _a, _b;
                return (_b = (_a = _this.root.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : null;
            },
            getAnchorAttribute: function(attr) {
                return _this.anchorElem ? _this.anchorElem.getAttribute(attr) : null;
            },
            setAnchorAttribute: function(attr, value) {
                var _a;
                (_a = _this.anchorElem) === null || _a === void 0 || _a.setAttribute(attr, value);
            },
            isRTL: function() {
                return getComputedStyle(_this.root).direction === 'rtl';
            },
            anchorContainsElement: function(element) {
                var _a;
                return !!((_a = _this.anchorElem) === null || _a === void 0 ? void 0 : _a.contains(element));
            },
            tooltipContainsElement: function(element) {
                return _this.root.contains(element);
            },
            focusAnchorElement: function() {
                var _a;
                (_a = _this.anchorElem) === null || _a === void 0 || _a.focus();
            },
            registerEventHandler: function(evt, handler) {
                if (_this.root instanceof HTMLElement) _this.root.addEventListener(evt, handler);
            },
            deregisterEventHandler: function(evt, handler) {
                if (_this.root instanceof HTMLElement) _this.root.removeEventListener(evt, handler);
            },
            registerAnchorEventHandler: function(evt, handler) {
                var _a;
                (_a = _this.anchorElem) === null || _a === void 0 || _a.addEventListener(evt, handler);
            },
            deregisterAnchorEventHandler: function(evt, handler) {
                var _a;
                (_a = _this.anchorElem) === null || _a === void 0 || _a.removeEventListener(evt, handler);
            },
            registerDocumentEventHandler: function(evt, handler) {
                document.body.addEventListener(evt, handler);
            },
            deregisterDocumentEventHandler: function(evt, handler) {
                document.body.removeEventListener(evt, handler);
            },
            registerWindowEventHandler: function(evt, handler) {
                window.addEventListener(evt, handler);
            },
            deregisterWindowEventHandler: function(evt, handler) {
                window.removeEventListener(evt, handler);
            },
            notifyHidden: function() {
                _this.emit((0, $5e84edd0d370f6cc$export$4bf9923669ad6c63).HIDDEN, {});
            },
            getTooltipCaretBoundingRect: function() {
                var caret = _this.root.querySelector("." + (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).TOOLTIP_CARET_TOP);
                if (!caret) return null;
                return caret.getBoundingClientRect();
            },
            setTooltipCaretStyle: function(propertyName, value) {
                var topCaret = _this.root.querySelector("." + (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).TOOLTIP_CARET_TOP);
                var bottomCaret = _this.root.querySelector("." + (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).TOOLTIP_CARET_BOTTOM);
                if (!topCaret || !bottomCaret) return;
                topCaret.style.setProperty(propertyName, value);
                bottomCaret.style.setProperty(propertyName, value);
            },
            clearTooltipCaretStyles: function() {
                var topCaret = _this.root.querySelector("." + (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).TOOLTIP_CARET_TOP);
                var bottomCaret = _this.root.querySelector("." + (0, $5e84edd0d370f6cc$export$19467ce65cc4f055).TOOLTIP_CARET_BOTTOM);
                if (!topCaret || !bottomCaret) return;
                topCaret.removeAttribute('style');
                bottomCaret.removeAttribute('style');
            },
            getActiveElement: function() {
                return document.activeElement;
            }
        };
        //tslint:enable:object-literal-sort-keys
        return new (0, $778570533f5b6055$export$ad52ca8d63569c37)(adapter);
    };
    return MDCTooltip;
}((0, $0a13a1859770d71d$export$c3670872e5a4af8e));


const $60e07ebc83e245dc$var$GLOBAL_REGION_KEY = "global";
const $60e07ebc83e245dc$var$PING_TEST_RUNNING_STATUS = "running";
const $60e07ebc83e245dc$var$PING_TEST_STOPPED_STATUS = "stopped";
const $60e07ebc83e245dc$var$INITIAL_ITERATIONS = 10;
const $60e07ebc83e245dc$var$btnCtrl = document.getElementById("stopstart");
/**
 * The `regions` obj is of the following format:
 * {
 *  "us-east1": {
 *    "key": "",
 *    "label": "",
 *    "pingUrl": "",
 *    "latencies": [],
 *    "median": ""
 *  }
 * }
 */ const $60e07ebc83e245dc$var$regions = {};
const $60e07ebc83e245dc$var$results = []; // this will always be sorted according to sortKey and sortDir
let $60e07ebc83e245dc$var$pingTestStatus = $60e07ebc83e245dc$var$PING_TEST_RUNNING_STATUS;
let $60e07ebc83e245dc$var$fastestRegionVisible = false;
let $60e07ebc83e245dc$var$fastestRegion = null;
let $60e07ebc83e245dc$var$globalRegionProxy = "";
let $60e07ebc83e245dc$var$sortKey = "median"; // column to sort the data with
let $60e07ebc83e245dc$var$sortDir = "ascending"; // sorting direction(ascending/descending)
/**
 * Fetches the endpoints for different Cloud Run regions.
 * We will later send a request to these endpoints and measure the latency.
 */ function $60e07ebc83e245dc$var$getEndpoints() {
    fetch("/api/endpoints").then(function(resp) {
        return resp.json();
    }).then(function(endpoints) {
        for (const zone of Object.values(endpoints)){
            const gcpZone = {
                key: zone.Region,
                label: zone.RegionName,
                pingUrl: zone.URL + "/api/ping",
                latencies: [],
                median: ""
            };
            $60e07ebc83e245dc$var$regions[gcpZone.key] = gcpZone;
        }
        // once we're done fetching all endpoints, let's start pinging
        $60e07ebc83e245dc$var$pingAllRegions($60e07ebc83e245dc$var$INITIAL_ITERATIONS);
    });
}
/**
 * Ping all regions to fetch their latency
 *
 * @param {number} iter
 */ async function $60e07ebc83e245dc$var$pingAllRegions(iter) {
    const regionsArr = Object.values($60e07ebc83e245dc$var$regions);
    for(let i = 0; i < iter; i++){
        for (const region of regionsArr){
            // Takes care of the stopped button
            if ($60e07ebc83e245dc$var$pingTestStatus === $60e07ebc83e245dc$var$PING_TEST_STOPPED_STATUS) break;
            const latency = await $60e07ebc83e245dc$var$pingSingleRegion(region.key);
            // add the latency to the array of latencies
            // from where we can compute the median and populate the table
            $60e07ebc83e245dc$var$regions[region.key]["latencies"].push(latency);
            $60e07ebc83e245dc$var$regions[region.key]["median"] = $60e07ebc83e245dc$var$getMedian($60e07ebc83e245dc$var$regions[region.key]["latencies"]);
            // update fastest region
            if ($60e07ebc83e245dc$var$fastestRegion === null || $60e07ebc83e245dc$var$regions[region.key]["median"] < $60e07ebc83e245dc$var$regions[$60e07ebc83e245dc$var$fastestRegion]["median"]) $60e07ebc83e245dc$var$fastestRegion = region.key;
            $60e07ebc83e245dc$var$addResult(region.key);
            $60e07ebc83e245dc$var$updateList();
        }
        // start displaying the fastest region after at least 1 iteration is over.
        // subsequent calls to this won't change anything
        $60e07ebc83e245dc$var$displayFastest(true);
    }
    // when all the region latencies have been fetched, let's update our status flag
    $60e07ebc83e245dc$var$updatePingTestState($60e07ebc83e245dc$var$PING_TEST_STOPPED_STATUS);
}
/**
 * Computes the ping time for a single GCP region
 * @param {string} regionKey The key of the GCP region, ex: us-east1
 * @return {Promise} Promise
 */ function $60e07ebc83e245dc$var$pingSingleRegion(regionKey) {
    return new Promise((resolve)=>{
        const gcpZone = $60e07ebc83e245dc$var$regions[regionKey];
        const start = new Date().getTime();
        fetch(gcpZone.pingUrl, {
            cache: "no-cache"
        }).then(async (resp)=>{
            const latency = new Date().getTime() - start;
            // if we just pinged the global region, the response should contain
            // the region that the Global Load Balancer uses to route the traffic.
            if (regionKey === $60e07ebc83e245dc$var$GLOBAL_REGION_KEY) resp.text().then((val)=>{
                $60e07ebc83e245dc$var$globalRegionProxy = val.trim();
            });
            resolve(latency);
        });
    });
}
/**
 * Function to update the current status of pinging
 * @param {string} status
 */ function $60e07ebc83e245dc$var$updatePingTestState(status) {
    $60e07ebc83e245dc$var$pingTestStatus = status;
    if (status === $60e07ebc83e245dc$var$PING_TEST_RUNNING_STATUS) $60e07ebc83e245dc$var$btnCtrl.classList.add("running");
    else if (status === $60e07ebc83e245dc$var$PING_TEST_STOPPED_STATUS) $60e07ebc83e245dc$var$btnCtrl.classList.remove("running");
}
/**
 * Updates the list view with the result set of regions and their latencies.
 */ function $60e07ebc83e245dc$var$updateList() {
    let html = "";
    let cls = "";
    let regionKey = "";
    for(let i = 0; i < $60e07ebc83e245dc$var$results.length; i++){
        cls = $60e07ebc83e245dc$var$results[i] === $60e07ebc83e245dc$var$fastestRegion && $60e07ebc83e245dc$var$fastestRegionVisible ? "fastest-region" : "";
        regionKey = $60e07ebc83e245dc$var$getDisplayedRegionKey($60e07ebc83e245dc$var$results[i]);
        html += '<tr class="mdc-data-table__row ' + cls + '"><td class="mdc-data-table__cell regiondesc">' + $60e07ebc83e245dc$var$regions[$60e07ebc83e245dc$var$results[i]]["label"] + '<div class="embedded-region d-none d-md-block">' + regionKey + "</div>" + '</td><td class="mdc-data-table__cell region d-md-none">' + regionKey + "</td>" + '<td class="mdc-data-table__cell result"><div>' + $60e07ebc83e245dc$var$regions[$60e07ebc83e245dc$var$results[i]]["median"] + " ms</div></td></tr>";
    }
    document.getElementsByTagName("tbody")[0].innerHTML = html;
}
/**
 * Helper function to return median from a given array
 * @param {*} arr Array of latencies
 * @return {*}
 */ function $60e07ebc83e245dc$var$getMedian(arr) {
    if (arr.length == 0) return 0;
    const copy = arr.slice(0);
    copy.sort();
    return copy[Math.floor(copy.length / 2)];
}
/**
 * Helper that adds the regionKey to it's proper position keeping the results array sorted
 * This means we don't always have to sort the whole results array
 * TODO: Try and use an ordered map here to simply this
 * @param {string} regionKey
 */ function $60e07ebc83e245dc$var$addResult(regionKey) {
    if (!$60e07ebc83e245dc$var$results.length) {
        $60e07ebc83e245dc$var$results.push(regionKey);
        return;
    }
    // remove any current values with the same regionKey
    for(let i = 0; i < $60e07ebc83e245dc$var$results.length; i++)if ($60e07ebc83e245dc$var$results[i] === regionKey) {
        $60e07ebc83e245dc$var$results.splice(i, 1);
        break;
    }
    // TODO: Probably use Binary search here to merge the following 2 blocks
    // if new region is at 0th position
    if ($60e07ebc83e245dc$var$compareTwoRegions(regionKey, $60e07ebc83e245dc$var$results[0]) < 0) {
        $60e07ebc83e245dc$var$results.unshift(regionKey);
        return;
    } else if ($60e07ebc83e245dc$var$compareTwoRegions(regionKey, $60e07ebc83e245dc$var$results[$60e07ebc83e245dc$var$results.length - 1]) > 0) {
        $60e07ebc83e245dc$var$results.push(regionKey);
        return;
    }
    // add the region to it's proper position
    for(let i = 0; i < $60e07ebc83e245dc$var$results.length - 1; i++)// if the region to be added is b/w i and i+1 elements
    if ($60e07ebc83e245dc$var$compareTwoRegions(regionKey, $60e07ebc83e245dc$var$results[i]) >= 0 && $60e07ebc83e245dc$var$compareTwoRegions(regionKey, $60e07ebc83e245dc$var$results[i + 1]) < 0) {
        $60e07ebc83e245dc$var$results.splice(i + 1, 0, regionKey);
        return;
    }
}
/**
 * Sets the visiblity for the fastest region indicator on the list(the green cell)
 * @param {bool} isVisible Indicator to toggle visibility for the fastest region indicator
 */ function $60e07ebc83e245dc$var$displayFastest(isVisible) {
    $60e07ebc83e245dc$var$fastestRegionVisible = true;
    $60e07ebc83e245dc$var$updateList();
}
/**
 * Helper function to deduce the region to be displayed in the list
 * @param {string} regionKey
 * @return {string}
 */ function $60e07ebc83e245dc$var$getDisplayedRegionKey(regionKey) {
    // if the region is not global, return it as it is.
    if (regionKey !== $60e07ebc83e245dc$var$GLOBAL_REGION_KEY) return regionKey;
    // if the region is global and we have received the region that is used by the Gloabl Load Balancer
    // we display that
    if ($60e07ebc83e245dc$var$globalRegionProxy.length > 0) return "<em>\u2192" + $60e07ebc83e245dc$var$globalRegionProxy + "</em>";
    // if the region is global and we don't have the routing region, we show "gloabl"
    return "global";
}
/**
 * Sort the table data based on a column(defined in sortKey) and direction(sortDir)
 */ function $60e07ebc83e245dc$var$sortResults() {
    $60e07ebc83e245dc$var$results.sort($60e07ebc83e245dc$var$compareTwoRegions);
}
/**
 * Function to compare order of 2 regions based on the current sort options
 * @param {string} a Region key for first region to be compared
 * @param {string} b Region key for second region to be compared
 * @return {int}
 */ function $60e07ebc83e245dc$var$compareTwoRegions(a, b) {
    const multiplier = $60e07ebc83e245dc$var$sortDir === "ascending" ? 1 : -1;
    a = $60e07ebc83e245dc$var$regions[a][$60e07ebc83e245dc$var$sortKey];
    b = $60e07ebc83e245dc$var$regions[b][$60e07ebc83e245dc$var$sortKey];
    if (a == b) return 0;
    return multiplier * (a > b ? 1 : -1);
}
/**
 * Event listener for the button to start/stop the pinging
 */ $60e07ebc83e245dc$var$btnCtrl.addEventListener("click", function() {
    const newStatus = $60e07ebc83e245dc$var$pingTestStatus === $60e07ebc83e245dc$var$PING_TEST_STOPPED_STATUS ? $60e07ebc83e245dc$var$PING_TEST_RUNNING_STATUS : $60e07ebc83e245dc$var$PING_TEST_STOPPED_STATUS;
    $60e07ebc83e245dc$var$updatePingTestState(newStatus);
    if (newStatus === $60e07ebc83e245dc$var$PING_TEST_RUNNING_STATUS) $60e07ebc83e245dc$var$pingAllRegions(1);
});
// start the process by fetching the endpoints
$60e07ebc83e245dc$var$getEndpoints();
window.onload = function() {
    // How it works btn
    const dialog = new (0, $38d6c657ee62cba7$export$6808244b173e4b98)(document.querySelector(".mdc-dialog"));
    document.querySelector(".how-it-works-link").addEventListener("click", function(e) {
        e.preventDefault();
        dialog.open();
    });
    // init data-table
    new (0, $369a0c7b5a754e20$export$240748bfd28d4d90)(document.querySelector(".mdc-data-table"));
    document.querySelector(".mdc-data-table").addEventListener("MDCDataTable:sorted", function(data) {
        const detail = data.detail;
        // update the sorting options according to the requested values
        $60e07ebc83e245dc$var$sortKey = detail.columnId, $60e07ebc83e245dc$var$sortDir = detail.sortValue;
        $60e07ebc83e245dc$var$sortResults();
        $60e07ebc83e245dc$var$updateList();
    });
    // init tooltips
    [].map.call(document.querySelectorAll(".mdc-tooltip"), function(el) {
        return new (0, $6208747c4409e6c0$export$31963e96a9940462)(el);
    });
};


//# sourceMappingURL=web.6bbef960.js.map
